"use strict";
module.exports = {
    Mat: {
        name: 'Mat',
        localizedName: 'Mat',
        desciption: '',
        icon: 'https://assets.flaivy.com/5.svg',
        VAT: 12,
        immutableFields: {
            alcoholPercentage: null,
            shelfLife: null,
            recycleType: null,
            appearance: null,
            scent: null,
            taste: null,
            grapes: null,
            seal: null,
            vintage: null,
            systembolagetArticleNumber: null,
            systembolagetSalesPrice: null,
            knNumber: null,
            exciseProductCode: null,
            alcoholTaxPaid: null,
        },
        alcoholFreeBookKeepingAccounts: {
            Commission: {
                purchaseAccount: 4005,
                salesAccount: 3005,
            },
            OwnedByDrycks: {
                purchaseAccount: 4004,
                salesAccount: 3004,
            },
            DropShipping: {
                purchaseAccount: 4005,
                salesAccount: 3005,
            },
            StandAlone: {
                purchaseAccount: 4005,
                salesAccount: 3005,
            },
        },
        alcoholTaxClasses: ['Alcoholfree'],
        children: {
            'Bröd, bakverk & dessert': {
                name: 'Bröd, bakverk & dessert',
                localizedName: 'Bröd, bakverk & dessert',
                desciption: '',
                icon: 'https://assets.flaivy.com/bread.svg',
                immutableFields: {
                    recycleType: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    systembolagetArticleNumber: null,
                    systembolagetSalesPrice: null,
                    knNumber: null,
                    exciseProductCode: null,
                    alcoholTaxPaid: null,
                    isFoam: null,
                    isCoated: null,
                    isFudge: null,
                    isGelatinous: null,
                    isHardCandy: null,
                },
                children: {
                    'Dessert, glass & tillbehör': {
                        name: 'Dessert, glass & tillbehör',
                        localizedName: 'Dessert, glass & tillbehör',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/ice cream, bowl, cherry, dessert, sweets, food.svg',
                        immutableFields: {
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                        },
                        children: {
                            Dessert: {
                                name: 'Dessert',
                                localizedName: 'Dessert',
                                desciption: '',
                            },
                            Glass: {
                                name: 'Glass',
                                localizedName: 'Glass',
                                desciption: '',
                            },
                            Glasstillbehör: {
                                name: 'Glasstillbehör',
                                localizedName: 'Glasstillbehör',
                                desciption: '',
                            },
                            Maräng: {
                                name: 'Maräng',
                                localizedName: 'Maräng',
                                desciption: '',
                                immutableFields: {
                                    isLiquorice: null,
                                },
                            },
                            'Puréer, bär mm': {
                                name: 'Puréer, bär mm',
                                localizedName: 'Puréer, bär mm',
                                desciption: '',
                                immutableFields: {
                                    isLiquorice: null,
                                },
                            },
                        },
                    },
                    Fastfoodbröd: {
                        name: 'Fastfoodbröd',
                        localizedName: 'Fastfoodbröd',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/hotdog, sandwich, sausage, food, meal, fast food, junk food.svg',
                        immutableFields: {
                            volume: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                        },
                        children: {
                            Hamburgerbröd: {
                                name: 'Hamburgerbröd',
                                localizedName: 'Hamburgerbröd',
                                desciption: '',
                            },
                            Korvbröd: {
                                name: 'Korvbröd',
                                localizedName: 'Korvbröd',
                                desciption: '',
                            },
                            Pitabröd: {
                                name: 'Pitabröd',
                                localizedName: 'Pitabröd',
                                desciption: '',
                            },
                            Pizza: {
                                name: 'Pizza',
                                localizedName: 'Pizza',
                                desciption: '',
                            },
                            'Övrigt fastfoodbröd': {
                                name: 'Övrigt fastfoodbröd',
                                localizedName: 'Övrigt fastfoodbröd',
                                desciption: '',
                            },
                        },
                    },
                    'Kaffebröd & kakor mm': {
                        name: 'Kaffebröd & kakor mm',
                        localizedName: 'Kaffebröd & kakor mm',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/doughnut, donut, pastry, bakery, food, sweets.svg',
                        immutableFields: {
                            volume: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                        },
                        children: {
                            Brownie: {
                                name: 'Brownie',
                                localizedName: 'Brownie',
                                desciption: '',
                            },
                            Kaffebröd: {
                                name: 'Kaffebröd',
                                localizedName: 'Kaffebröd',
                                desciption: '',
                            },
                            Kakor: {
                                name: 'Kakor',
                                localizedName: 'Kakor',
                                desciption: '',
                            },
                            Kondisbit: {
                                name: 'Kondisbit',
                                localizedName: 'Kondisbit',
                                desciption: '',
                            },
                            Längd: {
                                name: 'Längd',
                                localizedName: 'Längd',
                                desciption: '',
                            },
                            'Söta kex': {
                                name: 'Söta kex',
                                localizedName: 'Söta kex',
                                desciption: '',
                            },
                            'Övrigt kaffebröd & kakor mm': {
                                name: 'Övrigt kaffebröd & kakor mm',
                                localizedName: 'Övrigt kaffebröd & kakor mm',
                                desciption: '',
                            },
                        },
                    },
                    'Knäckebröd & skorpor mm': {
                        name: 'Knäckebröd & skorpor mm',
                        localizedName: 'Knäckebröd & skorpor mm',
                        desciption: '',
                        immutableFields: {
                            volume: null,
                            isFrozen: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                        },
                        children: {
                            Grissini: {
                                name: 'Grissini',
                                localizedName: 'Grissini',
                                desciption: '',
                            },
                            Knäckebröd: {
                                name: 'Knäckebröd',
                                localizedName: 'Knäckebröd',
                                desciption: '',
                            },
                            Krutong: {
                                name: 'Krutong',
                                localizedName: 'Krutong',
                                desciption: '',
                            },
                            'Skorpor & kex': {
                                name: 'Skorpor & kex',
                                localizedName: 'Skorpor & kex',
                                desciption: '',
                            },
                            Tunnbröd: {
                                name: 'Tunnbröd',
                                localizedName: 'Tunnbröd',
                                desciption: '',
                            },
                            'Övrigt knäckebröd & skorpor mm': {
                                name: 'Övrigt knäckebröd & skorpor mm',
                                localizedName: 'Övrigt knäckebröd & skorpor mm',
                                desciption: '',
                            },
                        },
                    },
                    Matbröd: {
                        name: 'Matbröd',
                        localizedName: 'Matbröd',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/baguette.svg',
                        immutableFields: {
                            volume: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                        },
                        children: {
                            Bagel: {
                                name: 'Bagel',
                                localizedName: 'Bagel',
                                desciption: '',
                            },
                            Baguette: {
                                name: 'Baguette',
                                localizedName: 'Baguette',
                                desciption: '',
                            },
                            Brioche: {
                                name: 'Brioche',
                                localizedName: 'Brioche',
                                desciption: '',
                            },
                            Brytbröd: {
                                name: 'Brytbröd',
                                localizedName: 'Brytbröd',
                                desciption: '',
                            },
                            Ciabatta: {
                                name: 'Ciabatta',
                                localizedName: 'Ciabatta',
                                desciption: '',
                            },
                            Focaccia: {
                                name: 'Focaccia',
                                localizedName: 'Focaccia',
                                desciption: '',
                            },
                            Fralla: {
                                name: 'Fralla',
                                localizedName: 'Fralla',
                                desciption: '',
                            },
                            Frukostbröd: {
                                name: 'Frukostbröd',
                                localizedName: 'Frukostbröd',
                                desciption: '',
                            },
                            Kakbröd: {
                                name: 'Kakbröd',
                                localizedName: 'Kakbröd',
                                desciption: '',
                            },
                            Kuvertbröd: {
                                name: 'Kuvertbröd',
                                localizedName: 'Kuvertbröd',
                                desciption: '',
                            },
                            Lantbröd: {
                                name: 'Lantbröd',
                                localizedName: 'Lantbröd',
                                desciption: '',
                            },
                            Limpa: {
                                name: 'Limpa',
                                localizedName: 'Limpa',
                                desciption: '',
                            },
                            Matmuffins: {
                                name: 'Matmuffins',
                                localizedName: 'Matmuffins',
                                desciption: '',
                            },
                            Panini: {
                                name: 'Panini',
                                localizedName: 'Panini',
                                desciption: '',
                            },
                            Pumpernickel: {
                                name: 'Pumpernickel',
                                localizedName: 'Pumpernickel',
                                desciption: '',
                            },
                            Scones: {
                                name: 'Scones',
                                localizedName: 'Scones',
                                desciption: '',
                            },
                            'Övrigt matbröd': {
                                name: 'Övrigt matbröd',
                                localizedName: 'Övrigt matbröd',
                                desciption: '',
                            },
                        },
                    },
                    'Paj, tårtor & cheesecakes': {
                        name: 'Paj, tårtor & cheesecakes',
                        localizedName: 'Paj, tårtor & cheesecakes',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/pie, food, pastry, meal, fresh, healthy.svg',
                        immutableFields: {
                            volume: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                        },
                        children: {
                            Cheesecake: {
                                name: 'Cheesecake',
                                localizedName: 'Cheesecake',
                                desciption: '',
                            },
                            Paj: {
                                name: 'Paj',
                                localizedName: 'Paj',
                                desciption: '',
                            },
                            Tårtor: {
                                name: 'Tårtor',
                                localizedName: 'Tårtor',
                                desciption: '',
                            },
                        },
                    },
                    'Tårt- &smörgåsbottnar mm': {
                        name: 'Tårt- &smörgåsbottnar mm',
                        localizedName: 'Tårt- &smörgåsbottnar mm',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/cake-slice.svg',
                        immutableFields: {
                            volume: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                        },
                        children: {
                            Anslagsbotten: {
                                name: 'Anslagsbotten',
                                localizedName: 'Anslagsbotten',
                                desciption: '',
                            },
                            Filodeg: {
                                name: 'Filodeg',
                                localizedName: 'Filodeg',
                                desciption: '',
                            },
                            Krustad: {
                                name: 'Krustad',
                                localizedName: 'Krustad',
                                desciption: '',
                            },
                            Landgångsbröd: {
                                name: 'Landgångsbröd',
                                localizedName: 'Landgångsbröd',
                                desciption: '',
                            },
                            Marängbotten: {
                                name: 'Marängbotten',
                                localizedName: 'Marängbotten',
                                desciption: '',
                            },
                            Mördegsbotten: {
                                name: 'Mördegsbotten',
                                localizedName: 'Mördegsbotten',
                                desciption: '',
                            },
                            Pajskal: {
                                name: 'Pajskal',
                                localizedName: 'Pajskal',
                                desciption: '',
                            },
                            Rulltårtsanslag: {
                                name: 'Rulltårtsanslag',
                                localizedName: 'Rulltårtsanslag',
                                desciption: '',
                            },
                            Smördegsbotten: {
                                name: 'Smördegsbotten',
                                localizedName: 'Smördegsbotten',
                                desciption: '',
                            },
                            Smörgåstårtsbotten: {
                                name: 'Smörgåstårtsbotten',
                                localizedName: 'Smörgåstårtsbotten',
                                desciption: '',
                            },
                            Tårtbotten: {
                                name: 'Tårtbotten',
                                localizedName: 'Tårtbotten',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            Chark: {
                name: 'Chark',
                localizedName: 'Chark',
                desciption: '',
                icon: 'https://assets.flaivy.com/steak.svg',
                immutableFields: {
                    recycleType: null,
                    volume: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    systembolagetArticleNumber: null,
                    systembolagetSalesPrice: null,
                    knNumber: null,
                    exciseProductCode: null,
                    alcoholTaxPaid: null,
                    isVegan: null,
                    isGelatinFree: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                    isPalmOilFree: null,
                    isFrozen: null,
                    isFoam: null,
                    isCoated: null,
                    isFudge: null,
                    isGelatinous: null,
                    isLiquorice: null,
                    isHardCandy: null,
                },
                children: {
                    Delichark: {
                        name: 'Delichark',
                        localizedName: 'Delichark',
                        desciption: '',
                        children: {
                            Bog: {
                                name: 'Bog',
                                localizedName: 'Bog',
                                desciption: '',
                            },
                            Bresaola: {
                                name: 'Bresaola',
                                localizedName: 'Bresaola',
                                desciption: '',
                            },
                            Coppa: {
                                name: 'Coppa',
                                localizedName: 'Coppa',
                                desciption: '',
                            },
                            Filé: {
                                name: 'Filé',
                                localizedName: 'Filé',
                                desciption: '',
                            },
                            Fiol: {
                                name: 'Fiol',
                                localizedName: 'Fiol',
                                desciption: '',
                            },
                            Grisfötter: {
                                name: 'Grisfötter',
                                localizedName: 'Grisfötter',
                                desciption: '',
                            },
                            Griskind: {
                                name: 'Griskind',
                                localizedName: 'Griskind',
                                desciption: '',
                            },
                            Innanlår: {
                                name: 'Innanlår',
                                localizedName: 'Innanlår',
                                desciption: '',
                            },
                            'Jul & helgskinka': {
                                name: 'Jul & helgskinka',
                                localizedName: 'Jul & helgskinka',
                                desciption: '',
                            },
                            Karre: {
                                name: 'Karre',
                                localizedName: 'Karre',
                                desciption: '',
                            },
                            Klubba: {
                                name: 'Klubba',
                                localizedName: 'Klubba',
                                desciption: '',
                            },
                            Kotlett: {
                                name: 'Kotlett',
                                localizedName: 'Kotlett',
                                desciption: '',
                            },
                            'Lufttorkat nötkött': {
                                name: 'Lufttorkat nötkött',
                                localizedName: 'Lufttorkat nötkött',
                                desciption: '',
                            },
                            Pancetta: {
                                name: 'Pancetta',
                                localizedName: 'Pancetta',
                                desciption: '',
                            },
                            Pastrami: {
                                name: 'Pastrami',
                                localizedName: 'Pastrami',
                                desciption: '',
                            },
                            Pizzaskinka: {
                                name: 'Pizzaskinka',
                                localizedName: 'Pizzaskinka',
                                desciption: '',
                            },
                            Rostbiff: {
                                name: 'Rostbiff',
                                localizedName: 'Rostbiff',
                                desciption: '',
                            },
                            Salami: {
                                name: 'Salami',
                                localizedName: 'Salami',
                                desciption: '',
                            },
                            Skinka: {
                                name: 'Skinka',
                                localizedName: 'Skinka',
                                desciption: '',
                            },
                            Stek: {
                                name: 'Stek',
                                localizedName: 'Stek',
                                desciption: '',
                            },
                            'Övrigt delichark': {
                                name: 'Övrigt delichark',
                                localizedName: 'Övrigt delichark',
                                desciption: '',
                            },
                        },
                    },
                    Innanmat: {
                        name: 'Innanmat',
                        localizedName: 'Innanmat',
                        desciption: '',
                        children: {
                            Anklever: {
                                name: 'Anklever',
                                localizedName: 'Anklever',
                                desciption: '',
                            },
                            Blodkorv: {
                                name: 'Blodkorv',
                                localizedName: 'Blodkorv',
                                desciption: '',
                            },
                            Blodpalt: {
                                name: 'Blodpalt',
                                localizedName: 'Blodpalt',
                                desciption: '',
                            },
                            Blodpudding: {
                                name: 'Blodpudding',
                                localizedName: 'Blodpudding',
                                desciption: '',
                            },
                            Lever: {
                                name: 'Lever',
                                localizedName: 'Lever',
                                desciption: '',
                            },
                            Svartsoppa: {
                                name: 'Svartsoppa',
                                localizedName: 'Svartsoppa',
                                desciption: '',
                            },
                            Talg: {
                                name: 'Talg',
                                localizedName: 'Talg',
                                desciption: '',
                            },
                            Ungnötslever: {
                                name: 'Ungnötslever',
                                localizedName: 'Ungnötslever',
                                desciption: '',
                            },
                        },
                    },
                    Korv: {
                        name: 'Korv',
                        localizedName: 'Korv',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/sausage, food, meal, meat, fork.svg',
                        children: {
                            Falukorv: {
                                name: 'Falukorv',
                                localizedName: 'Falukorv',
                                desciption: '',
                            },
                            Fläskkorv: {
                                name: 'Fläskkorv',
                                localizedName: 'Fläskkorv',
                                desciption: '',
                            },
                            'Frukost & lunchkorv': {
                                name: 'Frukost & lunchkorv',
                                localizedName: 'Frukost & lunchkorv',
                                desciption: '',
                            },
                            Färskkorv: {
                                name: 'Färskkorv',
                                localizedName: 'Färskkorv',
                                desciption: '',
                            },
                            Grillkorv: {
                                name: 'Grillkorv',
                                localizedName: 'Grillkorv',
                                desciption: '',
                            },
                            Isterbad: {
                                name: 'Isterbad',
                                localizedName: 'Isterbad',
                                desciption: '',
                            },
                            Julkorv: {
                                name: 'Julkorv',
                                localizedName: 'Julkorv',
                                desciption: '',
                            },
                            Kryddkorv: {
                                name: 'Kryddkorv',
                                localizedName: 'Kryddkorv',
                                desciption: '',
                            },
                            Kycklingkorv: {
                                name: 'Kycklingkorv',
                                localizedName: 'Kycklingkorv',
                                desciption: '',
                            },
                            Köttkorv: {
                                name: 'Köttkorv',
                                localizedName: 'Köttkorv',
                                desciption: '',
                            },
                            Lammkorv: {
                                name: 'Lammkorv',
                                localizedName: 'Lammkorv',
                                desciption: '',
                            },
                            Lantkorv: {
                                name: 'Lantkorv',
                                localizedName: 'Lantkorv',
                                desciption: '',
                            },
                            Middagskorv: {
                                name: 'Middagskorv',
                                localizedName: 'Middagskorv',
                                desciption: '',
                            },
                            Måltidskorv: {
                                name: 'Måltidskorv',
                                localizedName: 'Måltidskorv',
                                desciption: '',
                            },
                            Nötkorv: {
                                name: 'Nötkorv',
                                localizedName: 'Nötkorv',
                                desciption: '',
                            },
                            Prinskorv: {
                                name: 'Prinskorv',
                                localizedName: 'Prinskorv',
                                desciption: '',
                            },
                            Spickekorv: {
                                name: 'Spickekorv',
                                localizedName: 'Spickekorv',
                                desciption: '',
                            },
                            Stekkorv: {
                                name: 'Stekkorv',
                                localizedName: 'Stekkorv',
                                desciption: '',
                            },
                            'Varm & wienerkorv': {
                                name: 'Varm & wienerkorv',
                                localizedName: 'Varm & wienerkorv',
                                desciption: '',
                            },
                            Vegetarisk: {
                                name: 'Vegetarisk',
                                localizedName: 'Vegetarisk',
                                desciption: '',
                            },
                            Viltkorv: {
                                name: 'Viltkorv',
                                localizedName: 'Viltkorv',
                                desciption: '',
                            },
                            Ölkorv: {
                                name: 'Ölkorv',
                                localizedName: 'Ölkorv',
                                desciption: '',
                            },
                            'Övrigt korv': {
                                name: 'Övrigt korv',
                                localizedName: 'Övrigt korv',
                                desciption: '',
                            },
                        },
                    },
                    'Pastej & pateer': {
                        name: 'Pastej & pateer',
                        localizedName: 'Pastej & pateer',
                        desciption: '',
                        children: {
                            Aladab: {
                                name: 'Aladab',
                                localizedName: 'Aladab',
                                desciption: '',
                            },
                            Pastej: {
                                name: 'Pastej',
                                localizedName: 'Pastej',
                                desciption: '',
                            },
                            Paté: {
                                name: 'Paté',
                                localizedName: 'Paté',
                                desciption: '',
                            },
                            Sylta: {
                                name: 'Sylta',
                                localizedName: 'Sylta',
                                desciption: '',
                            },
                        },
                    },
                    Påläggschark: {
                        name: 'Påläggschark',
                        localizedName: 'Påläggschark',
                        desciption: '',
                        children: {
                            Hamburgerkött: {
                                name: 'Hamburgerkött',
                                localizedName: 'Hamburgerkött',
                                desciption: '',
                            },
                            Lökkorv: {
                                name: 'Lökkorv',
                                localizedName: 'Lökkorv',
                                desciption: '',
                            },
                            Medwurst: {
                                name: 'Medwurst',
                                localizedName: 'Medwurst',
                                desciption: '',
                            },
                            Rulle: {
                                name: 'Rulle',
                                localizedName: 'Rulle',
                                desciption: '',
                            },
                            Salami: {
                                name: 'Salami',
                                localizedName: 'Salami',
                                desciption: '',
                            },
                            Skinka: {
                                name: 'Skinka',
                                localizedName: 'Skinka',
                                desciption: '',
                            },
                            Skinkspad: {
                                name: 'Skinkspad',
                                localizedName: 'Skinkspad',
                                desciption: '',
                            },
                            Smörgåspålägg: {
                                name: 'Smörgåspålägg',
                                localizedName: 'Smörgåspålägg',
                                desciption: '',
                            },
                            Vegetarisk: {
                                name: 'Vegetarisk',
                                localizedName: 'Vegetarisk',
                                desciption: '',
                            },
                        },
                    },
                    'Rökt & rimmat': {
                        name: 'Rökt & rimmat',
                        localizedName: 'Rökt & rimmat',
                        desciption: '',
                        children: {
                            Bacon: {
                                name: 'Bacon',
                                localizedName: 'Bacon',
                                desciption: '',
                            },
                            Fläskkött: {
                                name: 'Fläskkött',
                                localizedName: 'Fläskkött',
                                desciption: '',
                            },
                            Kalkonkött: {
                                name: 'Kalkonkött',
                                localizedName: 'Kalkonkött',
                                desciption: '',
                            },
                            Kassler: {
                                name: 'Kassler',
                                localizedName: 'Kassler',
                                desciption: '',
                            },
                            Sida: {
                                name: 'Sida',
                                localizedName: 'Sida',
                                desciption: '',
                            },
                            Stekfläsk: {
                                name: 'Stekfläsk',
                                localizedName: 'Stekfläsk',
                                desciption: '',
                            },
                            Ärtfläsk: {
                                name: 'Ärtfläsk',
                                localizedName: 'Ärtfläsk',
                                desciption: '',
                            },
                        },
                    },
                    'Sous vide': {
                        name: 'Sous vide',
                        localizedName: 'Sous vide',
                        desciption: '',
                        children: {
                            Anklår: {
                                name: 'Anklår',
                                localizedName: 'Anklår',
                                desciption: '',
                            },
                            Bog: {
                                name: 'Bog',
                                localizedName: 'Bog',
                                desciption: '',
                            },
                            Bringa: {
                                name: 'Bringa',
                                localizedName: 'Bringa',
                                desciption: '',
                            },
                            Bröstfilé: {
                                name: 'Bröstfilé',
                                localizedName: 'Bröstfilé',
                                desciption: '',
                            },
                            Filé: {
                                name: 'Filé',
                                localizedName: 'Filé',
                                desciption: '',
                            },
                            Högrevskärna: {
                                name: 'Högrevskärna',
                                localizedName: 'Högrevskärna',
                                desciption: '',
                            },
                            Karré: {
                                name: 'Karré',
                                localizedName: 'Karré',
                                desciption: '',
                            },
                            Kotlett: {
                                name: 'Kotlett',
                                localizedName: 'Kotlett',
                                desciption: '',
                            },
                            Kotlettrad: {
                                name: 'Kotlettrad',
                                localizedName: 'Kotlettrad',
                                desciption: '',
                            },
                            Lägg: {
                                name: 'Lägg',
                                localizedName: 'Lägg',
                                desciption: '',
                            },
                            Porterstek: {
                                name: 'Porterstek',
                                localizedName: 'Porterstek',
                                desciption: '',
                            },
                            Revben: {
                                name: 'Revben',
                                localizedName: 'Revben',
                                desciption: '',
                            },
                            Rostbiff: {
                                name: 'Rostbiff',
                                localizedName: 'Rostbiff',
                                desciption: '',
                            },
                            Sida: {
                                name: 'Sida',
                                localizedName: 'Sida',
                                desciption: '',
                            },
                            Skinka: {
                                name: 'Skinka',
                                localizedName: 'Skinka',
                                desciption: '',
                            },
                            Skinkstek: {
                                name: 'Skinkstek',
                                localizedName: 'Skinkstek',
                                desciption: '',
                            },
                            Stek: {
                                name: 'Stek',
                                localizedName: 'Stek',
                                desciption: '',
                            },
                            Ytterfilé: {
                                name: 'Ytterfilé',
                                localizedName: 'Ytterfilé',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Fisk & skaldjur': {
                name: 'Fisk & skaldjur',
                localizedName: 'Fisk & skaldjur',
                desciption: '',
                icon: 'https://assets.flaivy.com/9.svg',
                immutableFields: {
                    recycleType: null,
                    volume: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    systembolagetArticleNumber: null,
                    systembolagetSalesPrice: null,
                    knNumber: null,
                    exciseProductCode: null,
                    alcoholTaxPaid: null,
                    isVegan: null,
                    isGelatinFree: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                    isPalmOilFree: null,
                    isFoam: null,
                    isCoated: null,
                    isFudge: null,
                    isGelatinous: null,
                    isLiquorice: null,
                    isHardCandy: null,
                },
                children: {
                    Fisk: {
                        name: 'Fisk',
                        localizedName: 'Fisk',
                        desciption: '',
                        children: {
                            Abborre: {
                                name: 'Abborre',
                                localizedName: 'Abborre',
                                desciption: '',
                            },
                            'Alaska pollock': {
                                name: 'Alaska pollock',
                                localizedName: 'Alaska pollock',
                                desciption: '',
                            },
                            Ansjovis: {
                                name: 'Ansjovis',
                                localizedName: 'Ansjovis',
                                desciption: '',
                            },
                            Bergtunga: {
                                name: 'Bergtunga',
                                localizedName: 'Bergtunga',
                                desciption: '',
                            },
                            Blåvitling: {
                                name: 'Blåvitling',
                                localizedName: 'Blåvitling',
                                desciption: '',
                            },
                            Bläckfisk: {
                                name: 'Bläckfisk',
                                localizedName: 'Bläckfisk',
                                desciption: '',
                            },
                            Boquerones: {
                                name: 'Boquerones',
                                localizedName: 'Boquerones',
                                desciption: '',
                            },
                            Fiskmix: {
                                name: 'Fiskmix',
                                localizedName: 'Fiskmix',
                                desciption: '',
                            },
                            Flundra: {
                                name: 'Flundra',
                                localizedName: 'Flundra',
                                desciption: '',
                            },
                            Guldlax: {
                                name: 'Guldlax',
                                localizedName: 'Guldlax',
                                desciption: '',
                            },
                            Gädda: {
                                name: 'Gädda',
                                localizedName: 'Gädda',
                                desciption: '',
                            },
                            Gös: {
                                name: 'Gös',
                                localizedName: 'Gös',
                                desciption: '',
                            },
                            Havskatt: {
                                name: 'Havskatt',
                                localizedName: 'Havskatt',
                                desciption: '',
                            },
                            Hoki: {
                                name: 'Hoki',
                                localizedName: 'Hoki',
                                desciption: '',
                            },
                            'Hälleflundra liten': {
                                name: 'Hälleflundra liten',
                                localizedName: 'Hälleflundra liten',
                                desciption: '',
                            },
                            Kapkummel: {
                                name: 'Kapkummel',
                                localizedName: 'Kapkummel',
                                desciption: '',
                            },
                            Kolja: {
                                name: 'Kolja',
                                localizedName: 'Kolja',
                                desciption: '',
                            },
                            Kummel: {
                                name: 'Kummel',
                                localizedName: 'Kummel',
                                desciption: '',
                            },
                            Lax: {
                                name: 'Lax',
                                localizedName: 'Lax',
                                desciption: '',
                            },
                            Lubb: {
                                name: 'Lubb',
                                localizedName: 'Lubb',
                                desciption: '',
                            },
                            Långa: {
                                name: 'Långa',
                                localizedName: 'Långa',
                                desciption: '',
                            },
                            Makrill: {
                                name: 'Makrill',
                                localizedName: 'Makrill',
                                desciption: '',
                            },
                            Mix: {
                                name: 'Mix',
                                localizedName: 'Mix',
                                desciption: '',
                            },
                            Pangasius: {
                                name: 'Pangasius',
                                localizedName: 'Pangasius',
                                desciption: '',
                            },
                            'Pinklax, chumlax & stillhavslax': {
                                name: 'Pinklax, chumlax & stillhavslax',
                                localizedName: 'Pinklax, chumlax & stillhavslax',
                                desciption: '',
                            },
                            'Regnbåge & fjordörre': {
                                name: 'Regnbåge & fjordörre',
                                localizedName: 'Regnbåge & fjordörre',
                                desciption: '',
                            },
                            Röding: {
                                name: 'Röding',
                                localizedName: 'Röding',
                                desciption: '',
                            },
                            Rödspätta: {
                                name: 'Rödspätta',
                                localizedName: 'Rödspätta',
                                desciption: '',
                            },
                            Rödtunga: {
                                name: 'Rödtunga',
                                localizedName: 'Rödtunga',
                                desciption: '',
                            },
                            Sardell: {
                                name: 'Sardell',
                                localizedName: 'Sardell',
                                desciption: '',
                            },
                            Sej: {
                                name: 'Sej',
                                localizedName: 'Sej',
                                desciption: '',
                            },
                            Sill: {
                                name: 'Sill',
                                localizedName: 'Sill',
                                desciption: '',
                            },
                            Tonfisk: {
                                name: 'Tonfisk',
                                localizedName: 'Tonfisk',
                                desciption: '',
                            },
                            Torsk: {
                                name: 'Torsk',
                                localizedName: 'Torsk',
                                desciption: '',
                            },
                        },
                    },
                    'Kaviar & rom': {
                        name: 'Kaviar & rom',
                        localizedName: 'Kaviar & rom',
                        desciption: '',
                        children: {
                            Oscietra: {
                                name: 'Oscietra',
                                localizedName: 'Oscietra',
                                desciption: '',
                            },
                            'Regnbåge & fjordörre': {
                                name: 'Regnbåge & fjordörre',
                                localizedName: 'Regnbåge & fjordörre',
                                desciption: '',
                            },
                            Sik: {
                                name: 'Sik',
                                localizedName: 'Sik',
                                desciption: '',
                            },
                            Siklöja: {
                                name: 'Siklöja',
                                localizedName: 'Siklöja',
                                desciption: '',
                            },
                            Sjurygg: {
                                name: 'Sjurygg',
                                localizedName: 'Sjurygg',
                                desciption: '',
                            },
                            Störrom: {
                                name: 'Störrom',
                                localizedName: 'Störrom',
                                desciption: '',
                            },
                            Torsk: {
                                name: 'Torsk',
                                localizedName: 'Torsk',
                                desciption: '',
                            },
                            Vegetabilisk: {
                                name: 'Vegetabilisk',
                                localizedName: 'Vegetabilisk',
                                desciption: '',
                            },
                            'Övrigt kaviar & rom': {
                                name: 'Övrigt kaviar & rom',
                                localizedName: 'Övrigt kaviar & rom',
                                desciption: '',
                            },
                        },
                    },
                    'Kräfta, krabba & hummer': {
                        name: 'Kräfta, krabba & hummer',
                        localizedName: 'Kräfta, krabba & hummer',
                        desciption: '',
                        children: {
                            Havskräfta: {
                                name: 'Havskräfta',
                                localizedName: 'Havskräfta',
                                desciption: '',
                            },
                            Hummer: {
                                name: 'Hummer',
                                localizedName: 'Hummer',
                                desciption: '',
                            },
                            Krabba: {
                                name: 'Krabba',
                                localizedName: 'Krabba',
                                desciption: '',
                            },
                            Kräfta: {
                                name: 'Kräfta',
                                localizedName: 'Kräfta',
                                desciption: '',
                            },
                            Kungskrabba: {
                                name: 'Kungskrabba',
                                localizedName: 'Kungskrabba',
                                desciption: '',
                            },
                            Snowcrab: {
                                name: 'Snowcrab',
                                localizedName: 'Snowcrab',
                                desciption: '',
                            },
                        },
                    },
                    'Musslor & ostron': {
                        name: 'Musslor & ostron',
                        localizedName: 'Musslor & ostron',
                        desciption: '',
                        children: {
                            Blåmussla: {
                                name: 'Blåmussla',
                                localizedName: 'Blåmussla',
                                desciption: '',
                            },
                            Grönmussla: {
                                name: 'Grönmussla',
                                localizedName: 'Grönmussla',
                                desciption: '',
                            },
                            Kammussla: {
                                name: 'Kammussla',
                                localizedName: 'Kammussla',
                                desciption: '',
                            },
                            Ostron: {
                                name: 'Ostron',
                                localizedName: 'Ostron',
                                desciption: '',
                            },
                            Vongole: {
                                name: 'Vongole',
                                localizedName: 'Vongole',
                                desciption: '',
                            },
                            'Övrigt musslor & ostron': {
                                name: 'Övrigt musslor & ostron',
                                localizedName: 'Övrigt musslor & ostron',
                                desciption: '',
                            },
                        },
                    },
                    'Pastej & pateer': {
                        name: 'Pastej & pateer',
                        localizedName: 'Pastej & pateer',
                        desciption: '',
                    },
                    Räkor: {
                        name: 'Räkor',
                        localizedName: 'Räkor',
                        desciption: '',
                        children: {
                            Räka: {
                                name: 'Räka',
                                localizedName: 'Räka',
                                desciption: '',
                            },
                            Rödräka: {
                                name: 'Rödräka',
                                localizedName: 'Rödräka',
                                desciption: '',
                            },
                            Tigerräka: {
                                name: 'Tigerräka',
                                localizedName: 'Tigerräka',
                                desciption: '',
                            },
                            Vannameiräka: {
                                name: 'Vannameiräka',
                                localizedName: 'Vannameiräka',
                                desciption: '',
                            },
                            'Övrigt räkor': {
                                name: 'Övrigt räkor',
                                localizedName: 'Övrigt räkor',
                                desciption: '',
                            },
                        },
                    },
                    'Övrig fisk & skaldjur': {
                        name: 'Övrig fisk & skaldjur',
                        localizedName: 'Övrig fisk & skaldjur',
                        desciption: '',
                        children: {
                            Fiskben: {
                                name: 'Fiskben',
                                localizedName: 'Fiskben',
                                desciption: '',
                            },
                            Seafoodmix: {
                                name: 'Seafoodmix',
                                localizedName: 'Seafoodmix',
                                desciption: '',
                            },
                            Snigel: {
                                name: 'Snigel',
                                localizedName: 'Snigel',
                                desciption: '',
                            },
                            Surimi: {
                                name: 'Surimi',
                                localizedName: 'Surimi',
                                desciption: '',
                            },
                            'Övrigt övrig fisk & skaldjur': {
                                name: 'Övrigt övrig fisk & skaldjur',
                                localizedName: 'Övrigt övrig fisk & skaldjur',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Frukt & grönt': {
                name: 'Frukt & grönt',
                localizedName: 'Frukt & grönt',
                desciption: '',
                icon: 'https://assets.flaivy.com/apple.svg',
                immutableFields: {
                    recycleType: null,
                    volume: null,
                    goesWith: null,
                    isGelatinFree: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                    isPalmOilFree: null,
                    isFrozen: null,
                    isRefrigerated: null,
                    isFoam: null,
                    isCoated: null,
                    isFudge: null,
                    isGelatinous: null,
                    isLiquorice: null,
                    isHardCandy: null,
                },
                children: {
                    Baljväxter: {
                        name: 'Baljväxter',
                        localizedName: 'Baljväxter',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Böna: {
                                name: 'Böna',
                                localizedName: 'Böna',
                                desciption: '',
                            },
                            Sockerärta: {
                                name: 'Sockerärta',
                                localizedName: 'Sockerärta',
                                desciption: '',
                            },
                            Ärter: {
                                name: 'Ärter',
                                localizedName: 'Ärter',
                                desciption: '',
                            },
                            'Övrigt baljväxter': {
                                name: 'Övrigt baljväxter',
                                localizedName: 'Övrigt baljväxter',
                                desciption: '',
                            },
                        },
                    },
                    Bär: {
                        name: 'Bär',
                        localizedName: 'Bär',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/blueberries.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Björnbär: {
                                name: 'Björnbär',
                                localizedName: 'Björnbär',
                                desciption: '',
                            },
                            Blåbär: {
                                name: 'Blåbär',
                                localizedName: 'Blåbär',
                                desciption: '',
                            },
                            Bärblandning: {
                                name: 'Bärblandning',
                                localizedName: 'Bärblandning',
                                desciption: '',
                            },
                            Hallon: {
                                name: 'Hallon',
                                localizedName: 'Hallon',
                                desciption: '',
                            },
                            Havtorn: {
                                name: 'Havtorn',
                                localizedName: 'Havtorn',
                                desciption: '',
                            },
                            Hjortron: {
                                name: 'Hjortron',
                                localizedName: 'Hjortron',
                                desciption: '',
                            },
                            Jordgubbe: {
                                name: 'Jordgubbe',
                                localizedName: 'Jordgubbe',
                                desciption: '',
                            },
                            Krusbär: {
                                name: 'Krusbär',
                                localizedName: 'Krusbär',
                                desciption: '',
                            },
                            Lingon: {
                                name: 'Lingon',
                                localizedName: 'Lingon',
                                desciption: '',
                            },
                            Tranbär: {
                                name: 'Tranbär',
                                localizedName: 'Tranbär',
                                desciption: '',
                            },
                            Vinbär: {
                                name: 'Vinbär',
                                localizedName: 'Vinbär',
                                desciption: '',
                            },
                            'Övrigt bär': {
                                name: 'Övrigt bär',
                                localizedName: 'Övrigt bär',
                                desciption: '',
                            },
                        },
                    },
                    Citrus: {
                        name: 'Citrus',
                        localizedName: 'Citrus',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/lemon.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Apelsin: {
                                name: 'Apelsin',
                                localizedName: 'Apelsin',
                                desciption: '',
                            },
                            Citron: {
                                name: 'Citron',
                                localizedName: 'Citron',
                                desciption: '',
                            },
                            Clementin: {
                                name: 'Clementin',
                                localizedName: 'Clementin',
                                desciption: '',
                            },
                            Grapefrukt: {
                                name: 'Grapefrukt',
                                localizedName: 'Grapefrukt',
                                desciption: '',
                            },
                            Lime: {
                                name: 'Lime',
                                localizedName: 'Lime',
                                desciption: '',
                            },
                            Pomelo: {
                                name: 'Pomelo',
                                localizedName: 'Pomelo',
                                desciption: '',
                            },
                        },
                    },
                    'Exotisk frukt': {
                        name: 'Exotisk frukt',
                        localizedName: 'Exotisk frukt',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/pineapple.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Ananas: {
                                name: 'Ananas',
                                localizedName: 'Ananas',
                                desciption: '',
                            },
                            Banan: {
                                name: 'Banan',
                                localizedName: 'Banan',
                                desciption: '',
                            },
                            Dadel: {
                                name: 'Dadel',
                                localizedName: 'Dadel',
                                desciption: '',
                            },
                            Druva: {
                                name: 'Druva',
                                localizedName: 'Druva',
                                desciption: '',
                            },
                            Granatäpple: {
                                name: 'Granatäpple',
                                localizedName: 'Granatäpple',
                                desciption: '',
                            },
                            Kiwi: {
                                name: 'Kiwi',
                                localizedName: 'Kiwi',
                                desciption: '',
                            },
                            Kokosnöt: {
                                name: 'Kokosnöt',
                                localizedName: 'Kokosnöt',
                                desciption: '',
                            },
                            Mango: {
                                name: 'Mango',
                                localizedName: 'Mango',
                                desciption: '',
                            },
                            Papaya: {
                                name: 'Papaya',
                                localizedName: 'Papaya',
                                desciption: '',
                            },
                            Passionsfrukt: {
                                name: 'Passionsfrukt',
                                localizedName: 'Passionsfrukt',
                                desciption: '',
                            },
                            Physalis: {
                                name: 'Physalis',
                                localizedName: 'Physalis',
                                desciption: '',
                            },
                            Pitahaya: {
                                name: 'Pitahaya',
                                localizedName: 'Pitahaya',
                                desciption: '',
                            },
                            'Övrigt exotisk frukt': {
                                name: 'Övrigt exotisk frukt',
                                localizedName: 'Övrigt exotisk frukt',
                                desciption: '',
                            },
                        },
                    },
                    Frukt: {
                        name: 'Frukt',
                        localizedName: 'Frukt',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Äpple: {
                                name: 'Äpple',
                                localizedName: 'Äpple',
                                desciption: '',
                            },
                            Fruktblandning: {
                                name: 'Fruktblandning',
                                localizedName: 'Fruktblandning',
                                desciption: '',
                            },
                        },
                    },
                    Grönsaker: {
                        name: 'Grönsaker',
                        localizedName: 'Grönsaker',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/tomato.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Alg: {
                                name: 'Alg',
                                localizedName: 'Alg',
                                desciption: '',
                            },
                            Aubergine: {
                                name: 'Aubergine',
                                localizedName: 'Aubergine',
                                desciption: '',
                            },
                            Avocado: {
                                name: 'Avocado',
                                localizedName: 'Avocado',
                                desciption: '',
                            },
                            Blekselleri: {
                                name: 'Blekselleri',
                                localizedName: 'Blekselleri',
                                desciption: '',
                            },
                            Chili: {
                                name: 'Chili',
                                localizedName: 'Chili',
                                desciption: '',
                            },
                            Grodd: {
                                name: 'Grodd',
                                localizedName: 'Grodd',
                                desciption: '',
                            },
                            Grönsaksblandning: {
                                name: 'Grönsaksblandning',
                                localizedName: 'Grönsaksblandning',
                                desciption: '',
                            },
                            Gurka: {
                                name: 'Gurka',
                                localizedName: 'Gurka',
                                desciption: '',
                            },
                            Jordnöt: {
                                name: 'Jordnöt',
                                localizedName: 'Jordnöt',
                                desciption: '',
                            },
                            Kastanj: {
                                name: 'Kastanj',
                                localizedName: 'Kastanj',
                                desciption: '',
                            },
                            Kronärtskocka: {
                                name: 'Kronärtskocka',
                                localizedName: 'Kronärtskocka',
                                desciption: '',
                            },
                            Lav: {
                                name: 'Lav',
                                localizedName: 'Lav',
                                desciption: '',
                            },
                            Linser: {
                                name: 'Linser',
                                localizedName: 'Linser',
                                desciption: '',
                            },
                            Majs: {
                                name: 'Majs',
                                localizedName: 'Majs',
                                desciption: '',
                            },
                            Mangold: {
                                name: 'Mangold',
                                localizedName: 'Mangold',
                                desciption: '',
                            },
                            Paprika: {
                                name: 'Paprika',
                                localizedName: 'Paprika',
                                desciption: '',
                            },
                            Pumpa: {
                                name: 'Pumpa',
                                localizedName: 'Pumpa',
                                desciption: '',
                            },
                            Rabarber: {
                                name: 'Rabarber',
                                localizedName: 'Rabarber',
                                desciption: '',
                            },
                            Salladsblandning: {
                                name: 'Salladsblandning',
                                localizedName: 'Salladsblandning',
                                desciption: '',
                            },
                            Solrosskott: {
                                name: 'Solrosskott',
                                localizedName: 'Solrosskott',
                                desciption: '',
                            },
                            Sparris: {
                                name: 'Sparris',
                                localizedName: 'Sparris',
                                desciption: '',
                            },
                            Spenat: {
                                name: 'Spenat',
                                localizedName: 'Spenat',
                                desciption: '',
                            },
                            Tomat: {
                                name: 'Tomat',
                                localizedName: 'Tomat',
                                desciption: '',
                            },
                            Zucchini: {
                                name: 'Zucchini',
                                localizedName: 'Zucchini',
                                desciption: '',
                            },
                            Ärtskott: {
                                name: 'Ärtskott',
                                localizedName: 'Ärtskott',
                                desciption: '',
                            },
                            'Ätlig blomma': {
                                name: 'Ätlig blomma',
                                localizedName: 'Ätlig blomma',
                                desciption: '',
                            },
                            'Övriga skott': {
                                name: 'Övriga skott',
                                localizedName: 'Övriga skott',
                                desciption: '',
                            },
                            'Övrigt grönsaker': {
                                name: 'Övrigt grönsaker',
                                localizedName: 'Övrigt grönsaker',
                                desciption: '',
                            },
                        },
                    },
                    Kryddgrönt: {
                        name: 'Kryddgrönt',
                        localizedName: 'Kryddgrönt',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Basilika: {
                                name: 'Basilika',
                                localizedName: 'Basilika',
                                desciption: '',
                            },
                            Citronmeliss: {
                                name: 'Citronmeliss',
                                localizedName: 'Citronmeliss',
                                desciption: '',
                            },
                            Citronverbena: {
                                name: 'Citronverbena',
                                localizedName: 'Citronverbena',
                                desciption: '',
                            },
                            Dill: {
                                name: 'Dill',
                                localizedName: 'Dill',
                                desciption: '',
                            },
                            Dragon: {
                                name: 'Dragon',
                                localizedName: 'Dragon',
                                desciption: '',
                            },
                            Fänkålsdill: {
                                name: 'Fänkålsdill',
                                localizedName: 'Fänkålsdill',
                                desciption: '',
                            },
                            Gräslök: {
                                name: 'Gräslök',
                                localizedName: 'Gräslök',
                                desciption: '',
                            },
                            Koriander: {
                                name: 'Koriander',
                                localizedName: 'Koriander',
                                desciption: '',
                            },
                            Krasse: {
                                name: 'Krasse',
                                localizedName: 'Krasse',
                                desciption: '',
                            },
                            'Krydgrönt udda': {
                                name: 'Krydgrönt udda',
                                localizedName: 'Krydgrönt udda',
                                desciption: '',
                            },
                            Körvel: {
                                name: 'Körvel',
                                localizedName: 'Körvel',
                                desciption: '',
                            },
                            Libbsticka: {
                                name: 'Libbsticka',
                                localizedName: 'Libbsticka',
                                desciption: '',
                            },
                            Mejram: {
                                name: 'Mejram',
                                localizedName: 'Mejram',
                                desciption: '',
                            },
                            Mynta: {
                                name: 'Mynta',
                                localizedName: 'Mynta',
                                desciption: '',
                            },
                            Oregano: {
                                name: 'Oregano',
                                localizedName: 'Oregano',
                                desciption: '',
                            },
                            'Oxalis/ängsyra': {
                                name: 'Oxalis/ängsyra',
                                localizedName: 'Oxalis/ängsyra',
                                desciption: '',
                            },
                            Persilja: {
                                name: 'Persilja',
                                localizedName: 'Persilja',
                                desciption: '',
                            },
                            Rosmarin: {
                                name: 'Rosmarin',
                                localizedName: 'Rosmarin',
                                desciption: '',
                            },
                            Salvia: {
                                name: 'Salvia',
                                localizedName: 'Salvia',
                                desciption: '',
                            },
                            Timjan: {
                                name: 'Timjan',
                                localizedName: 'Timjan',
                                desciption: '',
                            },
                            Vattenkrasse: {
                                name: 'Vattenkrasse',
                                localizedName: 'Vattenkrasse',
                                desciption: '',
                            },
                            Örtmix: {
                                name: 'Örtmix',
                                localizedName: 'Örtmix',
                                desciption: '',
                            },
                        },
                    },
                    Kål: {
                        name: 'Kål',
                        localizedName: 'Kål',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Blomkål: {
                                name: 'Blomkål',
                                localizedName: 'Blomkål',
                                desciption: '',
                            },
                            Broccoli: {
                                name: 'Broccoli',
                                localizedName: 'Broccoli',
                                desciption: '',
                            },
                            Brysselkål: {
                                name: 'Brysselkål',
                                localizedName: 'Brysselkål',
                                desciption: '',
                            },
                            Fänkål: {
                                name: 'Fänkål',
                                localizedName: 'Fänkål',
                                desciption: '',
                            },
                            Grönkål: {
                                name: 'Grönkål',
                                localizedName: 'Grönkål',
                                desciption: '',
                            },
                            Kålrabbi: {
                                name: 'Kålrabbi',
                                localizedName: 'Kålrabbi',
                                desciption: '',
                            },
                            'Pak choy': {
                                name: 'Pak choy',
                                localizedName: 'Pak choy',
                                desciption: '',
                            },
                            Rödkål: {
                                name: 'Rödkål',
                                localizedName: 'Rödkål',
                                desciption: '',
                            },
                            Salladskål: {
                                name: 'Salladskål',
                                localizedName: 'Salladskål',
                                desciption: '',
                            },
                            Savoykål: {
                                name: 'Savoykål',
                                localizedName: 'Savoykål',
                                desciption: '',
                            },
                            Spetskål: {
                                name: 'Spetskål',
                                localizedName: 'Spetskål',
                                desciption: '',
                            },
                            Svartkål: {
                                name: 'Svartkål',
                                localizedName: 'Svartkål',
                                desciption: '',
                            },
                            Vitkål: {
                                name: 'Vitkål',
                                localizedName: 'Vitkål',
                                desciption: '',
                            },
                            'Övrigt kål': {
                                name: 'Övrigt kål',
                                localizedName: 'Övrigt kål',
                                desciption: '',
                            },
                        },
                    },
                    Lök: {
                        name: 'Lök',
                        localizedName: 'Lök',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/onion.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            'Gul lök': {
                                name: 'Gul lök',
                                localizedName: 'Gul lök',
                                desciption: '',
                            },
                            Purjolök: {
                                name: 'Purjolök',
                                localizedName: 'Purjolök',
                                desciption: '',
                            },
                            Pärllök: {
                                name: 'Pärllök',
                                localizedName: 'Pärllök',
                                desciption: '',
                            },
                            Ramslök: {
                                name: 'Ramslök',
                                localizedName: 'Ramslök',
                                desciption: '',
                            },
                            Rödlök: {
                                name: 'Rödlök',
                                localizedName: 'Rödlök',
                                desciption: '',
                            },
                            Salladslök: {
                                name: 'Salladslök',
                                localizedName: 'Salladslök',
                                desciption: '',
                            },
                            Schalottenlök: {
                                name: 'Schalottenlök',
                                localizedName: 'Schalottenlök',
                                desciption: '',
                            },
                            Vitlök: {
                                name: 'Vitlök',
                                localizedName: 'Vitlök',
                                desciption: '',
                            },
                            'Övrigt lök': {
                                name: 'Övrigt lök',
                                localizedName: 'Övrigt lök',
                                desciption: '',
                            },
                        },
                    },
                    Melon: {
                        name: 'Melon',
                        localizedName: 'Melon',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/watermelon-and-slice.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Cantaloupe: {
                                name: 'Cantaloupe',
                                localizedName: 'Cantaloupe',
                                desciption: '',
                            },
                            Galla: {
                                name: 'Galla',
                                localizedName: 'Galla',
                                desciption: '',
                            },
                            Honungsmelon: {
                                name: 'Honungsmelon',
                                localizedName: 'Honungsmelon',
                                desciption: '',
                            },
                            Vattenmelon: {
                                name: 'Vattenmelon',
                                localizedName: 'Vattenmelon',
                                desciption: '',
                            },
                            'Övrigt melon': {
                                name: 'Övrigt melon',
                                localizedName: 'Övrigt melon',
                                desciption: '',
                            },
                        },
                    },
                    Potatis: {
                        name: 'Potatis',
                        localizedName: 'Potatis',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Bakpotatis: {
                                name: 'Bakpotatis',
                                localizedName: 'Bakpotatis',
                                desciption: '',
                            },
                            'Potatis bearbetad': {
                                name: 'Potatis bearbetad',
                                localizedName: 'Potatis bearbetad',
                                desciption: '',
                            },
                            'Potatis tvättad': {
                                name: 'Potatis tvättad',
                                localizedName: 'Potatis tvättad',
                                desciption: '',
                            },
                        },
                    },
                    Potatisprodukter: {
                        name: 'Potatisprodukter',
                        localizedName: 'Potatisprodukter',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Klyftpotatis: {
                                name: 'Klyftpotatis',
                                localizedName: 'Klyftpotatis',
                                desciption: '',
                            },
                            Mos: {
                                name: 'Mos',
                                localizedName: 'Mos',
                                desciption: '',
                            },
                            Pommes: {
                                name: 'Pommes',
                                localizedName: 'Pommes',
                                desciption: '',
                            },
                            Potatisbakelse: {
                                name: 'Potatisbakelse',
                                localizedName: 'Potatisbakelse',
                                desciption: '',
                            },
                            Potatisbulle: {
                                name: 'Potatisbulle',
                                localizedName: 'Potatisbulle',
                                desciption: '',
                            },
                            'Potatis förkokt': {
                                name: 'Potatis förkokt',
                                localizedName: 'Potatis förkokt',
                                desciption: '',
                            },
                            Pyttpotatis: {
                                name: 'Pyttpotatis',
                                localizedName: 'Pyttpotatis',
                                desciption: '',
                            },
                            Raggmunk: {
                                name: 'Raggmunk',
                                localizedName: 'Raggmunk',
                                desciption: '',
                            },
                            Rösti: {
                                name: 'Rösti',
                                localizedName: 'Rösti',
                                desciption: '',
                            },
                            'Övrigt potatisprodukter': {
                                name: 'Övrigt potatisprodukter',
                                localizedName: 'Övrigt potatisprodukter',
                                desciption: '',
                            },
                        },
                    },
                    Puré: {
                        name: 'Puré',
                        localizedName: 'Puré',
                        desciption: '',
                        children: {
                            Ananas: {
                                name: 'Ananas',
                                localizedName: 'Ananas',
                                desciption: '',
                            },
                            Aprikos: {
                                name: 'Aprikos',
                                localizedName: 'Aprikos',
                                desciption: '',
                            },
                            Banan: {
                                name: 'Banan',
                                localizedName: 'Banan',
                                desciption: '',
                            },
                            Björnbär: {
                                name: 'Björnbär',
                                localizedName: 'Björnbär',
                                desciption: '',
                            },
                            Blodapelsin: {
                                name: 'Blodapelsin',
                                localizedName: 'Blodapelsin',
                                desciption: '',
                            },
                            Blomkål: {
                                name: 'Blomkål',
                                localizedName: 'Blomkål',
                                desciption: '',
                            },
                            Blåbär: {
                                name: 'Blåbär',
                                localizedName: 'Blåbär',
                                desciption: '',
                            },
                            Broccoli: {
                                name: 'Broccoli',
                                localizedName: 'Broccoli',
                                desciption: '',
                            },
                            Böna: {
                                name: 'Böna',
                                localizedName: 'Böna',
                                desciption: '',
                            },
                            Citron: {
                                name: 'Citron',
                                localizedName: 'Citron',
                                desciption: '',
                            },
                            Fruktmix: {
                                name: 'Fruktmix',
                                localizedName: 'Fruktmix',
                                desciption: '',
                            },
                            Granatäpple: {
                                name: 'Granatäpple',
                                localizedName: 'Granatäpple',
                                desciption: '',
                            },
                            Grönsaksmix: {
                                name: 'Grönsaksmix',
                                localizedName: 'Grönsaksmix',
                                desciption: '',
                            },
                            Guava: {
                                name: 'Guava',
                                localizedName: 'Guava',
                                desciption: '',
                            },
                            'Gul lök': {
                                name: 'Gul lök',
                                localizedName: 'Gul lök',
                                desciption: '',
                            },
                            Hallon: {
                                name: 'Hallon',
                                localizedName: 'Hallon',
                                desciption: '',
                            },
                            Havtorn: {
                                name: 'Havtorn',
                                localizedName: 'Havtorn',
                                desciption: '',
                            },
                            Jordgubbe: {
                                name: 'Jordgubbe',
                                localizedName: 'Jordgubbe',
                                desciption: '',
                            },
                            Jordärtskocka: {
                                name: 'Jordärtskocka',
                                localizedName: 'Jordärtskocka',
                                desciption: '',
                            },
                            Kokosnöt: {
                                name: 'Kokosnöt',
                                localizedName: 'Kokosnöt',
                                desciption: '',
                            },
                            Körsbär: {
                                name: 'Körsbär',
                                localizedName: 'Körsbär',
                                desciption: '',
                            },
                            Lime: {
                                name: 'Lime',
                                localizedName: 'Lime',
                                desciption: '',
                            },
                            Majs: {
                                name: 'Majs',
                                localizedName: 'Majs',
                                desciption: '',
                            },
                            Mandarin: {
                                name: 'Mandarin',
                                localizedName: 'Mandarin',
                                desciption: '',
                            },
                            Mango: {
                                name: 'Mango',
                                localizedName: 'Mango',
                                desciption: '',
                            },
                            Morot: {
                                name: 'Morot',
                                localizedName: 'Morot',
                                desciption: '',
                            },
                            Nypon: {
                                name: 'Nypon',
                                localizedName: 'Nypon',
                                desciption: '',
                            },
                            Palsternacka: {
                                name: 'Palsternacka',
                                localizedName: 'Palsternacka',
                                desciption: '',
                            },
                            Passionsfrukt: {
                                name: 'Passionsfrukt',
                                localizedName: 'Passionsfrukt',
                                desciption: '',
                            },
                            Persika: {
                                name: 'Persika',
                                localizedName: 'Persika',
                                desciption: '',
                            },
                            Plommon: {
                                name: 'Plommon',
                                localizedName: 'Plommon',
                                desciption: '',
                            },
                            Päron: {
                                name: 'Päron',
                                localizedName: 'Päron',
                                desciption: '',
                            },
                            Rabarber: {
                                name: 'Rabarber',
                                localizedName: 'Rabarber',
                                desciption: '',
                            },
                            Rotselleri: {
                                name: 'Rotselleri',
                                localizedName: 'Rotselleri',
                                desciption: '',
                            },
                            Rödbeta: {
                                name: 'Rödbeta',
                                localizedName: 'Rödbeta',
                                desciption: '',
                            },
                            Selleri: {
                                name: 'Selleri',
                                localizedName: 'Selleri',
                                desciption: '',
                            },
                            Smultron: {
                                name: 'Smultron',
                                localizedName: 'Smultron',
                                desciption: '',
                            },
                            Sparris: {
                                name: 'Sparris',
                                localizedName: 'Sparris',
                                desciption: '',
                            },
                            Sötpotatis: {
                                name: 'Sötpotatis',
                                localizedName: 'Sötpotatis',
                                desciption: '',
                            },
                            Vattenmelon: {
                                name: 'Vattenmelon',
                                localizedName: 'Vattenmelon',
                                desciption: '',
                            },
                            Vinbär: {
                                name: 'Vinbär',
                                localizedName: 'Vinbär',
                                desciption: '',
                            },
                            Yuzu: {
                                name: 'Yuzu',
                                localizedName: 'Yuzu',
                                desciption: '',
                            },
                            Äpple: {
                                name: 'Äpple',
                                localizedName: 'Äpple',
                                desciption: '',
                            },
                            Ärter: {
                                name: 'Ärter',
                                localizedName: 'Ärter',
                                desciption: '',
                            },
                            'Övrigt puré': {
                                name: 'Övrigt puré',
                                localizedName: 'Övrigt puré',
                                desciption: '',
                            },
                        },
                    },
                    Rotfrukt: {
                        name: 'Rotfrukt',
                        localizedName: 'Rotfrukt',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/carrot.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            goesWith: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Gulbeta: {
                                name: 'Gulbeta',
                                localizedName: 'Gulbeta',
                                desciption: '',
                            },
                            Gurkmeja: {
                                name: 'Gurkmeja',
                                localizedName: 'Gurkmeja',
                                desciption: '',
                            },
                            Ingefära: {
                                name: 'Ingefära',
                                localizedName: 'Ingefära',
                                desciption: '',
                            },
                            Jordärtskocka: {
                                name: 'Jordärtskocka',
                                localizedName: 'Jordärtskocka',
                                desciption: '',
                            },
                            Kålrot: {
                                name: 'Kålrot',
                                localizedName: 'Kålrot',
                                desciption: '',
                            },
                            Majrova: {
                                name: 'Majrova',
                                localizedName: 'Majrova',
                                desciption: '',
                            },
                            Morot: {
                                name: 'Morot',
                                localizedName: 'Morot',
                                desciption: '',
                            },
                            Palsternacka: {
                                name: 'Palsternacka',
                                localizedName: 'Palsternacka',
                                desciption: '',
                            },
                            Pepparrot: {
                                name: 'Pepparrot',
                                localizedName: 'Pepparrot',
                                desciption: '',
                            },
                            Persiljerot: {
                                name: 'Persiljerot',
                                localizedName: 'Persiljerot',
                                desciption: '',
                            },
                            Polkabeta: {
                                name: 'Polkabeta',
                                localizedName: 'Polkabeta',
                                desciption: '',
                            },
                            Rotfruktsblandning: {
                                name: 'Rotfruktsblandning',
                                localizedName: 'Rotfruktsblandning',
                                desciption: '',
                            },
                            Rotselleri: {
                                name: 'Rotselleri',
                                localizedName: 'Rotselleri',
                                desciption: '',
                            },
                            Rädisa: {
                                name: 'Rädisa',
                                localizedName: 'Rädisa',
                                desciption: '',
                            },
                            Rättika: {
                                name: 'Rättika',
                                localizedName: 'Rättika',
                                desciption: '',
                            },
                            Rödbeta: {
                                name: 'Rödbeta',
                                localizedName: 'Rödbeta',
                                desciption: '',
                            },
                            Sockerbeta: {
                                name: 'Sockerbeta',
                                localizedName: 'Sockerbeta',
                                desciption: '',
                            },
                            Svartrot: {
                                name: 'Svartrot',
                                localizedName: 'Svartrot',
                                desciption: '',
                            },
                            Sötpotatis: {
                                name: 'Sötpotatis',
                                localizedName: 'Sötpotatis',
                                desciption: '',
                            },
                            'Övrigt rotfrukt': {
                                name: 'Övrigt rotfrukt',
                                localizedName: 'Övrigt rotfrukt',
                                desciption: '',
                            },
                        },
                    },
                    Sallad: {
                        name: 'Sallad',
                        localizedName: 'Sallad',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            'Bulls blood': {
                                name: 'Bulls blood',
                                localizedName: 'Bulls blood',
                                desciption: '',
                            },
                            Crisp: {
                                name: 'Crisp',
                                localizedName: 'Crisp',
                                desciption: '',
                            },
                            Ekblad: {
                                name: 'Ekblad',
                                localizedName: 'Ekblad',
                                desciption: '',
                            },
                            Endive: {
                                name: 'Endive',
                                localizedName: 'Endive',
                                desciption: '',
                            },
                            Frisee: {
                                name: 'Frisee',
                                localizedName: 'Frisee',
                                desciption: '',
                            },
                            Huvudsallat: {
                                name: 'Huvudsallat',
                                localizedName: 'Huvudsallat',
                                desciption: '',
                            },
                            Isberg: {
                                name: 'Isberg',
                                localizedName: 'Isberg',
                                desciption: '',
                            },
                            'Lollo biondo': {
                                name: 'Lollo biondo',
                                localizedName: 'Lollo biondo',
                                desciption: '',
                            },
                            'Lollo rosso': {
                                name: 'Lollo rosso',
                                localizedName: 'Lollo rosso',
                                desciption: '',
                            },
                            Mache: {
                                name: 'Mache',
                                localizedName: 'Mache',
                                desciption: '',
                            },
                            Mangoldskott: {
                                name: 'Mangoldskott',
                                localizedName: 'Mangoldskott',
                                desciption: '',
                            },
                            Mizuna: {
                                name: 'Mizuna',
                                localizedName: 'Mizuna',
                                desciption: '',
                            },
                            Plocksallat: {
                                name: 'Plocksallat',
                                localizedName: 'Plocksallat',
                                desciption: '',
                            },
                            Roman: {
                                name: 'Roman',
                                localizedName: 'Roman',
                                desciption: '',
                            },
                            Rose: {
                                name: 'Rose',
                                localizedName: 'Rose',
                                desciption: '',
                            },
                            Ruccola: {
                                name: 'Ruccola',
                                localizedName: 'Ruccola',
                                desciption: '',
                            },
                            Senapsört: {
                                name: 'Senapsört',
                                localizedName: 'Senapsört',
                                desciption: '',
                            },
                            Tatsoi: {
                                name: 'Tatsoi',
                                localizedName: 'Tatsoi',
                                desciption: '',
                            },
                            'Övrigt sallad': {
                                name: 'Övrigt sallad',
                                localizedName: 'Övrigt sallad',
                                desciption: '',
                            },
                        },
                    },
                    Stenfrukt: {
                        name: 'Stenfrukt',
                        localizedName: 'Stenfrukt',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/cherry.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Aprikos: {
                                name: 'Aprikos',
                                localizedName: 'Aprikos',
                                desciption: '',
                            },
                            Körsbär: {
                                name: 'Körsbär',
                                localizedName: 'Körsbär',
                                desciption: '',
                            },
                            Nektarin: {
                                name: 'Nektarin',
                                localizedName: 'Nektarin',
                                desciption: '',
                            },
                            Persika: {
                                name: 'Persika',
                                localizedName: 'Persika',
                                desciption: '',
                            },
                            Plommon: {
                                name: 'Plommon',
                                localizedName: 'Plommon',
                                desciption: '',
                            },
                        },
                    },
                    Svamp: {
                        name: 'Svamp',
                        localizedName: 'Svamp',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/mushroom.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Champinjon: {
                                name: 'Champinjon',
                                localizedName: 'Champinjon',
                                desciption: '',
                            },
                            Kantarell: {
                                name: 'Kantarell',
                                localizedName: 'Kantarell',
                                desciption: '',
                            },
                            Karljohansvamp: {
                                name: 'Karljohansvamp',
                                localizedName: 'Karljohansvamp',
                                desciption: '',
                            },
                            Ostronskivling: {
                                name: 'Ostronskivling',
                                localizedName: 'Ostronskivling',
                                desciption: '',
                            },
                            Portabella: {
                                name: 'Portabella',
                                localizedName: 'Portabella',
                                desciption: '',
                            },
                            Shemeji: {
                                name: 'Shemeji',
                                localizedName: 'Shemeji',
                                desciption: '',
                            },
                            Shiitake: {
                                name: 'Shiitake',
                                localizedName: 'Shiitake',
                                desciption: '',
                            },
                            Svampmix: {
                                name: 'Svampmix',
                                localizedName: 'Svampmix',
                                desciption: '',
                            },
                            Tryffel: {
                                name: 'Tryffel',
                                localizedName: 'Tryffel',
                                desciption: '',
                            },
                            'Övrgit svamp': {
                                name: 'Övrgit svamp',
                                localizedName: 'Övrgit svamp',
                                desciption: '',
                            },
                        },
                    },
                    'Övrig frukt': {
                        name: 'Övrig frukt',
                        localizedName: 'Övrig frukt',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            container: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isVegan: null,
                        },
                        children: {
                            Druva: {
                                name: 'Druva',
                                localizedName: 'Druva',
                                desciption: '',
                            },
                            Päron: {
                                name: 'Päron',
                                localizedName: 'Päron',
                                desciption: '',
                            },
                            'Övrigt övrig frukt': {
                                name: 'Övrigt övrig frukt',
                                localizedName: 'Övrigt övrig frukt',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            Fågel: {
                name: 'Fågel',
                localizedName: 'Fågel',
                desciption: '',
                icon: 'https://assets.flaivy.com/chicken-bite.svg',
                immutableFields: {
                    container: null,
                    recycleType: null,
                    volume: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    systembolagetArticleNumber: null,
                    systembolagetSalesPrice: null,
                    knNumber: null,
                    exciseProductCode: null,
                    alcoholTaxPaid: null,
                    isVegan: null,
                    isGelatinFree: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                    isPalmOilFree: null,
                    isFoam: null,
                    isCoated: null,
                    isFudge: null,
                    isGelatinous: null,
                    isLiquorice: null,
                    isHardCandy: null,
                },
                children: {
                    Kyckling: {
                        name: 'Kyckling',
                        localizedName: 'Kyckling',
                        desciption: '',
                        children: {
                            Bitar: {
                                name: 'Bitar',
                                localizedName: 'Bitar',
                                desciption: '',
                            },
                            Bröstfilé: {
                                name: 'Bröstfilé',
                                localizedName: 'Bröstfilé',
                                desciption: '',
                            },
                            Drumstick: {
                                name: 'Drumstick',
                                localizedName: 'Drumstick',
                                desciption: '',
                            },
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Helfågel: {
                                name: 'Helfågel',
                                localizedName: 'Helfågel',
                                desciption: '',
                            },
                            Innerfilé: {
                                name: 'Innerfilé',
                                localizedName: 'Innerfilé',
                                desciption: '',
                            },
                            Kebab: {
                                name: 'Kebab',
                                localizedName: 'Kebab',
                                desciption: '',
                            },
                            Klubba: {
                                name: 'Klubba',
                                localizedName: 'Klubba',
                                desciption: '',
                            },
                            Kycklingkött: {
                                name: 'Kycklingkött',
                                localizedName: 'Kycklingkött',
                                desciption: '',
                            },
                            Lever: {
                                name: 'Lever',
                                localizedName: 'Lever',
                                desciption: '',
                            },
                            Lårfilé: {
                                name: 'Lårfilé',
                                localizedName: 'Lårfilé',
                                desciption: '',
                            },
                            Nuggets: {
                                name: 'Nuggets',
                                localizedName: 'Nuggets',
                                desciption: '',
                            },
                            Skinn: {
                                name: 'Skinn',
                                localizedName: 'Skinn',
                                desciption: '',
                            },
                            Skrov: {
                                name: 'Skrov',
                                localizedName: 'Skrov',
                                desciption: '',
                            },
                            Spett: {
                                name: 'Spett',
                                localizedName: 'Spett',
                                desciption: '',
                            },
                            Vinge: {
                                name: 'Vinge',
                                localizedName: 'Vinge',
                                desciption: '',
                            },
                            'Övrigt kyckling': {
                                name: 'Övrigt kyckling',
                                localizedName: 'Övrigt kyckling',
                                desciption: '',
                            },
                        },
                    },
                    Tamfågel: {
                        name: 'Tamfågel',
                        localizedName: 'Tamfågel',
                        desciption: '',
                        children: {
                            Ankfett: {
                                name: 'Ankfett',
                                localizedName: 'Ankfett',
                                desciption: '',
                            },
                            Bacon: {
                                name: 'Bacon',
                                localizedName: 'Bacon',
                                desciption: '',
                            },
                            Blod: {
                                name: 'Blod',
                                localizedName: 'Blod',
                                desciption: '',
                            },
                            Bröstfilé: {
                                name: 'Bröstfilé',
                                localizedName: 'Bröstfilé',
                                desciption: '',
                            },
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Helfågel: {
                                name: 'Helfågel',
                                localizedName: 'Helfågel',
                                desciption: '',
                            },
                            Lever: {
                                name: 'Lever',
                                localizedName: 'Lever',
                                desciption: '',
                            },
                            Lårfilé: {
                                name: 'Lårfilé',
                                localizedName: 'Lårfilé',
                                desciption: '',
                            },
                        },
                    },
                    Vilt: {
                        name: 'Vilt',
                        localizedName: 'Vilt',
                        desciption: '',
                        children: {
                            Bröst: {
                                name: 'Bröst',
                                localizedName: 'Bröst',
                                desciption: '',
                            },
                            Bröstfilé: {
                                name: 'Bröstfilé',
                                localizedName: 'Bröstfilé',
                                desciption: '',
                            },
                            Filé: {
                                name: 'Filé',
                                localizedName: 'Filé',
                                desciption: '',
                            },
                            Grytbitar: {
                                name: 'Grytbitar',
                                localizedName: 'Grytbitar',
                                desciption: '',
                            },
                            Helfågel: {
                                name: 'Helfågel',
                                localizedName: 'Helfågel',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            Färdigmat: {
                name: 'Färdigmat',
                localizedName: 'Färdigmat',
                desciption: '',
                icon: 'https://assets.flaivy.com/pizza, fast food, junk food, slice, food, meal.svg',
                immutableFields: {
                    recycleType: null,
                    goesWith: null,
                    isSugarFree: null,
                    isFoam: null,
                    isCoated: null,
                    isFudge: null,
                    isGelatinous: null,
                    isLiquorice: null,
                    isHardCandy: null,
                },
                children: {
                    'Burgare, köttbullar & biffar mm': {
                        name: 'Burgare, köttbullar & biffar mm',
                        localizedName: 'Burgare, köttbullar & biffar mm',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/burger.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Biffar: {
                                name: 'Biffar',
                                localizedName: 'Biffar',
                                desciption: '',
                            },
                            Burgare: {
                                name: 'Burgare',
                                localizedName: 'Burgare',
                                desciption: '',
                            },
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Järpar: {
                                name: 'Järpar',
                                localizedName: 'Järpar',
                                desciption: '',
                            },
                            Köttbulle: {
                                name: 'Köttbulle',
                                localizedName: 'Köttbulle',
                                desciption: '',
                            },
                            'Övrigt burgare, köttbullar & biffar mm': {
                                name: 'Övrigt burgare, köttbullar & biffar mm',
                                localizedName: 'Övrigt burgare, köttbullar & biffar mm',
                                desciption: '',
                            },
                        },
                    },
                    Fastfood: {
                        name: 'Fastfood',
                        localizedName: 'Fastfood',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Gyros: {
                                name: 'Gyros',
                                localizedName: 'Gyros',
                                desciption: '',
                            },
                            Kebab: {
                                name: 'Kebab',
                                localizedName: 'Kebab',
                                desciption: '',
                            },
                            Nuggets: {
                                name: 'Nuggets',
                                localizedName: 'Nuggets',
                                desciption: '',
                            },
                            Pulled: {
                                name: 'Pulled',
                                localizedName: 'Pulled',
                                desciption: '',
                            },
                            'Övrigt fastfood': {
                                name: 'Övrigt fastfood',
                                localizedName: 'Övrigt fastfood',
                                desciption: '',
                            },
                        },
                    },
                    Fingerfood: {
                        name: 'Fingerfood',
                        localizedName: 'Fingerfood',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            'Cheese bites': {
                                name: 'Cheese bites',
                                localizedName: 'Cheese bites',
                                desciption: '',
                            },
                            'Chicken fingers': {
                                name: 'Chicken fingers',
                                localizedName: 'Chicken fingers',
                                desciption: '',
                            },
                            Churros: {
                                name: 'Churros',
                                localizedName: 'Churros',
                                desciption: '',
                            },
                            Lökringar: {
                                name: 'Lökringar',
                                localizedName: 'Lökringar',
                                desciption: '',
                            },
                            'Övrigt fingerfood': {
                                name: 'Övrigt fingerfood',
                                localizedName: 'Övrigt fingerfood',
                                desciption: '',
                            },
                        },
                    },
                    'Färdigmat, 1-portion': {
                        name: 'Färdigmat, 1-portion',
                        localizedName: 'Färdigmat, 1-portion',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Fläsk: {
                                name: 'Fläsk',
                                localizedName: 'Fläsk',
                                desciption: '',
                            },
                            Korv: {
                                name: 'Korv',
                                localizedName: 'Korv',
                                desciption: '',
                            },
                            Kyckling: {
                                name: 'Kyckling',
                                localizedName: 'Kyckling',
                                desciption: '',
                            },
                            Köttbulle: {
                                name: 'Köttbulle',
                                localizedName: 'Köttbulle',
                                desciption: '',
                            },
                            Lasagne: {
                                name: 'Lasagne',
                                localizedName: 'Lasagne',
                                desciption: '',
                            },
                            Nöt: {
                                name: 'Nöt',
                                localizedName: 'Nöt',
                                desciption: '',
                            },
                            Pizza: {
                                name: 'Pizza',
                                localizedName: 'Pizza',
                                desciption: '',
                            },
                            Soppa: {
                                name: 'Soppa',
                                localizedName: 'Soppa',
                                desciption: '',
                            },
                            Vegetarisk: {
                                name: 'Vegetarisk',
                                localizedName: 'Vegetarisk',
                                desciption: '',
                            },
                            'Övrigt färdigmat, 1-portion': {
                                name: 'Övrigt färdigmat, 1-portion',
                                localizedName: 'Övrigt färdigmat, 1-portion',
                                desciption: '',
                            },
                        },
                    },
                    'Gratäng, pudding & pytt': {
                        name: 'Gratäng, pudding & pytt',
                        localizedName: 'Gratäng, pudding & pytt',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Gratäng: {
                                name: 'Gratäng',
                                localizedName: 'Gratäng',
                                desciption: '',
                            },
                            Pudding: {
                                name: 'Pudding',
                                localizedName: 'Pudding',
                                desciption: '',
                            },
                            Pytt: {
                                name: 'Pytt',
                                localizedName: 'Pytt',
                                desciption: '',
                            },
                        },
                    },
                    'Kroppkaka & palt': {
                        name: 'Kroppkaka & palt',
                        localizedName: 'Kroppkaka & palt',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Kroppkaka: {
                                name: 'Kroppkaka',
                                localizedName: 'Kroppkaka',
                                desciption: '',
                            },
                            Palt: {
                                name: 'Palt',
                                localizedName: 'Palt',
                                desciption: '',
                            },
                        },
                    },
                    'Pannkakor, plättar & våfflor': {
                        name: 'Pannkakor, plättar & våfflor',
                        localizedName: 'Pannkakor, plättar & våfflor',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/pancakes.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Crepes: {
                                name: 'Crepes',
                                localizedName: 'Crepes',
                                desciption: '',
                            },
                            Pannkakor: {
                                name: 'Pannkakor',
                                localizedName: 'Pannkakor',
                                desciption: '',
                            },
                            Plätt: {
                                name: 'Plätt',
                                localizedName: 'Plätt',
                                desciption: '',
                            },
                            Ugnspannkaka: {
                                name: 'Ugnspannkaka',
                                localizedName: 'Ugnspannkaka',
                                desciption: '',
                            },
                            Våffla: {
                                name: 'Våffla',
                                localizedName: 'Våffla',
                                desciption: '',
                            },
                            Äggkaka: {
                                name: 'Äggkaka',
                                localizedName: 'Äggkaka',
                                desciption: '',
                            },
                        },
                    },
                    'Pasta & nudelrätter': {
                        name: 'Pasta & nudelrätter',
                        localizedName: 'Pasta & nudelrätter',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/noodles, spaghetti, fork, meal, dinner, plate.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Lasagne: {
                                name: 'Lasagne',
                                localizedName: 'Lasagne',
                                desciption: '',
                            },
                            Tortelloni: {
                                name: 'Tortelloni',
                                localizedName: 'Tortelloni',
                                desciption: '',
                            },
                            'Övrigt pasta & nudelrätter': {
                                name: 'Övrigt pasta & nudelrätter',
                                localizedName: 'Övrigt pasta & nudelrätter',
                                desciption: '',
                            },
                        },
                    },
                    'Pizza, pirog, mackor & matpaj': {
                        name: 'Pizza, pirog, mackor & matpaj',
                        localizedName: 'Pizza, pirog, mackor & matpaj',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Burrito: {
                                name: 'Burrito',
                                localizedName: 'Burrito',
                                desciption: '',
                            },
                            Dumpling: {
                                name: 'Dumpling',
                                localizedName: 'Dumpling',
                                desciption: '',
                            },
                            Macka: {
                                name: 'Macka',
                                localizedName: 'Macka',
                                desciption: '',
                            },
                            Matpaj: {
                                name: 'Matpaj',
                                localizedName: 'Matpaj',
                                desciption: '',
                            },
                            'Naan bröd': {
                                name: 'Naan bröd',
                                localizedName: 'Naan bröd',
                                desciption: '',
                            },
                            Panini: {
                                name: 'Panini',
                                localizedName: 'Panini',
                                desciption: '',
                            },
                            Pirog: {
                                name: 'Pirog',
                                localizedName: 'Pirog',
                                desciption: '',
                            },
                            Pizza: {
                                name: 'Pizza',
                                localizedName: 'Pizza',
                                desciption: '',
                            },
                            Samosas: {
                                name: 'Samosas',
                                localizedName: 'Samosas',
                                desciption: '',
                            },
                            Smördeg: {
                                name: 'Smördeg',
                                localizedName: 'Smördeg',
                                desciption: '',
                            },
                            Tortillabröd: {
                                name: 'Tortillabröd',
                                localizedName: 'Tortillabröd',
                                desciption: '',
                            },
                            Vårrulle: {
                                name: 'Vårrulle',
                                localizedName: 'Vårrulle',
                                desciption: '',
                            },
                            'Övrigt pizza, pirog, mackor & matpaj': {
                                name: 'Övrigt pizza, pirog, mackor & matpaj',
                                localizedName: 'Övrigt pizza, pirog, mackor & matpaj',
                                desciption: '',
                            },
                        },
                    },
                    'Schnitzel mm': {
                        name: 'Schnitzel mm',
                        localizedName: 'Schnitzel mm',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                    },
                    Soppor: {
                        name: 'Soppor',
                        localizedName: 'Soppor',
                        desciption: '',
                        children: {
                            Blomkålsoppa: {
                                name: 'Blomkålsoppa',
                                localizedName: 'Blomkålsoppa',
                                desciption: '',
                            },
                            Broccolisoppa: {
                                name: 'Broccolisoppa',
                                localizedName: 'Broccolisoppa',
                                desciption: '',
                            },
                            Champinjonsoppa: {
                                name: 'Champinjonsoppa',
                                localizedName: 'Champinjonsoppa',
                                desciption: '',
                            },
                            Fisksoppa: {
                                name: 'Fisksoppa',
                                localizedName: 'Fisksoppa',
                                desciption: '',
                            },
                            Grönsakssoppa: {
                                name: 'Grönsakssoppa',
                                localizedName: 'Grönsakssoppa',
                                desciption: '',
                            },
                            Gulaschsoppa: {
                                name: 'Gulaschsoppa',
                                localizedName: 'Gulaschsoppa',
                                desciption: '',
                            },
                            'Indisk soppa': {
                                name: 'Indisk soppa',
                                localizedName: 'Indisk soppa',
                                desciption: '',
                            },
                            Kycklingsoppa: {
                                name: 'Kycklingsoppa',
                                localizedName: 'Kycklingsoppa',
                                desciption: '',
                            },
                            Köttsoppa: {
                                name: 'Köttsoppa',
                                localizedName: 'Köttsoppa',
                                desciption: '',
                            },
                            Minestronisoppa: {
                                name: 'Minestronisoppa',
                                localizedName: 'Minestronisoppa',
                                desciption: '',
                            },
                            'Ost broccolisoppa': {
                                name: 'Ost broccolisoppa',
                                localizedName: 'Ost broccolisoppa',
                                desciption: '',
                            },
                            'Potatis purjolöksoppa': {
                                name: 'Potatis purjolöksoppa',
                                localizedName: 'Potatis purjolöksoppa',
                                desciption: '',
                            },
                            Räksoppa: {
                                name: 'Räksoppa',
                                localizedName: 'Räksoppa',
                                desciption: '',
                            },
                            Sparrissoppa: {
                                name: 'Sparrissoppa',
                                localizedName: 'Sparrissoppa',
                                desciption: '',
                            },
                            Svampsoppa: {
                                name: 'Svampsoppa',
                                localizedName: 'Svampsoppa',
                                desciption: '',
                            },
                            'Thai soppa': {
                                name: 'Thai soppa',
                                localizedName: 'Thai soppa',
                                desciption: '',
                            },
                            Tomatsoppa: {
                                name: 'Tomatsoppa',
                                localizedName: 'Tomatsoppa',
                                desciption: '',
                            },
                            Ärtsoppa: {
                                name: 'Ärtsoppa',
                                localizedName: 'Ärtsoppa',
                                desciption: '',
                            },
                            'Övrigt fryst': {
                                name: 'Övrigt fryst',
                                localizedName: 'Övrigt fryst',
                                desciption: '',
                            },
                        },
                    },
                    'Timbaler & pate mm': {
                        name: 'Timbaler & pate mm',
                        localizedName: 'Timbaler & pate mm',
                        desciption: '',
                        immutableFields: {
                            volume: null,
                        },
                        children: {
                            Paté: {
                                name: 'Paté',
                                localizedName: 'Paté',
                                desciption: '',
                            },
                            Puré: {
                                name: 'Puré',
                                localizedName: 'Puré',
                                desciption: '',
                            },
                            Timbal: {
                                name: 'Timbal',
                                localizedName: 'Timbal',
                                desciption: '',
                            },
                        },
                    },
                    'Vegetariska rätter': {
                        name: 'Vegetariska rätter',
                        localizedName: 'Vegetariska rätter',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/boriito, sandwich, food, meal, take out, fast food, junk food.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Beat: {
                                name: 'Beat',
                                localizedName: 'Beat',
                                desciption: '',
                            },
                            Biffar: {
                                name: 'Biffar',
                                localizedName: 'Biffar',
                                desciption: '',
                            },
                            Bitar: {
                                name: 'Bitar',
                                localizedName: 'Bitar',
                                desciption: '',
                            },
                            Bullar: {
                                name: 'Bullar',
                                localizedName: 'Bullar',
                                desciption: '',
                            },
                            Burgare: {
                                name: 'Burgare',
                                localizedName: 'Burgare',
                                desciption: '',
                            },
                            Falafel: {
                                name: 'Falafel',
                                localizedName: 'Falafel',
                                desciption: '',
                            },
                            Filé: {
                                name: 'Filé',
                                localizedName: 'Filé',
                                desciption: '',
                            },
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Gratäng: {
                                name: 'Gratäng',
                                localizedName: 'Gratäng',
                                desciption: '',
                            },
                            Kebab: {
                                name: 'Kebab',
                                localizedName: 'Kebab',
                                desciption: '',
                            },
                            Korv: {
                                name: 'Korv',
                                localizedName: 'Korv',
                                desciption: '',
                            },
                            Köttbulle: {
                                name: 'Köttbulle',
                                localizedName: 'Köttbulle',
                                desciption: '',
                            },
                            Lasagne: {
                                name: 'Lasagne',
                                localizedName: 'Lasagne',
                                desciption: '',
                            },
                            Nuggets: {
                                name: 'Nuggets',
                                localizedName: 'Nuggets',
                                desciption: '',
                            },
                            Plättar: {
                                name: 'Plättar',
                                localizedName: 'Plättar',
                                desciption: '',
                            },
                            Pulled: {
                                name: 'Pulled',
                                localizedName: 'Pulled',
                                desciption: '',
                            },
                            Pytt: {
                                name: 'Pytt',
                                localizedName: 'Pytt',
                                desciption: '',
                            },
                            Schnitzel: {
                                name: 'Schnitzel',
                                localizedName: 'Schnitzel',
                                desciption: '',
                            },
                            Strimlor: {
                                name: 'Strimlor',
                                localizedName: 'Strimlor',
                                desciption: '',
                            },
                            'Övrigt vegetariska rätter': {
                                name: 'Övrigt vegetariska rätter',
                                localizedName: 'Övrigt vegetariska rätter',
                                desciption: '',
                            },
                        },
                    },
                    'Övrig färdigmat': {
                        name: 'Övrig färdigmat',
                        localizedName: 'Övrig färdigmat',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Fiskrätter: {
                                name: 'Fiskrätter',
                                localizedName: 'Fiskrätter',
                                desciption: '',
                            },
                            Frikadell: {
                                name: 'Frikadell',
                                localizedName: 'Frikadell',
                                desciption: '',
                            },
                            Gnocchi: {
                                name: 'Gnocchi',
                                localizedName: 'Gnocchi',
                                desciption: '',
                            },
                            Gryta: {
                                name: 'Gryta',
                                localizedName: 'Gryta',
                                desciption: '',
                            },
                            Gröt: {
                                name: 'Gröt',
                                localizedName: 'Gröt',
                                desciption: '',
                            },
                            Guacamole: {
                                name: 'Guacamole',
                                localizedName: 'Guacamole',
                                desciption: '',
                            },
                            Kåldolmar: {
                                name: 'Kåldolmar',
                                localizedName: 'Kåldolmar',
                                desciption: '',
                            },
                            Lappskojskött: {
                                name: 'Lappskojskött',
                                localizedName: 'Lappskojskött',
                                desciption: '',
                            },
                            Pölsa: {
                                name: 'Pölsa',
                                localizedName: 'Pölsa',
                                desciption: '',
                            },
                            'Ris á la malta': {
                                name: 'Ris á la malta',
                                localizedName: 'Ris á la malta',
                                desciption: '',
                            },
                            'Övrigt övrig färdigmat': {
                                name: 'Övrigt övrig färdigmat',
                                localizedName: 'Övrigt övrig färdigmat',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            Kött: {
                name: 'Kött',
                localizedName: 'Kött',
                desciption: '',
                icon: 'https://assets.flaivy.com/steak.svg',
                immutableFields: {
                    recycleType: null,
                    volume: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    systembolagetArticleNumber: null,
                    systembolagetSalesPrice: null,
                    knNumber: null,
                    exciseProductCode: null,
                    alcoholTaxPaid: null,
                    isVegan: null,
                    isGelatinFree: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                    isPalmOilFree: null,
                    isFoam: null,
                    isCoated: null,
                    isFudge: null,
                    isGelatinous: null,
                    isLiquorice: null,
                    isHardCandy: null,
                },
                children: {
                    Fläskkött: {
                        name: 'Fläskkött',
                        localizedName: 'Fläskkött',
                        desciption: '',
                        children: {
                            Ben: {
                                name: 'Ben',
                                localizedName: 'Ben',
                                desciption: '',
                            },
                            Blod: {
                                name: 'Blod',
                                localizedName: 'Blod',
                                desciption: '',
                            },
                            Bog: {
                                name: 'Bog',
                                localizedName: 'Bog',
                                desciption: '',
                            },
                            Filé: {
                                name: 'Filé',
                                localizedName: 'Filé',
                                desciption: '',
                            },
                            Fjälster: {
                                name: 'Fjälster',
                                localizedName: 'Fjälster',
                                desciption: '',
                            },
                            Fot: {
                                name: 'Fot',
                                localizedName: 'Fot',
                                desciption: '',
                            },
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Färskött: {
                                name: 'Färskött',
                                localizedName: 'Färskött',
                                desciption: '',
                            },
                            Hel: {
                                name: 'Hel',
                                localizedName: 'Hel',
                                desciption: '',
                            },
                            Hjärta: {
                                name: 'Hjärta',
                                localizedName: 'Hjärta',
                                desciption: '',
                            },
                            Huvud: {
                                name: 'Huvud',
                                localizedName: 'Huvud',
                                desciption: '',
                            },
                            Iberico: {
                                name: 'Iberico',
                                localizedName: 'Iberico',
                                desciption: '',
                            },
                            Karré: {
                                name: 'Karré',
                                localizedName: 'Karré',
                                desciption: '',
                            },
                            Kind: {
                                name: 'Kind',
                                localizedName: 'Kind',
                                desciption: '',
                            },
                            Kotlettrad: {
                                name: 'Kotlettrad',
                                localizedName: 'Kotlettrad',
                                desciption: '',
                            },
                            Lever: {
                                name: 'Lever',
                                localizedName: 'Lever',
                                desciption: '',
                            },
                            Lägg: {
                                name: 'Lägg',
                                localizedName: 'Lägg',
                                desciption: '',
                            },
                            Pluma: {
                                name: 'Pluma',
                                localizedName: 'Pluma',
                                desciption: '',
                            },
                            Racks: {
                                name: 'Racks',
                                localizedName: 'Racks',
                                desciption: '',
                            },
                            Revben: {
                                name: 'Revben',
                                localizedName: 'Revben',
                                desciption: '',
                            },
                            Rygg: {
                                name: 'Rygg',
                                localizedName: 'Rygg',
                                desciption: '',
                            },
                            Secreto: {
                                name: 'Secreto',
                                localizedName: 'Secreto',
                                desciption: '',
                            },
                            Sida: {
                                name: 'Sida',
                                localizedName: 'Sida',
                                desciption: '',
                            },
                            Skinkstek: {
                                name: 'Skinkstek',
                                localizedName: 'Skinkstek',
                                desciption: '',
                            },
                            Sofilé: {
                                name: 'Sofilé',
                                localizedName: 'Sofilé',
                                desciption: '',
                            },
                            Späck: {
                                name: 'Späck',
                                localizedName: 'Späck',
                                desciption: '',
                            },
                            Spädgris: {
                                name: 'Spädgris',
                                localizedName: 'Spädgris',
                                desciption: '',
                            },
                            Stek: {
                                name: 'Stek',
                                localizedName: 'Stek',
                                desciption: '',
                            },
                            Svål: {
                                name: 'Svål',
                                localizedName: 'Svål',
                                desciption: '',
                            },
                            Ytterfilé: {
                                name: 'Ytterfilé',
                                localizedName: 'Ytterfilé',
                                desciption: '',
                            },
                            Öron: {
                                name: 'Öron',
                                localizedName: 'Öron',
                                desciption: '',
                            },
                            'Övrigt fläskkött': {
                                name: 'Övrigt fläskkött',
                                localizedName: 'Övrigt fläskkött',
                                desciption: '',
                            },
                        },
                    },
                    Lammkött: {
                        name: 'Lammkött',
                        localizedName: 'Lammkött',
                        desciption: '',
                        children: {
                            Ben: {
                                name: 'Ben',
                                localizedName: 'Ben',
                                desciption: '',
                            },
                            Bog: {
                                name: 'Bog',
                                localizedName: 'Bog',
                                desciption: '',
                            },
                            Box: {
                                name: 'Box',
                                localizedName: 'Box',
                                desciption: '',
                            },
                            Entrecote: {
                                name: 'Entrecote',
                                localizedName: 'Entrecote',
                                desciption: '',
                            },
                            Fjälster: {
                                name: 'Fjälster',
                                localizedName: 'Fjälster',
                                desciption: '',
                            },
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Hel: {
                                name: 'Hel',
                                localizedName: 'Hel',
                                desciption: '',
                            },
                            Innerfilé: {
                                name: 'Innerfilé',
                                localizedName: 'Innerfilé',
                                desciption: '',
                            },
                            Kotlett: {
                                name: 'Kotlett',
                                localizedName: 'Kotlett',
                                desciption: '',
                            },
                            Lägg: {
                                name: 'Lägg',
                                localizedName: 'Lägg',
                                desciption: '',
                            },
                            Racks: {
                                name: 'Racks',
                                localizedName: 'Racks',
                                desciption: '',
                            },
                            Rostbiff: {
                                name: 'Rostbiff',
                                localizedName: 'Rostbiff',
                                desciption: '',
                            },
                            Sadel: {
                                name: 'Sadel',
                                localizedName: 'Sadel',
                                desciption: '',
                            },
                            Stek: {
                                name: 'Stek',
                                localizedName: 'Stek',
                                desciption: '',
                            },
                            Tunnbringa: {
                                name: 'Tunnbringa',
                                localizedName: 'Tunnbringa',
                                desciption: '',
                            },
                            Ytterfilé: {
                                name: 'Ytterfilé',
                                localizedName: 'Ytterfilé',
                                desciption: '',
                            },
                            'Övrigt lammkött': {
                                name: 'Övrigt lammkött',
                                localizedName: 'Övrigt lammkött',
                                desciption: '',
                            },
                        },
                    },
                    'Nöt- & fläskkött': {
                        name: 'Nöt- & fläskkött',
                        localizedName: 'Nöt- & fläskkött',
                        desciption: '',
                        children: {
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Lever: {
                                name: 'Lever',
                                localizedName: 'Lever',
                                desciption: '',
                            },
                            Pyttkött: {
                                name: 'Pyttkött',
                                localizedName: 'Pyttkött',
                                desciption: '',
                            },
                        },
                    },
                    Nötkött: {
                        name: 'Nötkött',
                        localizedName: 'Nötkött',
                        desciption: '',
                        children: {
                            Ben: {
                                name: 'Ben',
                                localizedName: 'Ben',
                                desciption: '',
                            },
                            Biff: {
                                name: 'Biff',
                                localizedName: 'Biff',
                                desciption: '',
                            },
                            Blod: {
                                name: 'Blod',
                                localizedName: 'Blod',
                                desciption: '',
                            },
                            Bog: {
                                name: 'Bog',
                                localizedName: 'Bog',
                                desciption: '',
                            },
                            Bringa: {
                                name: 'Bringa',
                                localizedName: 'Bringa',
                                desciption: '',
                            },
                            Bräss: {
                                name: 'Bräss',
                                localizedName: 'Bräss',
                                desciption: '',
                            },
                            Carpaccio: {
                                name: 'Carpaccio',
                                localizedName: 'Carpaccio',
                                desciption: '',
                            },
                            Entrecote: {
                                name: 'Entrecote',
                                localizedName: 'Entrecote',
                                desciption: '',
                            },
                            Filé: {
                                name: 'Filé',
                                localizedName: 'Filé',
                                desciption: '',
                            },
                            Flankstek: {
                                name: 'Flankstek',
                                localizedName: 'Flankstek',
                                desciption: '',
                            },
                            Flapmeat: {
                                name: 'Flapmeat',
                                localizedName: 'Flapmeat',
                                desciption: '',
                            },
                            Fransyska: {
                                name: 'Fransyska',
                                localizedName: 'Fransyska',
                                desciption: '',
                            },
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Färskött: {
                                name: 'Färskött',
                                localizedName: 'Färskött',
                                desciption: '',
                            },
                            Högrev: {
                                name: 'Högrev',
                                localizedName: 'Högrev',
                                desciption: '',
                            },
                            Högrevshjärta: {
                                name: 'Högrevshjärta',
                                localizedName: 'Högrevshjärta',
                                desciption: '',
                            },
                            Innanlår: {
                                name: 'Innanlår',
                                localizedName: 'Innanlår',
                                desciption: '',
                            },
                            Innerfilé: {
                                name: 'Innerfilé',
                                localizedName: 'Innerfilé',
                                desciption: '',
                            },
                            Kind: {
                                name: 'Kind',
                                localizedName: 'Kind',
                                desciption: '',
                            },
                            Kotlett: {
                                name: 'Kotlett',
                                localizedName: 'Kotlett',
                                desciption: '',
                            },
                            Lever: {
                                name: 'Lever',
                                localizedName: 'Lever',
                                desciption: '',
                            },
                            Lägg: {
                                name: 'Lägg',
                                localizedName: 'Lägg',
                                desciption: '',
                            },
                            Löv: {
                                name: 'Löv',
                                localizedName: 'Löv',
                                desciption: '',
                            },
                            Märg: {
                                name: 'Märg',
                                localizedName: 'Märg',
                                desciption: '',
                            },
                            Märgben: {
                                name: 'Märgben',
                                localizedName: 'Märgben',
                                desciption: '',
                            },
                            Njure: {
                                name: 'Njure',
                                localizedName: 'Njure',
                                desciption: '',
                            },
                            Njurtapp: {
                                name: 'Njurtapp',
                                localizedName: 'Njurtapp',
                                desciption: '',
                            },
                            Nötbit: {
                                name: 'Nötbit',
                                localizedName: 'Nötbit',
                                desciption: '',
                            },
                            Racks: {
                                name: 'Racks',
                                localizedName: 'Racks',
                                desciption: '',
                            },
                            Revben: {
                                name: 'Revben',
                                localizedName: 'Revben',
                                desciption: '',
                            },
                            Rostas: {
                                name: 'Rostas',
                                localizedName: 'Rostas',
                                desciption: '',
                            },
                            Rostbiff: {
                                name: 'Rostbiff',
                                localizedName: 'Rostbiff',
                                desciption: '',
                            },
                            Rostlock: {
                                name: 'Rostlock',
                                localizedName: 'Rostlock',
                                desciption: '',
                            },
                            Rulle: {
                                name: 'Rulle',
                                localizedName: 'Rulle',
                                desciption: '',
                            },
                            Rumpstek: {
                                name: 'Rumpstek',
                                localizedName: 'Rumpstek',
                                desciption: '',
                            },
                            Skav: {
                                name: 'Skav',
                                localizedName: 'Skav',
                                desciption: '',
                            },
                            Stek: {
                                name: 'Stek',
                                localizedName: 'Stek',
                                desciption: '',
                            },
                            Svans: {
                                name: 'Svans',
                                localizedName: 'Svans',
                                desciption: '',
                            },
                            Talg: {
                                name: 'Talg',
                                localizedName: 'Talg',
                                desciption: '',
                            },
                            'T-bone': {
                                name: 'T-bone',
                                localizedName: 'T-bone',
                                desciption: '',
                            },
                            Tenderstrip: {
                                name: 'Tenderstrip',
                                localizedName: 'Tenderstrip',
                                desciption: '',
                            },
                            Tomahawk: {
                                name: 'Tomahawk',
                                localizedName: 'Tomahawk',
                                desciption: '',
                            },
                            'Top blade': {
                                name: 'Top blade',
                                localizedName: 'Top blade',
                                desciption: '',
                            },
                            Tunga: {
                                name: 'Tunga',
                                localizedName: 'Tunga',
                                desciption: '',
                            },
                            Ytterfilé: {
                                name: 'Ytterfilé',
                                localizedName: 'Ytterfilé',
                                desciption: '',
                            },
                            Ytterlår: {
                                name: 'Ytterlår',
                                localizedName: 'Ytterlår',
                                desciption: '',
                            },
                            'Övrigt nötkött': {
                                name: 'Övrigt nötkött',
                                localizedName: 'Övrigt nötkött',
                                desciption: '',
                            },
                        },
                    },
                    Vilt: {
                        name: 'Vilt',
                        localizedName: 'Vilt',
                        desciption: '',
                        children: {
                            Ben: {
                                name: 'Ben',
                                localizedName: 'Ben',
                                desciption: '',
                            },
                            Blod: {
                                name: 'Blod',
                                localizedName: 'Blod',
                                desciption: '',
                            },
                            Bog: {
                                name: 'Bog',
                                localizedName: 'Bog',
                                desciption: '',
                            },
                            Carpaccio: {
                                name: 'Carpaccio',
                                localizedName: 'Carpaccio',
                                desciption: '',
                            },
                            Entrecote: {
                                name: 'Entrecote',
                                localizedName: 'Entrecote',
                                desciption: '',
                            },
                            Filé: {
                                name: 'Filé',
                                localizedName: 'Filé',
                                desciption: '',
                            },
                            Fransyska: {
                                name: 'Fransyska',
                                localizedName: 'Fransyska',
                                desciption: '',
                            },
                            Färs: {
                                name: 'Färs',
                                localizedName: 'Färs',
                                desciption: '',
                            },
                            Grodlår: {
                                name: 'Grodlår',
                                localizedName: 'Grodlår',
                                desciption: '',
                            },
                            Grytbitar: {
                                name: 'Grytbitar',
                                localizedName: 'Grytbitar',
                                desciption: '',
                            },
                            Hel: {
                                name: 'Hel',
                                localizedName: 'Hel',
                                desciption: '',
                            },
                            Hjärta: {
                                name: 'Hjärta',
                                localizedName: 'Hjärta',
                                desciption: '',
                            },
                            Högrev: {
                                name: 'Högrev',
                                localizedName: 'Högrev',
                                desciption: '',
                            },
                            Innanlår: {
                                name: 'Innanlår',
                                localizedName: 'Innanlår',
                                desciption: '',
                            },
                            Innerfilé: {
                                name: 'Innerfilé',
                                localizedName: 'Innerfilé',
                                desciption: '',
                            },
                            Karré: {
                                name: 'Karré',
                                localizedName: 'Karré',
                                desciption: '',
                            },
                            Lår: {
                                name: 'Lår',
                                localizedName: 'Lår',
                                desciption: '',
                            },
                            Lägg: {
                                name: 'Lägg',
                                localizedName: 'Lägg',
                                desciption: '',
                            },
                            Racks: {
                                name: 'Racks',
                                localizedName: 'Racks',
                                desciption: '',
                            },
                            Revben: {
                                name: 'Revben',
                                localizedName: 'Revben',
                                desciption: '',
                            },
                            Rostbiff: {
                                name: 'Rostbiff',
                                localizedName: 'Rostbiff',
                                desciption: '',
                            },
                            Sadel: {
                                name: 'Sadel',
                                localizedName: 'Sadel',
                                desciption: '',
                            },
                            Sida: {
                                name: 'Sida',
                                localizedName: 'Sida',
                                desciption: '',
                            },
                            Skav: {
                                name: 'Skav',
                                localizedName: 'Skav',
                                desciption: '',
                            },
                            Souvas: {
                                name: 'Souvas',
                                localizedName: 'Souvas',
                                desciption: '',
                            },
                            Stek: {
                                name: 'Stek',
                                localizedName: 'Stek',
                                desciption: '',
                            },
                            Torkat: {
                                name: 'Torkat',
                                localizedName: 'Torkat',
                                desciption: '',
                            },
                            'Tri-tip': {
                                name: 'Tri-tip',
                                localizedName: 'Tri-tip',
                                desciption: '',
                            },
                            Tunga: {
                                name: 'Tunga',
                                localizedName: 'Tunga',
                                desciption: '',
                            },
                            Ytterfilé: {
                                name: 'Ytterfilé',
                                localizedName: 'Ytterfilé',
                                desciption: '',
                            },
                            Ytterlår: {
                                name: 'Ytterlår',
                                localizedName: 'Ytterlår',
                                desciption: '',
                            },
                            'Övrigt vilt': {
                                name: 'Övrigt vilt',
                                localizedName: 'Övrigt vilt',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Ost, mejeri & ägg': {
                name: 'Ost, mejeri & ägg',
                localizedName: 'Ost, mejeri & ägg',
                desciption: '',
                icon: 'https://assets.flaivy.com/cheese.svg',
                immutableFields: {
                    recycleType: null,
                    isVegan: null,
                    isGelatinFree: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                    isPalmOilFree: null,
                    isFrozen: null,
                    isFoam: null,
                    isCoated: null,
                    isFudge: null,
                    isGelatinous: null,
                    isLiquorice: null,
                    isHardCandy: null,
                },
                children: {
                    Dressing: {
                        name: 'Dressing',
                        localizedName: 'Dressing',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/sauce, ketchup, mustard, taste, food.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Ceasardressing: {
                                name: 'Ceasardressing',
                                localizedName: 'Ceasardressing',
                                desciption: '',
                            },
                            Chilidressing: {
                                name: 'Chilidressing',
                                localizedName: 'Chilidressing',
                                desciption: '',
                            },
                            Coleslaw: {
                                name: 'Coleslaw',
                                localizedName: 'Coleslaw',
                                desciption: '',
                            },
                            'Creme fraiche': {
                                name: 'Creme fraiche',
                                localizedName: 'Creme fraiche',
                                desciption: '',
                            },
                            Currydressing: {
                                name: 'Currydressing',
                                localizedName: 'Currydressing',
                                desciption: '',
                            },
                            Drerssingmix: {
                                name: 'Drerssingmix',
                                localizedName: 'Drerssingmix',
                                desciption: '',
                            },
                            'Fransk dressing': {
                                name: 'Fransk dressing',
                                localizedName: 'Fransk dressing',
                                desciption: '',
                            },
                            'Green onion': {
                                name: 'Green onion',
                                localizedName: 'Green onion',
                                desciption: '',
                            },
                            Hamburgerdressing: {
                                name: 'Hamburgerdressing',
                                localizedName: 'Hamburgerdressing',
                                desciption: '',
                            },
                            Kebabsås: {
                                name: 'Kebabsås',
                                localizedName: 'Kebabsås',
                                desciption: '',
                            },
                            'Mango curry': {
                                name: 'Mango curry',
                                localizedName: 'Mango curry',
                                desciption: '',
                            },
                            Mangorajadressing: {
                                name: 'Mangorajadressing',
                                localizedName: 'Mangorajadressing',
                                desciption: '',
                            },
                            'New york dressing': {
                                name: 'New york dressing',
                                localizedName: 'New york dressing',
                                desciption: '',
                            },
                            Orientdressing: {
                                name: 'Orientdressing',
                                localizedName: 'Orientdressing',
                                desciption: '',
                            },
                            Ostdressing: {
                                name: 'Ostdressing',
                                localizedName: 'Ostdressing',
                                desciption: '',
                            },
                            'Rhode island dressing': {
                                name: 'Rhode island dressing',
                                localizedName: 'Rhode island dressing',
                                desciption: '',
                            },
                            Salladsdressing: {
                                name: 'Salladsdressing',
                                localizedName: 'Salladsdressing',
                                desciption: '',
                            },
                            Senapsdressing: {
                                name: 'Senapsdressing',
                                localizedName: 'Senapsdressing',
                                desciption: '',
                            },
                            Sourcream: {
                                name: 'Sourcream',
                                localizedName: 'Sourcream',
                                desciption: '',
                            },
                            Stripsdressing: {
                                name: 'Stripsdressing',
                                localizedName: 'Stripsdressing',
                                desciption: '',
                            },
                            'Sweet chili': {
                                name: 'Sweet chili',
                                localizedName: 'Sweet chili',
                                desciption: '',
                            },
                            Vinägrett: {
                                name: 'Vinägrett',
                                localizedName: 'Vinägrett',
                                desciption: '',
                            },
                            Vitlöksdressing: {
                                name: 'Vitlöksdressing',
                                localizedName: 'Vitlöksdressing',
                                desciption: '',
                            },
                        },
                    },
                    'Havre, soja, ris & mandel mm': {
                        name: 'Havre, soja, ris & mandel mm',
                        localizedName: 'Havre, soja, ris & mandel mm',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/milk.svg',
                        immutableFields: {
                            goesWith: null,
                        },
                        children: {
                            Dessert: {
                                name: 'Dessert',
                                localizedName: 'Dessert',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Dryck: {
                                name: 'Dryck',
                                localizedName: 'Dryck',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    weight: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Gurt: {
                                name: 'Gurt',
                                localizedName: 'Gurt',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Matlagning: {
                                name: 'Matlagning',
                                localizedName: 'Matlagning',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Pålägg: {
                                name: 'Pålägg',
                                localizedName: 'Pålägg',
                                desciption: '',
                                immutableFields: {
                                    volume: null,
                                },
                            },
                            'Till kaffe': {
                                name: 'Till kaffe',
                                localizedName: 'Till kaffe',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    weight: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                        },
                    },
                    Majonäser: {
                        name: 'Majonäser',
                        localizedName: 'Majonäser',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/sauce, ketchup, mustard, taste, food.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                    },
                    Matfett: {
                        name: 'Matfett',
                        localizedName: 'Matfett',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            volume: null,
                            goesWith: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Cocosfett: {
                                name: 'Cocosfett',
                                localizedName: 'Cocosfett',
                                desciption: '',
                            },
                            Margarin: {
                                name: 'Margarin',
                                localizedName: 'Margarin',
                                desciption: '',
                            },
                            Matfettsblandning: {
                                name: 'Matfettsblandning',
                                localizedName: 'Matfettsblandning',
                                desciption: '',
                            },
                            Smör: {
                                name: 'Smör',
                                localizedName: 'Smör',
                                desciption: '',
                            },
                            'Övrigt matfett': {
                                name: 'Övrigt matfett',
                                localizedName: 'Övrigt matfett',
                                desciption: '',
                            },
                        },
                    },
                    Mejeriprodukter: {
                        name: 'Mejeriprodukter',
                        localizedName: 'Mejeriprodukter',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/milk, drink, carton, glass, beverage, juice.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            goesWith: null,
                        },
                        children: {
                            Dessert: {
                                name: 'Dessert',
                                localizedName: 'Dessert',
                                desciption: '',
                                immutableFields: {
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Filmjölk: {
                                name: 'Filmjölk',
                                localizedName: 'Filmjölk',
                                desciption: '',
                            },
                            Grädde: {
                                name: 'Grädde',
                                localizedName: 'Grädde',
                                desciption: '',
                            },
                            Kvarg: {
                                name: 'Kvarg',
                                localizedName: 'Kvarg',
                                desciption: '',
                                immutableFields: {
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Messmör: {
                                name: 'Messmör',
                                localizedName: 'Messmör',
                                desciption: '',
                                immutableFields: {
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Mjölk: {
                                name: 'Mjölk',
                                localizedName: 'Mjölk',
                                desciption: '',
                            },
                            Mjölkdryck: {
                                name: 'Mjölkdryck',
                                localizedName: 'Mjölkdryck',
                                desciption: '',
                            },
                            'Syrad produkt': {
                                name: 'Syrad produkt',
                                localizedName: 'Syrad produkt',
                                desciption: '',
                            },
                            Yoghurt: {
                                name: 'Yoghurt',
                                localizedName: 'Yoghurt',
                                desciption: '',
                                immutableFields: {
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            'Övrigt mejeriprodukter': {
                                name: 'Övrigt mejeriprodukter',
                                localizedName: 'Övrigt mejeriprodukter',
                                desciption: '',
                            },
                        },
                    },
                    Ost: {
                        name: 'Ost',
                        localizedName: 'Ost',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/cheese-slice.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            recycleType: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Blåmögel: {
                                name: 'Blåmögel',
                                localizedName: 'Blåmögel',
                                desciption: '',
                                children: {
                                    Get: {
                                        name: 'Get',
                                        localizedName: 'Get',
                                        desciption: '',
                                    },
                                    Får: {
                                        name: 'Får',
                                        localizedName: 'Får',
                                        desciption: '',
                                    },
                                },
                            },
                            'Feta, halloumi & vitost': {
                                name: 'Feta, halloumi & vitost',
                                localizedName: 'Feta, halloumi & vitost',
                                desciption: '',
                            },
                            Färskost: {
                                name: 'Färskost',
                                localizedName: 'Färskost',
                                desciption: '',
                                children: {
                                    Get: {
                                        name: 'Get',
                                        localizedName: 'Get',
                                        desciption: '',
                                    },
                                    Får: {
                                        name: 'Får',
                                        localizedName: 'Får',
                                        desciption: '',
                                    },
                                },
                            },
                            Hårdost: {
                                name: 'Hårdost',
                                localizedName: 'Hårdost',
                                desciption: '',
                                children: {
                                    Get: {
                                        name: 'Get',
                                        localizedName: 'Get',
                                        desciption: '',
                                    },
                                    Får: {
                                        name: 'Får',
                                        localizedName: 'Får',
                                        desciption: '',
                                    },
                                },
                            },
                            Kittost: {
                                name: 'Kittost',
                                localizedName: 'Kittost',
                                desciption: '',
                                children: {
                                    Get: {
                                        name: 'Get',
                                        localizedName: 'Get',
                                        desciption: '',
                                    },
                                    Får: {
                                        name: 'Får',
                                        localizedName: 'Får',
                                        desciption: '',
                                    },
                                },
                            },
                            Mese: {
                                name: 'Mese',
                                localizedName: 'Mese',
                                desciption: '',
                            },
                            Mjukost: {
                                name: 'Mjukost',
                                localizedName: 'Mjukost',
                                desciption: '',
                            },
                            Vegetabiliskt: {
                                name: 'Vegetabiliskt',
                                localizedName: 'Vegetabiliskt',
                                desciption: '',
                            },
                            'Vit & blåmögel': {
                                name: 'Vit & blåmögel',
                                localizedName: 'Vit & blåmögel',
                                desciption: '',
                            },
                            Vitmögel: {
                                name: 'Vitmögel',
                                localizedName: 'Vitmögel',
                                desciption: '',
                                children: {
                                    Get: {
                                        name: 'Get',
                                        localizedName: 'Get',
                                        desciption: '',
                                    },
                                    Får: {
                                        name: 'Får',
                                        localizedName: 'Får',
                                        desciption: '',
                                    },
                                },
                            },
                            'Övrigt ost': {
                                name: 'Övrigt ost',
                                localizedName: 'Övrigt ost',
                                desciption: '',
                            },
                        },
                    },
                    'Röror & sallader': {
                        name: 'Röror & sallader',
                        localizedName: 'Röror & sallader',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/salad, bowl, food, meal, healthy, kitchen.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            recycleType: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            Coleslaw: {
                                name: 'Coleslaw',
                                localizedName: 'Coleslaw',
                                desciption: '',
                            },
                            Dallassallad: {
                                name: 'Dallassallad',
                                localizedName: 'Dallassallad',
                                desciption: '',
                            },
                            Gubbröra: {
                                name: 'Gubbröra',
                                localizedName: 'Gubbröra',
                                desciption: '',
                            },
                            Gurksallad: {
                                name: 'Gurksallad',
                                localizedName: 'Gurksallad',
                                desciption: '',
                            },
                            Ishavssallad: {
                                name: 'Ishavssallad',
                                localizedName: 'Ishavssallad',
                                desciption: '',
                            },
                            Kebabsallad: {
                                name: 'Kebabsallad',
                                localizedName: 'Kebabsallad',
                                desciption: '',
                            },
                            Kycklingsallad: {
                                name: 'Kycklingsallad',
                                localizedName: 'Kycklingsallad',
                                desciption: '',
                            },
                            Laxröra: {
                                name: 'Laxröra',
                                localizedName: 'Laxröra',
                                desciption: '',
                            },
                            Legymsallad: {
                                name: 'Legymsallad',
                                localizedName: 'Legymsallad',
                                desciption: '',
                            },
                            Mimosallad: {
                                name: 'Mimosallad',
                                localizedName: 'Mimosallad',
                                desciption: '',
                            },
                            'Ost/skinka': {
                                name: 'Ost/skinka',
                                localizedName: 'Ost/skinka',
                                desciption: '',
                            },
                            Pepparrot: {
                                name: 'Pepparrot',
                                localizedName: 'Pepparrot',
                                desciption: '',
                            },
                            Pikantsallad: {
                                name: 'Pikantsallad',
                                localizedName: 'Pikantsallad',
                                desciption: '',
                            },
                            Potatissallad: {
                                name: 'Potatissallad',
                                localizedName: 'Potatissallad',
                                desciption: '',
                            },
                            Räksallad: {
                                name: 'Räksallad',
                                localizedName: 'Räksallad',
                                desciption: '',
                            },
                            Rödbetssallad: {
                                name: 'Rödbetssallad',
                                localizedName: 'Rödbetssallad',
                                desciption: '',
                            },
                            Sillsallad: {
                                name: 'Sillsallad',
                                localizedName: 'Sillsallad',
                                desciption: '',
                            },
                            Skagensallad: {
                                name: 'Skagensallad',
                                localizedName: 'Skagensallad',
                                desciption: '',
                            },
                            Skinkröra: {
                                name: 'Skinkröra',
                                localizedName: 'Skinkröra',
                                desciption: '',
                            },
                            Tonfisksallad: {
                                name: 'Tonfisksallad',
                                localizedName: 'Tonfisksallad',
                                desciption: '',
                            },
                            'Övrigt röror & sallader': {
                                name: 'Övrigt röror & sallader',
                                localizedName: 'Övrigt röror & sallader',
                                desciption: '',
                            },
                        },
                    },
                    Ägg: {
                        name: 'Ägg',
                        localizedName: 'Ägg',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/eggs-2.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            recycleType: null,
                            volume: null,
                            goesWith: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                        },
                        children: {
                            'Bearbetade ägg': {
                                name: 'Bearbetade ägg',
                                localizedName: 'Bearbetade ägg',
                                desciption: '',
                            },
                            Skalägg: {
                                name: 'Skalägg',
                                localizedName: 'Skalägg',
                                desciption: '',
                            },
                            'Ägg flytande': {
                                name: 'Ägg flytande',
                                localizedName: 'Ägg flytande',
                                desciption: '',
                            },
                            'Övrigt ägg': {
                                name: 'Övrigt ägg',
                                localizedName: 'Övrigt ägg',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Skafferi & torrförråd': {
                name: 'Skafferi & torrförråd',
                localizedName: 'Skafferi & torrförråd',
                desciption: '',
                icon: 'https://assets.flaivy.com/jar.svg',
                immutableFields: {
                    isLactoseFree: null,
                    isPalmOilFree: null,
                    isFrozen: null,
                    isRefrigerated: null,
                },
                children: {
                    Bakning: {
                        name: 'Bakning',
                        localizedName: 'Bakning',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/15.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            recycleType: null,
                            volume: null,
                            goesWith: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Bakchoklad: {
                                name: 'Bakchoklad',
                                localizedName: 'Bakchoklad',
                                desciption: '',
                            },
                            Bakmixer: {
                                name: 'Bakmixer',
                                localizedName: 'Bakmixer',
                                desciption: '',
                                immutableFields: {
                                    isGelatinous: null,
                                },
                            },
                            Baktillbehör: {
                                name: 'Baktillbehör',
                                localizedName: 'Baktillbehör',
                                desciption: '',
                                immutableFields: {
                                    isGelatinous: null,
                                },
                            },
                            'Choklad, formar & bak': {
                                name: 'Choklad, formar & bak',
                                localizedName: 'Choklad, formar & bak',
                                desciption: '',
                            },
                            'Fyllningar & dekorationgel mm': {
                                name: 'Fyllningar & dekorationgel mm',
                                localizedName: 'Fyllningar & dekorationgel mm',
                                desciption: '',
                            },
                            Färgsättning: {
                                name: 'Färgsättning',
                                localizedName: 'Färgsättning',
                                desciption: '',
                                immutableFields: {
                                    isGelatinous: null,
                                },
                            },
                            Mandelmassa: {
                                name: 'Mandelmassa',
                                localizedName: 'Mandelmassa',
                                desciption: '',
                                immutableFields: {
                                    isGelatinous: null,
                                },
                            },
                            Marsipan: {
                                name: 'Marsipan',
                                localizedName: 'Marsipan',
                                desciption: '',
                                immutableFields: {
                                    isGelatinous: null,
                                },
                            },
                            'Petit choux': {
                                name: 'Petit choux',
                                localizedName: 'Petit choux',
                                desciption: '',
                                immutableFields: {
                                    isGelatinous: null,
                                },
                            },
                        },
                    },
                    Hälsokost: {
                        name: 'Hälsokost',
                        localizedName: 'Hälsokost',
                        desciption: '',
                        immutableFields: {
                            goesWith: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Dryck: {
                                name: 'Dryck',
                                localizedName: 'Dryck',
                                desciption: '',
                                immutableFields: {
                                    weight: null,
                                },
                            },
                            'Nutrition & måltidsersättning': {
                                name: 'Nutrition & måltidsersättning',
                                localizedName: 'Nutrition & måltidsersättning',
                                desciption: '',
                            },
                            Proteinpudding: {
                                name: 'Proteinpudding',
                                localizedName: 'Proteinpudding',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Vitaminer: {
                                name: 'Vitaminer',
                                localizedName: 'Vitaminer',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                        },
                    },
                    Konserver: {
                        name: 'Konserver',
                        localizedName: 'Konserver',
                        desciption: '',
                        immutableFields: {
                            alcoholPercentage: null,
                            recycleType: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Fruktkonserv: {
                                name: 'Fruktkonserv',
                                localizedName: 'Fruktkonserv',
                                desciption: '',
                            },
                            'Färdigmat, konserv': {
                                name: 'Färdigmat, konserv',
                                localizedName: 'Färdigmat, konserv',
                                desciption: '',
                            },
                            Grönsakskonserv: {
                                name: 'Grönsakskonserv',
                                localizedName: 'Grönsakskonserv',
                                desciption: '',
                            },
                            Oliver: {
                                name: 'Oliver',
                                localizedName: 'Oliver',
                                desciption: '',
                            },
                            Salladskonserver: {
                                name: 'Salladskonserver',
                                localizedName: 'Salladskonserver',
                                desciption: '',
                            },
                            'Svamp, konserv': {
                                name: 'Svamp, konserv',
                                localizedName: 'Svamp, konserv',
                                desciption: '',
                            },
                            'Övrigt konserver': {
                                name: 'Övrigt konserver',
                                localizedName: 'Övrigt konserver',
                                desciption: '',
                            },
                        },
                    },
                    Matolja: {
                        name: 'Matolja',
                        localizedName: 'Matolja',
                        desciption: '',
                        immutableFields: {
                            recycleType: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Grillolja: {
                                name: 'Grillolja',
                                localizedName: 'Grillolja',
                                desciption: '',
                            },
                            Björkolja: {
                                name: 'Björkolja',
                                localizedName: 'Björkolja',
                                desciption: '',
                            },
                            Enolja: {
                                name: 'Enolja',
                                localizedName: 'Enolja',
                                desciption: '',
                            },
                            Frityrolja: {
                                name: 'Frityrolja',
                                localizedName: 'Frityrolja',
                                desciption: '',
                            },
                            Granolja: {
                                name: 'Granolja',
                                localizedName: 'Granolja',
                                desciption: '',
                            },
                            Hasselnötsolja: {
                                name: 'Hasselnötsolja',
                                localizedName: 'Hasselnötsolja',
                                desciption: '',
                            },
                            Karljohansvampolja: {
                                name: 'Karljohansvampolja',
                                localizedName: 'Karljohansvampolja',
                                desciption: '',
                            },
                            Kokosolja: {
                                name: 'Kokosolja',
                                localizedName: 'Kokosolja',
                                desciption: '',
                            },
                            Majsolja: {
                                name: 'Majsolja',
                                localizedName: 'Majsolja',
                                desciption: '',
                            },
                            Olivolja: {
                                name: 'Olivolja',
                                localizedName: 'Olivolja',
                                desciption: '',
                            },
                            Pumpakärnsolja: {
                                name: 'Pumpakärnsolja',
                                localizedName: 'Pumpakärnsolja',
                                desciption: '',
                            },
                            'Raps-olivolja': {
                                name: 'Raps-olivolja',
                                localizedName: 'Raps-olivolja',
                                desciption: '',
                            },
                            Rapsolja: {
                                name: 'Rapsolja',
                                localizedName: 'Rapsolja',
                                desciption: '',
                            },
                            Sesamolja: {
                                name: 'Sesamolja',
                                localizedName: 'Sesamolja',
                                desciption: '',
                            },
                            Solrosolja: {
                                name: 'Solrosolja',
                                localizedName: 'Solrosolja',
                                desciption: '',
                            },
                            Tryffelolja: {
                                name: 'Tryffelolja',
                                localizedName: 'Tryffelolja',
                                desciption: '',
                            },
                            Valnötsolja: {
                                name: 'Valnötsolja',
                                localizedName: 'Valnötsolja',
                                desciption: '',
                            },
                        },
                    },
                    'Mjöl, gryner & torrförråd': {
                        name: 'Mjöl, gryner & torrförråd',
                        localizedName: 'Mjöl, gryner & torrförråd',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/16.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            recycleType: null,
                            volume: null,
                            goesWith: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Bakmixer: {
                                name: 'Bakmixer',
                                localizedName: 'Bakmixer',
                                desciption: '',
                            },
                            Baljväxter: {
                                name: 'Baljväxter',
                                localizedName: 'Baljväxter',
                                desciption: '',
                            },
                            Bovete: {
                                name: 'Bovete',
                                localizedName: 'Bovete',
                                desciption: '',
                            },
                            Böna: {
                                name: 'Böna',
                                localizedName: 'Böna',
                                desciption: '',
                            },
                            'Dessert, pulver': {
                                name: 'Dessert, pulver',
                                localizedName: 'Dessert, pulver',
                                desciption: '',
                            },
                            'Flingor & musli': {
                                name: 'Flingor & musli',
                                localizedName: 'Flingor & musli',
                                desciption: '',
                                children: {
                                    Musli: {
                                        name: 'Musli',
                                        localizedName: 'Musli',
                                        desciption: '',
                                    },
                                    Flingor: {
                                        name: 'Flingor',
                                        localizedName: 'Flingor',
                                        desciption: '',
                                    },
                                },
                            },
                            Fröer: {
                                name: 'Fröer',
                                localizedName: 'Fröer',
                                desciption: '',
                            },
                            Gryner: {
                                name: 'Gryner',
                                localizedName: 'Gryner',
                                desciption: '',
                            },
                            Hirs: {
                                name: 'Hirs',
                                localizedName: 'Hirs',
                                desciption: '',
                            },
                            Kikärter: {
                                name: 'Kikärter',
                                localizedName: 'Kikärter',
                                desciption: '',
                            },
                            Korn: {
                                name: 'Korn',
                                localizedName: 'Korn',
                                desciption: '',
                            },
                            Linfrö: {
                                name: 'Linfrö',
                                localizedName: 'Linfrö',
                                desciption: '',
                            },
                            Mjöl: {
                                name: 'Mjöl',
                                localizedName: 'Mjöl',
                                desciption: '',
                            },
                            Potatismos: {
                                name: 'Potatismos',
                                localizedName: 'Potatismos',
                                desciption: '',
                            },
                            Psyllium: {
                                name: 'Psyllium',
                                localizedName: 'Psyllium',
                                desciption: '',
                            },
                            Rotmos: {
                                name: 'Rotmos',
                                localizedName: 'Rotmos',
                                desciption: '',
                            },
                            Sesamfrö: {
                                name: 'Sesamfrö',
                                localizedName: 'Sesamfrö',
                                desciption: '',
                            },
                            Solroskärnor: {
                                name: 'Solroskärnor',
                                localizedName: 'Solroskärnor',
                                desciption: '',
                            },
                            Ströbröd: {
                                name: 'Ströbröd',
                                localizedName: 'Ströbröd',
                                desciption: '',
                            },
                            'Taco, tortilla mm': {
                                name: 'Taco, tortilla mm',
                                localizedName: 'Taco, tortilla mm',
                                desciption: '',
                            },
                            Torrförråd: {
                                name: 'Torrförråd',
                                localizedName: 'Torrförråd',
                                desciption: '',
                            },
                            Vetegroddar: {
                                name: 'Vetegroddar',
                                localizedName: 'Vetegroddar',
                                desciption: '',
                            },
                            Ärter: {
                                name: 'Ärter',
                                localizedName: 'Ärter',
                                desciption: '',
                            },
                            'Övrigt mjöl, gryner & torrförråd': {
                                name: 'Övrigt mjöl, gryner & torrförråd',
                                localizedName: 'Övrigt mjöl, gryner & torrförråd',
                                desciption: '',
                            },
                        },
                    },
                    'Pasta, ris, matgryn & nudlar': {
                        name: 'Pasta, ris, matgryn & nudlar',
                        localizedName: 'Pasta, ris, matgryn & nudlar',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/noodles, bowl, kitchen, chopsticks, food, meal.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            recycleType: null,
                            volume: null,
                            goesWith: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Gnocchi: {
                                name: 'Gnocchi',
                                localizedName: 'Gnocchi',
                                desciption: '',
                            },
                            Matgryn: {
                                name: 'Matgryn',
                                localizedName: 'Matgryn',
                                desciption: '',
                            },
                            Nudlar: {
                                name: 'Nudlar',
                                localizedName: 'Nudlar',
                                desciption: '',
                            },
                            Pasta: {
                                name: 'Pasta',
                                localizedName: 'Pasta',
                                desciption: '',
                            },
                            Ris: {
                                name: 'Ris',
                                localizedName: 'Ris',
                                desciption: '',
                            },
                            'Övrigt pasta, ris, matgryn & nudlar': {
                                name: 'Övrigt pasta, ris, matgryn & nudlar',
                                localizedName: 'Övrigt pasta, ris, matgryn & nudlar',
                                desciption: '',
                            },
                        },
                    },
                    Smaksättare: {
                        name: 'Smaksättare',
                        localizedName: 'Smaksättare',
                        desciption: '',
                        immutableFields: {
                            recycleType: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isHardCandy: null,
                        },
                        children: {
                            'Buljong & fond': {
                                name: 'Buljong & fond',
                                localizedName: 'Buljong & fond',
                                desciption: '',
                            },
                            Ketchup: {
                                name: 'Ketchup',
                                localizedName: 'Ketchup',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            'Kokosbaserade produkter': {
                                name: 'Kokosbaserade produkter',
                                localizedName: 'Kokosbaserade produkter',
                                desciption: '',
                            },
                            'Kondenserad mjölk': {
                                name: 'Kondenserad mjölk',
                                localizedName: 'Kondenserad mjölk',
                                desciption: '',
                            },
                            'Kryddor & kryddblandningar': {
                                name: 'Kryddor & kryddblandningar',
                                localizedName: 'Kryddor & kryddblandningar',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Matlagningsvin: {
                                name: 'Matlagningsvin',
                                localizedName: 'Matlagningsvin',
                                desciption: '',
                            },
                            'Puréer & pasta': {
                                name: 'Puréer & pasta',
                                localizedName: 'Puréer & pasta',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Senap: {
                                name: 'Senap',
                                localizedName: 'Senap',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            'Socker, sirap & honung': {
                                name: 'Socker, sirap & honung',
                                localizedName: 'Socker, sirap & honung',
                                desciption: '',
                                children: {
                                    Socker: {
                                        name: 'Socker',
                                        localizedName: 'Socker',
                                        desciption: '',
                                    },
                                    Sirap: {
                                        name: 'Sirap',
                                        localizedName: 'Sirap',
                                        desciption: '',
                                    },
                                },
                            },
                            Soja: {
                                name: 'Soja',
                                localizedName: 'Soja',
                                desciption: '',
                            },
                            Såser: {
                                name: 'Såser',
                                localizedName: 'Såser',
                                desciption: '',
                            },
                            'Torkad frukt': {
                                name: 'Torkad frukt',
                                localizedName: 'Torkad frukt',
                                desciption: '',
                                immutableFields: {
                                    alcoholPercentage: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            'Ättika, vinäger mm': {
                                name: 'Ättika, vinäger mm',
                                localizedName: 'Ättika, vinäger mm',
                                desciption: '',
                            },
                            'Övrigt smaksättare': {
                                name: 'Övrigt smaksättare',
                                localizedName: 'Övrigt smaksättare',
                                desciption: '',
                            },
                        },
                    },
                    'Snacks, nötter & godis': {
                        name: 'Snacks, nötter & godis',
                        localizedName: 'Snacks, nötter & godis',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/candy.svg',
                        immutableFields: {
                            alcoholPercentage: null,
                            recycleType: null,
                            volume: null,
                            goesWith: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isFrozen: null,
                            isRefrigerated: null,
                        },
                        children: {
                            Bars: {
                                name: 'Bars',
                                localizedName: 'Bars',
                                desciption: '',
                                immutableFields: {
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Chips: {
                                name: 'Chips',
                                localizedName: 'Chips',
                                desciption: '',
                                immutableFields: {
                                    isGelatinFree: null,
                                    isLactoseFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Extruderat: {
                                name: 'Extruderat',
                                localizedName: 'Extruderat',
                                desciption: '',
                                immutableFields: {
                                    isGelatinFree: null,
                                    isLactoseFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Konfektyr: {
                                name: 'Konfektyr',
                                localizedName: 'Konfektyr',
                                desciption: '',
                                immutableFields: {
                                    isGelatinous: null,
                                    isLiquorice: null,
                                },
                                children: {
                                    Present: {
                                        name: 'Present',
                                        localizedName: 'Present',
                                        desciption: '',
                                        immutableFields: {
                                            isGelatinous: null,
                                        },
                                    },
                                    'Travel retail': {
                                        name: 'Travel retail',
                                        localizedName: 'Travel retail',
                                        desciption: '',
                                        immutableFields: {
                                            isGelatinous: null,
                                        },
                                    },
                                    Sockervadd: {
                                        name: 'Sockervadd',
                                        localizedName: 'Sockervadd',
                                        desciption: '',
                                        immutableFields: {
                                            isFoam: null,
                                            isGelatinous: null,
                                            isHardCandy: null,
                                        },
                                    },
                                    'Dubbla stycksaker': {
                                        name: 'Dubbla stycksaker',
                                        localizedName: 'Dubbla stycksaker',
                                        desciption: '',
                                        immutableFields: {
                                            isGelatinous: null,
                                        },
                                        children: {
                                            Choklad: {
                                                name: 'Choklad',
                                                localizedName: 'Choklad',
                                                desciption: '',
                                                immutableFields: {
                                                    isGelatinous: null,
                                                    isHardCandy: null,
                                                },
                                            },
                                        },
                                    },
                                    'Enkla stycksaker': {
                                        name: 'Enkla stycksaker',
                                        localizedName: 'Enkla stycksaker',
                                        desciption: '',
                                        immutableFields: {
                                            isGelatinous: null,
                                        },
                                        children: {
                                            Choklad: {
                                                name: 'Choklad',
                                                localizedName: 'Choklad',
                                                desciption: '',
                                                immutableFields: {
                                                    isGelatinous: null,
                                                    isHardCandy: null,
                                                },
                                            },
                                            Sockerkonfektyr: {
                                                name: 'Sockerkonfektyr',
                                                localizedName: 'Sockerkonfektyr',
                                                desciption: '',
                                                immutableFields: {
                                                    isGelatinous: null,
                                                },
                                            },
                                        },
                                    },
                                    Rullar: {
                                        name: 'Rullar',
                                        localizedName: 'Rullar',
                                        desciption: '',
                                        immutableFields: {
                                            isGelatinous: null,
                                            isHardCandy: null,
                                        },
                                    },
                                    Choklad: {
                                        name: 'Choklad',
                                        localizedName: 'Choklad',
                                        desciption: '',
                                        immutableFields: {
                                            isFoam: null,
                                            isGelatinous: null,
                                            isHardCandy: null,
                                        },
                                        children: {
                                            Chokladkaka: {
                                                name: 'Chokladkaka',
                                                localizedName: 'Chokladkaka',
                                                desciption: '',
                                                immutableFields: {
                                                    isFoam: null,
                                                    isGelatinous: null,
                                                    isHardCandy: null,
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                            Dipmix: {
                                name: 'Dipmix',
                                localizedName: 'Dipmix',
                                desciption: '',
                                immutableFields: {
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Hälsosnacks: {
                                name: 'Hälsosnacks',
                                localizedName: 'Hälsosnacks',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Naturkost: {
                                name: 'Naturkost',
                                localizedName: 'Naturkost',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Fröer: {
                                name: 'Fröer',
                                localizedName: 'Fröer',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Godis: {
                                name: 'Godis',
                                localizedName: 'Godis',
                                desciption: '',
                                children: {
                                    Klubbor: {
                                        name: 'Klubbor',
                                        localizedName: 'Klubbor',
                                        desciption: '',
                                        immutableFields: {
                                            isFoam: null,
                                        },
                                    },
                                    Naturgodis: {
                                        name: 'Naturgodis',
                                        localizedName: 'Naturgodis',
                                        desciption: '',
                                        immutableFields: {
                                            isFoam: null,
                                            isHardCandy: null,
                                        },
                                    },
                                    Lösvikt: {
                                        name: 'Lösvikt',
                                        localizedName: 'Lösvikt',
                                        desciption: '',
                                        children: {
                                            Inslaget: {
                                                name: 'Inslaget',
                                                localizedName: 'Inslaget',
                                                desciption: '',
                                            },
                                            Oinslaget: {
                                                name: 'Oinslaget',
                                                localizedName: 'Oinslaget',
                                                desciption: '',
                                            },
                                            Marshmallow: {
                                                name: 'Marshmallow',
                                                localizedName: 'Marshmallow',
                                                desciption: '',
                                                immutableFields: {
                                                    isHardCandy: null,
                                                },
                                            },
                                            Naturgodis: {
                                                name: 'Naturgodis',
                                                localizedName: 'Naturgodis',
                                                desciption: '',
                                                immutableFields: {
                                                    isFoam: null,
                                                    isHardCandy: null,
                                                },
                                            },
                                            Praliner: {
                                                name: 'Praliner',
                                                localizedName: 'Praliner',
                                                desciption: '',
                                                immutableFields: {
                                                    isHardCandy: null,
                                                },
                                            },
                                        },
                                    },
                                    Barngodis: {
                                        name: 'Barngodis',
                                        localizedName: 'Barngodis',
                                        desciption: '',
                                        children: {
                                            Stycksaker: {
                                                name: 'Stycksaker',
                                                localizedName: 'Stycksaker',
                                                desciption: '',
                                            },
                                            Klubbor: {
                                                name: 'Klubbor',
                                                localizedName: 'Klubbor',
                                                desciption: '',
                                                immutableFields: {
                                                    isFoam: null,
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                            Kokos: {
                                name: 'Kokos',
                                localizedName: 'Kokos',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Mandel: {
                                name: 'Mandel',
                                localizedName: 'Mandel',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Nötter: {
                                name: 'Nötter',
                                localizedName: 'Nötter',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Ostsnacks: {
                                name: 'Ostsnacks',
                                localizedName: 'Ostsnacks',
                                desciption: '',
                                immutableFields: {
                                    isGelatinFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Popcorn: {
                                name: 'Popcorn',
                                localizedName: 'Popcorn',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            'Salta pinnar': {
                                name: 'Salta pinnar',
                                localizedName: 'Salta pinnar',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Snacksmix: {
                                name: 'Snacksmix',
                                localizedName: 'Snacksmix',
                                desciption: '',
                                immutableFields: {
                                    isGelatinFree: null,
                                    isLactoseFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Sojabönor: {
                                name: 'Sojabönor',
                                localizedName: 'Sojabönor',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Tunnbrödschips: {
                                name: 'Tunnbrödschips',
                                localizedName: 'Tunnbrödschips',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isCoated: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Wasabi: {
                                name: 'Wasabi',
                                localizedName: 'Wasabi',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                        },
                    },
                    Uppfräschare: {
                        name: 'Uppfräschare',
                        localizedName: 'Uppfräschare',
                        desciption: '',
                        immutableFields: {
                            volume: null,
                            isVegan: null,
                            isGelatinFree: null,
                            isSugarFree: null,
                            isLactoseFree: null,
                            isPalmOilFree: null,
                            isFoam: null,
                            isFudge: null,
                            isGelatinous: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Halstabletter: {
                                name: 'Halstabletter',
                                localizedName: 'Halstabletter',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                            Tuggummi: {
                                name: 'Tuggummi',
                                localizedName: 'Tuggummi',
                                desciption: '',
                                immutableFields: {
                                    isVegan: null,
                                    isGelatinFree: null,
                                    isSugarFree: null,
                                    isLactoseFree: null,
                                    isPalmOilFree: null,
                                    isFoam: null,
                                    isFudge: null,
                                    isGelatinous: null,
                                    isLiquorice: null,
                                    isHardCandy: null,
                                },
                            },
                        },
                    },
                    Specialmat: {
                        name: 'Specialmat',
                        localizedName: 'Specialmat',
                        desciption: '',
                        immutableFields: {
                            goesWith: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Barnmat: {
                                name: 'Barnmat',
                                localizedName: 'Barnmat',
                                desciption: '',
                                immutableFields: {
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Berikningspulver: {
                                name: 'Berikningspulver',
                                localizedName: 'Berikningspulver',
                                desciption: '',
                                immutableFields: {
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Förtjockningsmedel: {
                                name: 'Förtjockningsmedel',
                                localizedName: 'Förtjockningsmedel',
                                desciption: '',
                                immutableFields: {
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Gröt: {
                                name: 'Gröt',
                                localizedName: 'Gröt',
                                desciption: '',
                                immutableFields: {
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Mjölkersättning: {
                                name: 'Mjölkersättning',
                                localizedName: 'Mjölkersättning',
                                desciption: '',
                            },
                            Näringsdryck: {
                                name: 'Näringsdryck',
                                localizedName: 'Näringsdryck',
                                desciption: '',
                            },
                            Pofiber: {
                                name: 'Pofiber',
                                localizedName: 'Pofiber',
                                desciption: '',
                                immutableFields: {
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Sondnäring: {
                                name: 'Sondnäring',
                                localizedName: 'Sondnäring',
                                desciption: '',
                                immutableFields: {
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Torrmjölk: {
                                name: 'Torrmjölk',
                                localizedName: 'Torrmjölk',
                                desciption: '',
                                immutableFields: {
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                            Välling: {
                                name: 'Välling',
                                localizedName: 'Välling',
                                desciption: '',
                            },
                            Vätskeersättning: {
                                name: 'Vätskeersättning',
                                localizedName: 'Vätskeersättning',
                                desciption: '',
                                immutableFields: {
                                    recycleType: null,
                                    volume: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                    systembolagetArticleNumber: null,
                                    systembolagetSalesPrice: null,
                                    knNumber: null,
                                    exciseProductCode: null,
                                    alcoholTaxPaid: null,
                                },
                            },
                        },
                    },
                    'Sylt & marmelad mm': {
                        name: 'Sylt & marmelad mm',
                        localizedName: 'Sylt & marmelad mm',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/jam, jar, berries, food, taste, organic, healthy.svg',
                        immutableFields: {
                            recycleType: null,
                            volume: null,
                            appearance: null,
                            scent: null,
                            taste: null,
                            grapes: null,
                            seal: null,
                            vintage: null,
                            systembolagetArticleNumber: null,
                            systembolagetSalesPrice: null,
                            knNumber: null,
                            exciseProductCode: null,
                            alcoholTaxPaid: null,
                            isFoam: null,
                            isCoated: null,
                            isFudge: null,
                            isLiquorice: null,
                            isHardCandy: null,
                        },
                        children: {
                            Curd: {
                                name: 'Curd',
                                localizedName: 'Curd',
                                desciption: '',
                            },
                            Fruktkompott: {
                                name: 'Fruktkompott',
                                localizedName: 'Fruktkompott',
                                desciption: '',
                            },
                            Gelé: {
                                name: 'Gelé',
                                localizedName: 'Gelé',
                                desciption: '',
                            },
                            Marmelad: {
                                name: 'Marmelad',
                                localizedName: 'Marmelad',
                                desciption: '',
                            },
                            Mos: {
                                name: 'Mos',
                                localizedName: 'Mos',
                                desciption: '',
                            },
                            Sylt: {
                                name: 'Sylt',
                                localizedName: 'Sylt',
                                desciption: '',
                            },
                        },
                    },
                },
            },
        },
    },
    Dryck: {
        name: 'Dryck',
        localizedName: 'Dryck',
        desciption: '',
        icon: 'https://assets.flaivy.com/soda, can, bottle, drink, beverage.svg',
        immutableFields: {
            isGelatinFree: null,
            isPalmOilFree: null,
            isFrozen: null,
            isRefrigerated: null,
            isFoam: null,
            isCoated: null,
            isFudge: null,
            isGelatinous: null,
            isLiquorice: null,
            isHardCandy: null,
        },
        alcoholBookKeepingAccounts: {
            Commission: {
                purchaseAccount: 4011,
                salesAccount: 3011,
            },
            OwnedByDrycks: {
                purchaseAccount: 4010,
                salesAccount: 3010,
            },
            DropShipping: {
                purchaseAccount: 4011,
                salesAccount: 3011,
            },
        },
        alcoholFreeBookKeepingAccounts: {
            Commission: {
                purchaseAccount: 4012,
                salesAccount: 3017,
            },
            OwnedByDrycks: {
                purchaseAccount: 4014,
                salesAccount: 3014,
            },
            DropShipping: {
                purchaseAccount: 4012,
                salesAccount: 3017,
            },
            StandAlone: {
                purchaseAccount: 4012,
                salesAccount: 3017,
            },
        },
        alcoholTaxClasses: ['Alcoholfree'],
        children: {
            'Cider & Ready to drink': {
                name: 'Cider & Ready to drink',
                localizedName: 'Cider & Ready to drink',
                desciption: '',
                icon: 'https://assets.flaivy.com/drink.svg',
                immutableFields: {
                    goesWith: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    isLactoseFree: null,
                },
                alcoholBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4010,
                        salesAccount: 3010,
                    },
                    DropShipping: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4012,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4012,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['Wine', 'MidRange'],
                children: {
                    Cider: {
                        name: 'Cider',
                        localizedName: 'Cider',
                        desciption: '',
                        children: {
                            'Torr- & halvtorr cider': {
                                name: 'Torr- & halvtorr cider',
                                localizedName: 'Torr- & halvtorr cider',
                                desciption: '',
                            },
                            'Söt cider': {
                                name: 'Söt cider',
                                localizedName: 'Söt cider',
                                desciption: '',
                            },
                        },
                    },
                    'Ginger beer': {
                        name: 'Ginger beer',
                        localizedName: 'Ginger beer',
                        desciption: '',
                    },
                    'Ready to drink': {
                        name: 'Ready to drink',
                        localizedName: 'Ready to drink',
                        desciption: '',
                        children: {
                            Mocktail: {
                                name: 'Mocktail',
                                localizedName: 'Mocktail',
                                desciption: '',
                                immutableFields: {
                                    goesWith: null,
                                    appearance: null,
                                    scent: null,
                                    taste: null,
                                    grapes: null,
                                    seal: null,
                                    vintage: null,
                                },
                                alcoholTaxClasses: ['Alcoholfree'],
                            },
                            Seltzer: {
                                name: 'Seltzer',
                                localizedName: 'Seltzer',
                                desciption: '',
                            },
                        },
                    },
                    'Övrig cider & ready to drink': {
                        name: 'Övrig cider & ready to drink',
                        localizedName: 'Övrig cider & ready to drink',
                        desciption: '',
                    },
                },
            },
            Drinkmixers: {
                name: 'Drinkmixers',
                localizedName: 'Drinkmixers',
                desciption: '',
                icon: 'https://assets.flaivy.com/drink.svg',
                immutableFields: {
                    alcoholPercentage: null,
                    goesWith: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    isLactoseFree: null,
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['Alcoholfree'],
                children: {
                    Cocktailbär: {
                        name: 'Cocktailbär',
                        localizedName: 'Cocktailbär',
                        desciption: '',
                        alcoholFreeBookKeepingAccounts: {
                            Commission: {
                                purchaseAccount: 4005,
                                salesAccount: 3005,
                            },
                            OwnedByDrycks: {
                                purchaseAccount: 4004,
                                salesAccount: 3005,
                            },
                            DropShipping: {
                                purchaseAccount: 4005,
                                salesAccount: 3004,
                            },
                        },
                    },
                    Drinkpinne: {
                        name: 'Drinkpinne',
                        localizedName: 'Drinkpinne',
                        desciption: '',
                        alcoholFreeBookKeepingAccounts: {
                            Commission: {
                                purchaseAccount: 4000,
                                salesAccount: 3000,
                            },
                            DropShipping: {
                                purchaseAccount: 4000,
                                salesAccount: 3000,
                            },
                        },
                    },
                    Mixers: {
                        name: 'Mixers',
                        localizedName: 'Mixers',
                        desciption: '',
                        children: {
                            Tonic: {
                                name: 'Tonic',
                                localizedName: 'Tonic',
                                desciption: '',
                            },
                        },
                    },
                    Puré: {
                        name: 'Puré',
                        localizedName: 'Puré',
                        desciption: '',
                    },
                    'Övrigt drinkmixers': {
                        name: 'Övrigt drinkmixers',
                        localizedName: 'Övrigt drinkmixers',
                        desciption: '',
                    },
                },
            },
            'Juice, saft & måltidsdryck': {
                name: 'Juice, saft & måltidsdryck',
                localizedName: 'Juice, saft & måltidsdryck',
                desciption: '',
                icon: 'https://assets.flaivy.com/drink, beverage, container, milkshake, soda, fast food, junk food.svg',
                immutableFields: {
                    alcoholPercentage: null,
                    goesWith: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    alcoholTaxPaid: null,
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['Alcoholfree'],
                children: {
                    Koncentrat: {
                        name: 'Koncentrat',
                        localizedName: 'Koncentrat',
                        desciption: '',
                    },
                    Fruktdryck: {
                        name: 'Fruktdryck',
                        localizedName: 'Fruktdryck',
                        desciption: '',
                    },
                    Juice: {
                        name: 'Juice',
                        localizedName: 'Juice',
                        desciption: '',
                    },
                    Lemonad: {
                        name: 'Lemonad',
                        localizedName: 'Lemonad',
                        desciption: '',
                    },
                    Must: {
                        name: 'Must',
                        localizedName: 'Must',
                        desciption: '',
                    },
                    Måltidsdryck: {
                        name: 'Måltidsdryck',
                        localizedName: 'Måltidsdryck',
                        desciption: '',
                    },
                    Saft: {
                        name: 'Saft',
                        localizedName: 'Saft',
                        desciption: '',
                    },
                    Sav: {
                        name: 'Sav',
                        localizedName: 'Sav',
                        desciption: '',
                    },
                    Shots: {
                        name: 'Shots',
                        localizedName: 'Shots',
                        desciption: '',
                    },
                    Slush: {
                        name: 'Slush',
                        localizedName: 'Slush',
                        desciption: '',
                    },
                    Smoothie: {
                        name: 'Smoothie',
                        localizedName: 'Smoothie',
                        desciption: '',
                    },
                    'Övrig fruktdryck': {
                        name: 'Övrig fruktdryck',
                        localizedName: 'Övrig fruktdryck',
                        desciption: '',
                    },
                },
            },
            'Fruktsoppor & kräm': {
                name: 'Fruktsoppor & kräm',
                localizedName: 'Fruktsoppor & kräm',
                desciption: '',
                immutableFields: {
                    alcoholPercentage: null,
                    goesWith: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    systembolagetArticleNumber: null,
                    systembolagetSalesPrice: null,
                    knNumber: null,
                    alcoholTaxPaid: null,
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4005,
                        salesAccount: 3005,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4004,
                        salesAccount: 3004,
                    },
                    DropShipping: {
                        purchaseAccount: 4005,
                        salesAccount: 3005,
                    },
                },
                alcoholTaxClasses: ['Alcoholfree'],
                children: {
                    Aprikoskräm: {
                        name: 'Aprikoskräm',
                        localizedName: 'Aprikoskräm',
                        desciption: '',
                    },
                    Aprikossoppa: {
                        name: 'Aprikossoppa',
                        localizedName: 'Aprikossoppa',
                        desciption: '',
                    },
                    Björnbärskräm: {
                        name: 'Björnbärskräm',
                        localizedName: 'Björnbärskräm',
                        desciption: '',
                    },
                    Blåbärskräm: {
                        name: 'Blåbärskräm',
                        localizedName: 'Blåbärskräm',
                        desciption: '',
                    },
                    Blåbärssoppa: {
                        name: 'Blåbärssoppa',
                        localizedName: 'Blåbärssoppa',
                        desciption: '',
                    },
                    Citronsoppa: {
                        name: 'Citronsoppa',
                        localizedName: 'Citronsoppa',
                        desciption: '',
                    },
                    Fruktsoppa: {
                        name: 'Fruktsoppa',
                        localizedName: 'Fruktsoppa',
                        desciption: '',
                    },
                    Hallonkräm: {
                        name: 'Hallonkräm',
                        localizedName: 'Hallonkräm',
                        desciption: '',
                    },
                    Hallonsoppa: {
                        name: 'Hallonsoppa',
                        localizedName: 'Hallonsoppa',
                        desciption: '',
                    },
                    Jordgubbskräm: {
                        name: 'Jordgubbskräm',
                        localizedName: 'Jordgubbskräm',
                        desciption: '',
                    },
                    Körsbärssoppa: {
                        name: 'Körsbärssoppa',
                        localizedName: 'Körsbärssoppa',
                        desciption: '',
                    },
                    Mangosoppa: {
                        name: 'Mangosoppa',
                        localizedName: 'Mangosoppa',
                        desciption: '',
                    },
                    Nyponsoppa: {
                        name: 'Nyponsoppa',
                        localizedName: 'Nyponsoppa',
                        desciption: '',
                    },
                    Päronkräm: {
                        name: 'Päronkräm',
                        localizedName: 'Päronkräm',
                        desciption: '',
                    },
                    Äppelkräm: {
                        name: 'Äppelkräm',
                        localizedName: 'Äppelkräm',
                        desciption: '',
                    },
                    'Övrigt fruktsoppor & kräm': {
                        name: 'Övrigt fruktsoppor & kräm',
                        localizedName: 'Övrigt fruktsoppor & kräm',
                        desciption: '',
                    },
                },
            },
            'Kaffe, te & chokladdryck': {
                name: 'Kaffe, te & chokladdryck',
                localizedName: 'Kaffe, te & chokladdryck',
                desciption: '',
                icon: 'https://assets.flaivy.com/3.svg',
                immutableFields: {
                    alcoholPercentage: null,
                    goesWith: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    knNumber: null,
                    alcoholTaxPaid: null,
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['Alcoholfree'],
                children: {
                    Chokladdryck: {
                        name: 'Chokladdryck',
                        localizedName: 'Chokladdryck',
                        desciption: '',
                    },
                    Kaffe: {
                        name: 'Kaffe',
                        localizedName: 'Kaffe',
                        desciption: '',
                        alcoholFreeBookKeepingAccounts: {
                            Commission: {
                                purchaseAccount: 4005,
                                salesAccount: 3005,
                            },
                            OwnedByDrycks: {
                                purchaseAccount: 4004,
                                salesAccount: 3004,
                            },
                            DropShipping: {
                                purchaseAccount: 4005,
                                salesAccount: 3005,
                            },
                        },
                        children: {
                            Bryggkaffe: {
                                name: 'Bryggkaffe',
                                localizedName: 'Bryggkaffe',
                                desciption: '',
                                alcoholFreeBookKeepingAccounts: {
                                    Commission: {
                                        purchaseAccount: 4005,
                                    },
                                },
                                children: {
                                    Malt: {
                                        name: 'Malt',
                                        localizedName: 'Malt',
                                        desciption: '',
                                        alcoholFreeBookKeepingAccounts: {
                                            Commission: {
                                                purchaseAccount: 4005,
                                            },
                                        },
                                    },
                                },
                            },
                            Espresso: {
                                name: 'Espresso',
                                localizedName: 'Espresso',
                                desciption: '',
                                alcoholFreeBookKeepingAccounts: {
                                    Commission: {
                                        purchaseAccount: 4005,
                                    },
                                },
                            },
                        },
                    },
                    Kaffedryck: {
                        name: 'Kaffedryck',
                        localizedName: 'Kaffedryck',
                        desciption: '',
                        children: {
                            Iskaffe: {
                                name: 'Iskaffe',
                                localizedName: 'Iskaffe',
                                desciption: '',
                            },
                        },
                    },
                    Kaffemjölk: {
                        name: 'Kaffemjölk',
                        localizedName: 'Kaffemjölk',
                        desciption: '',
                    },
                    'Kaffesyrup mm': {
                        name: 'Kaffesyrup mm',
                        localizedName: 'Kaffesyrup mm',
                        desciption: '',
                    },
                    Te: {
                        name: 'Te',
                        localizedName: 'Te',
                        desciption: '',
                        alcoholFreeBookKeepingAccounts: {
                            Commission: {
                                purchaseAccount: 4005,
                                salesAccount: 3005,
                            },
                            OwnedByDrycks: {
                                purchaseAccount: 4004,
                                salesAccount: 3004,
                            },
                            DropShipping: {
                                purchaseAccount: 4005,
                                salesAccount: 3005,
                            },
                        },
                        children: {
                            Iste: {
                                name: 'Iste',
                                localizedName: 'Iste',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Kolsyrat & stilla': {
                name: 'Kolsyrat & stilla',
                localizedName: 'Kolsyrat & stilla',
                desciption: '',
                icon: 'https://assets.flaivy.com/soda-can.svg',
                immutableFields: {
                    alcoholPercentage: null,
                    goesWith: null,
                    appearance: null,
                    scent: null,
                    taste: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    alcoholTaxPaid: null,
                    isLactoseFree: null,
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['Alcoholfree'],
                children: {
                    Funktionsdryck: {
                        name: 'Funktionsdryck',
                        localizedName: 'Funktionsdryck',
                        desciption: '',
                        immutableFields: {
                            knNumber: null,
                        },
                        children: {
                            Energidryck: {
                                name: 'Energidryck',
                                localizedName: 'Energidryck',
                                desciption: '',
                                immutableFields: {
                                    knNumber: null,
                                },
                            },
                            Hälsodryck: {
                                name: 'Hälsodryck',
                                localizedName: 'Hälsodryck',
                                desciption: '',
                                immutableFields: {
                                    knNumber: null,
                                },
                            },
                            Kokosvatten: {
                                name: 'Kokosvatten',
                                localizedName: 'Kokosvatten',
                                desciption: '',
                                immutableFields: {
                                    knNumber: null,
                                },
                            },
                            Kombucha: {
                                name: 'Kombucha',
                                localizedName: 'Kombucha',
                                desciption: '',
                                immutableFields: {
                                    knNumber: null,
                                },
                            },
                            Vitaminvatten: {
                                name: 'Vitaminvatten',
                                localizedName: 'Vitaminvatten',
                                desciption: '',
                                immutableFields: {
                                    knNumber: null,
                                },
                            },
                        },
                    },
                    Is: {
                        name: 'Is',
                        localizedName: 'Is',
                        desciption: '',
                        immutableFields: {
                            knNumber: null,
                        },
                    },
                    Läsk: {
                        name: 'Läsk',
                        localizedName: 'Läsk',
                        desciption: '',
                    },
                    Mineralvatten: {
                        name: 'Mineralvatten',
                        localizedName: 'Mineralvatten',
                        desciption: '',
                        immutableFields: {
                            knNumber: null,
                        },
                        children: {
                            'Kolsyrat vatten': {
                                name: 'Kolsyrat vatten',
                                localizedName: 'Kolsyrat vatten',
                                desciption: '',
                                immutableFields: {
                                    knNumber: null,
                                },
                            },
                            'Stilla vatten': {
                                name: 'Stilla vatten',
                                localizedName: 'Stilla vatten',
                                desciption: '',
                                immutableFields: {
                                    knNumber: null,
                                },
                            },
                        },
                    },
                    'Övrigt kolsyrat & stilla': {
                        name: 'Övrigt kolsyrat & stilla',
                        localizedName: 'Övrigt kolsyrat & stilla',
                        desciption: '',
                        immutableFields: {
                            knNumber: null,
                        },
                    },
                },
            },
            Sprit: {
                name: 'Sprit',
                localizedName: 'Sprit',
                desciption: '',
                icon: 'https://assets.flaivy.com/wine-bottle.svg',
                immutableFields: {
                    shelfLife: 'long',
                    nutritionDeclaration: null,
                    goesWith: null,
                    grapes: null,
                    seal: null,
                    vintage: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                },
                alcoholBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4010,
                        salesAccount: 3010,
                    },
                    DropShipping: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                },
                alcoholTaxClasses: ['Spirits'],
                children: {
                    Amaro: {
                        name: 'Amaro',
                        localizedName: 'Amaro',
                        desciption: '',
                    },
                    'Aperitif & digestif': {
                        name: 'Aperitif & digestif',
                        localizedName: 'Aperitif & digestif',
                        desciption: '',
                        alcoholTaxClasses: ['Spirits', 'MidRange'],
                    },
                    Armagnac: {
                        name: 'Armagnac',
                        localizedName: 'Armagnac',
                        desciption: '',
                    },
                    Bitter: {
                        name: 'Bitter',
                        localizedName: 'Bitter',
                        desciption: '',
                    },
                    Brandy: {
                        name: 'Brandy',
                        localizedName: 'Brandy',
                        desciption: '',
                    },
                    Brännvin: {
                        name: 'Brännvin',
                        localizedName: 'Brännvin',
                        desciption: '',
                    },
                    Cachaca: {
                        name: 'Cachaca',
                        localizedName: 'Cachaca',
                        desciption: '',
                        alcoholTaxClasses: ['tca'],
                    },
                    Calvados: {
                        name: 'Calvados',
                        localizedName: 'Calvados',
                        desciption: '',
                    },
                    Cognac: {
                        name: 'Cognac',
                        localizedName: 'Cognac',
                        desciption: '',
                    },
                    'Eau de vie': {
                        name: 'Eau de vie',
                        localizedName: 'Eau de vie',
                        desciption: '',
                    },
                    Gin: {
                        name: 'Gin',
                        localizedName: 'Gin',
                        desciption: '',
                    },
                    Grappa: {
                        name: 'Grappa',
                        localizedName: 'Grappa',
                        desciption: '',
                    },
                    Likör: {
                        name: 'Likör',
                        localizedName: 'Likör',
                        desciption: '',
                        alcoholTaxClasses: ['Spirits', 'MidRange'],
                    },
                    Marc: {
                        name: 'Marc',
                        localizedName: 'Marc',
                        desciption: '',
                    },
                    Mezcal: {
                        name: 'Mezcal',
                        localizedName: 'Mezcal',
                        desciption: '',
                    },
                    Pisco: {
                        name: 'Pisco',
                        localizedName: 'Pisco',
                        desciption: '',
                    },
                    Rom: {
                        name: 'Rom',
                        localizedName: 'Rom',
                        desciption: '',
                    },
                    Shots: {
                        name: 'Shots',
                        localizedName: 'Shots',
                        desciption: '',
                        alcoholTaxClasses: ['Spirits', 'MidRange'],
                    },
                    'Smaksatt sprit': {
                        name: 'Smaksatt sprit',
                        localizedName: 'Smaksatt sprit',
                        desciption: '',
                    },
                    Tequila: {
                        name: 'Tequila',
                        localizedName: 'Tequila',
                        desciption: '',
                    },
                    Whisky: {
                        name: 'Whisky',
                        localizedName: 'Whisky',
                        desciption: '',
                    },
                    Vodka: {
                        name: 'Vodka',
                        localizedName: 'Vodka',
                        desciption: '',
                    },
                    'Övrig frukt & druvsprit': {
                        name: 'Övrig frukt & druvsprit',
                        localizedName: 'Övrig frukt & druvsprit',
                        desciption: '',
                    },
                    'Övrig starksprit': {
                        name: 'Övrig starksprit',
                        localizedName: 'Övrig starksprit',
                        desciption: '',
                    },
                },
            },
            Vin: {
                name: 'Vin',
                localizedName: 'Vin',
                desciption: '',
                icon: 'https://assets.flaivy.com/bottle, glass, drink, beverage, wine, alcohol.svg',
                immutableFields: {
                    nutritionDeclaration: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                },
                alcoholBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4010,
                        salesAccount: 3010,
                    },
                    DropShipping: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['Wine'],
                children: {
                    'Aperitif & dessertvin': {
                        name: 'Aperitif & dessertvin',
                        localizedName: 'Aperitif & dessertvin',
                        desciption: '',
                        alcoholTaxClasses: ['MidRange', 'Wine'],
                    },
                    Fruktvin: {
                        name: 'Fruktvin',
                        localizedName: 'Fruktvin',
                        desciption: '',
                    },
                    'Glögg & gluhwein': {
                        name: 'Glögg & gluhwein',
                        localizedName: 'Glögg & gluhwein',
                        desciption: '',
                        alcoholTaxClasses: ['MidRange', 'Wine'],
                    },
                    'Mousserande vin': {
                        name: 'Mousserande vin',
                        localizedName: 'Mousserande vin',
                        desciption: '',
                    },
                    'Orange vin': {
                        name: 'Orange vin',
                        localizedName: 'Orange vin',
                        desciption: '',
                    },
                    'Rose vin': {
                        name: 'Rose vin',
                        localizedName: 'Rose vin',
                        desciption: '',
                    },
                    'Rött vin': {
                        name: 'Rött vin',
                        localizedName: 'Rött vin',
                        desciption: '',
                    },
                    Sangria: {
                        name: 'Sangria',
                        localizedName: 'Sangria',
                        desciption: '',
                    },
                    Starkvin: {
                        name: 'Starkvin',
                        localizedName: 'Starkvin',
                        desciption: '',
                        alcoholTaxClasses: ['MidRange', 'Wine'],
                        children: {
                            Portvin: {
                                name: 'Portvin',
                                localizedName: 'Portvin',
                                desciption: '',
                                alcoholTaxClasses: ['MidRange', 'Wine'],
                            },
                            Sherry: {
                                name: 'Sherry',
                                localizedName: 'Sherry',
                                desciption: '',
                            },
                            Vermouth: {
                                name: 'Vermouth',
                                localizedName: 'Vermouth',
                                desciption: '',
                            },
                        },
                    },
                    'Vitt vin': {
                        name: 'Vitt vin',
                        localizedName: 'Vitt vin',
                        desciption: '',
                    },
                    'Övrigt vin': {
                        name: 'Övrigt vin',
                        localizedName: 'Övrigt vin',
                        desciption: '',
                        alcoholTaxClasses: ['MidRange', 'Wine'],
                    },
                    Mjöd: {
                        name: 'Mjöd',
                        localizedName: 'Mjöd',
                        desciption: '',
                    },
                },
            },
            Sake: {
                name: 'Sake',
                localizedName: 'Sake',
                desciption: '',
                alcoholBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4010,
                        salesAccount: 3010,
                    },
                    DropShipping: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['MidRange', 'Wine'],
                children: {
                    Daiginjo: {
                        name: 'Daiginjo',
                        localizedName: 'Daiginjo',
                        desciption: '',
                    },
                    Nigori: {
                        name: 'Nigori',
                        localizedName: 'Nigori',
                        desciption: '',
                    },
                    Junmai: {
                        name: 'Junmai',
                        localizedName: 'Junmai',
                        desciption: '',
                        children: {
                            Nama: {
                                name: 'Nama',
                                localizedName: 'Nama',
                                desciption: '',
                            },
                            Bodaimoto: {
                                name: 'Bodaimoto',
                                localizedName: 'Bodaimoto',
                                desciption: '',
                            },
                            Kimoto: {
                                name: 'Kimoto',
                                localizedName: 'Kimoto',
                                desciption: '',
                            },
                            Yamahai: {
                                name: 'Yamahai',
                                localizedName: 'Yamahai',
                                desciption: '',
                            },
                            Nigori: {
                                name: 'Nigori',
                                localizedName: 'Nigori',
                                desciption: '',
                            },
                            Kijoshu: {
                                name: 'Kijoshu',
                                localizedName: 'Kijoshu',
                                desciption: '',
                            },
                            Koshu: {
                                name: 'Koshu',
                                localizedName: 'Koshu',
                                desciption: '',
                            },
                        },
                    },
                    'Junmai Daiginjo': {
                        name: 'Junmai Daiginjo',
                        localizedName: 'Junmai Daiginjo',
                        desciption: '',
                        children: {
                            Nama: {
                                name: 'Nama',
                                localizedName: 'Nama',
                                desciption: '',
                            },
                            Nigori: {
                                name: 'Nigori',
                                localizedName: 'Nigori',
                                desciption: '',
                            },
                        },
                    },
                    'Junmai Ginjo': {
                        name: 'Junmai Ginjo',
                        localizedName: 'Junmai Ginjo',
                        desciption: '',
                        children: {
                            Nama: {
                                name: 'Nama',
                                localizedName: 'Nama',
                                desciption: '',
                            },
                            Nigori: {
                                name: 'Nigori',
                                localizedName: 'Nigori',
                                desciption: '',
                            },
                            Kimoto: {
                                name: 'Kimoto',
                                localizedName: 'Kimoto',
                                desciption: '',
                            },
                        },
                    },
                    'Futsu-shu': {
                        name: 'Futsu-shu',
                        localizedName: 'Futsu-shu',
                        desciption: '',
                    },
                    Ginjo: {
                        name: 'Ginjo',
                        localizedName: 'Ginjo',
                        desciption: '',
                        children: {
                            Koshu: {
                                name: 'Koshu',
                                localizedName: 'Koshu',
                                desciption: '',
                            },
                        },
                    },
                    Hiyaoroshi: {
                        name: 'Hiyaoroshi',
                        localizedName: 'Hiyaoroshi',
                        desciption: '',
                    },
                    Honjozo: {
                        name: 'Honjozo',
                        localizedName: 'Honjozo',
                        desciption: '',
                    },
                    Matlagningssake: {
                        name: 'Matlagningssake',
                        localizedName: 'Matlagningssake',
                        desciption: '',
                    },
                    Sparkling: {
                        name: 'Sparkling',
                        localizedName: 'Sparkling',
                        desciption: '',
                        children: {
                            Nigori: {
                                name: 'Nigori',
                                localizedName: 'Nigori',
                                desciption: '',
                            },
                            Junmai: {
                                name: 'Junmai',
                                localizedName: 'Junmai',
                                desciption: '',
                            },
                            'Junmai Daiginjo': {
                                name: 'Junmai Daiginjo',
                                localizedName: 'Junmai Daiginjo',
                                desciption: '',
                            },
                            'Junmai Ginjo': {
                                name: 'Junmai Ginjo',
                                localizedName: 'Junmai Ginjo',
                                desciption: '',
                            },
                        },
                    },
                    Taru: {
                        name: 'Taru',
                        localizedName: 'Taru',
                        desciption: '',
                        children: {
                            Junmai: {
                                name: 'Junmai',
                                localizedName: 'Junmai',
                                desciption: '',
                            },
                        },
                    },
                    'Yuzu / Fruit sake': {
                        name: 'Yuzu / Fruit sake',
                        localizedName: 'Yuzu / Fruit sake',
                        desciption: '',
                    },
                },
            },
            Shochu: {
                name: 'Shochu',
                localizedName: 'Shochu',
                desciption: '',
                alcoholBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4010,
                        salesAccount: 3010,
                    },
                    DropShipping: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['MidRange', 'Wine'],
                children: {
                    Barley: {
                        name: 'Barley',
                        localizedName: 'Barley',
                        desciption: '',
                    },
                    Kokuto: {
                        name: 'Kokuto',
                        localizedName: 'Kokuto',
                        desciption: '',
                    },
                    Rice: {
                        name: 'Rice',
                        localizedName: 'Rice',
                        desciption: '',
                    },
                    'Sweet potato': {
                        name: 'Sweet potato',
                        localizedName: 'Sweet potato',
                        desciption: '',
                    },
                },
            },
            Umeshu: {
                name: 'Umeshu',
                localizedName: 'Umeshu',
                desciption: '',
                alcoholBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4010,
                        salesAccount: 3010,
                    },
                    DropShipping: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['MidRange', 'Wine'],
            },
            Öl: {
                name: 'Öl',
                localizedName: 'Öl',
                desciption: '',
                icon: 'https://assets.flaivy.com/drink, beverage, jug, glass, bottle, beer, alcohol.svg',
                immutableFields: {
                    nutritionDeclaration: null,
                    grapes: null,
                    vintage: null,
                    isSugarFree: null,
                    isLactoseFree: null,
                },
                alcoholBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4010,
                        salesAccount: 3010,
                    },
                    DropShipping: {
                        purchaseAccount: 4011,
                        salesAccount: 3011,
                    },
                },
                alcoholFreeBookKeepingAccounts: {
                    Commission: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                    OwnedByDrycks: {
                        purchaseAccount: 4014,
                        salesAccount: 3014,
                    },
                    DropShipping: {
                        purchaseAccount: 4017,
                        salesAccount: 3017,
                    },
                },
                alcoholTaxClasses: ['Beer'],
                children: {
                    Ale: {
                        name: 'Ale',
                        localizedName: 'Ale',
                        desciption: '',
                        children: {
                            APA: {
                                name: 'APA',
                                localizedName: 'APA',
                                desciption: '',
                            },
                            'Amber, brown & red ale': {
                                name: 'Amber, brown & red ale',
                                localizedName: 'Amber, brown & red ale',
                                desciption: '',
                            },
                            'Barley wine': {
                                name: 'Barley wine',
                                localizedName: 'Barley wine',
                                desciption: '',
                            },
                            'Belgisk ale': {
                                name: 'Belgisk ale',
                                localizedName: 'Belgisk ale',
                                desciption: '',
                            },
                            DIPA: {
                                name: 'DIPA',
                                localizedName: 'DIPA',
                                desciption: '',
                            },
                            IPA: {
                                name: 'IPA',
                                localizedName: 'IPA',
                                desciption: '',
                            },
                            NEIPA: {
                                name: 'NEIPA',
                                localizedName: 'NEIPA',
                                desciption: '',
                            },
                            NEPA: {
                                name: 'NEPA',
                                localizedName: 'NEPA',
                                desciption: '',
                            },
                            'Pale ale': {
                                name: 'Pale ale',
                                localizedName: 'Pale ale',
                                desciption: '',
                            },
                            Saison: {
                                name: 'Saison',
                                localizedName: 'Saison',
                                desciption: '',
                            },
                        },
                    },
                    Lager: {
                        name: 'Lager',
                        localizedName: 'Lager',
                        desciption: '',
                        children: {
                            'Humlig lager': {
                                name: 'Humlig lager',
                                localizedName: 'Humlig lager',
                                desciption: '',
                            },
                            'Ljus lager': {
                                name: 'Ljus lager',
                                localizedName: 'Ljus lager',
                                desciption: '',
                            },
                            'Mörk & mellanmörk lager': {
                                name: 'Mörk & mellanmörk lager',
                                localizedName: 'Mörk & mellanmörk lager',
                                desciption: '',
                            },
                        },
                    },
                    'Porter & stout': {
                        name: 'Porter & stout',
                        localizedName: 'Porter & stout',
                        desciption: '',
                    },
                    'Syrlig öl': {
                        name: 'Syrlig öl',
                        localizedName: 'Syrlig öl',
                        desciption: '',
                    },
                    Veteöl: {
                        name: 'Veteöl',
                        localizedName: 'Veteöl',
                        desciption: '',
                    },
                    'Övrigt öl': {
                        name: 'Övrigt öl',
                        localizedName: 'Övrigt öl',
                        desciption: '',
                    },
                },
            },
        },
    },
    Utrustning: {
        name: 'Utrustning',
        localizedName: 'Utrustning',
        desciption: '',
        icon: 'https://assets.flaivy.com/pot-2.svg',
        immutableFields: {
            alcoholPercentage: null,
            shelfLife: 'long',
            container: null,
            recycleType: null,
            volume: null,
            weight: null,
            ingredientsDeclaration: null,
            nutritionDeclaration: null,
            isEco: null,
            goesWith: null,
            appearance: null,
            scent: null,
            taste: null,
            grapes: null,
            seal: null,
            vintage: null,
            systembolagetArticleNumber: null,
            systembolagetSalesPrice: null,
            knNumber: null,
            exciseProductCode: null,
            alcoholTaxPaid: null,
            isVegan: null,
            isGelatinFree: null,
            isSugarFree: null,
            isLactoseFree: null,
            isPalmOilFree: null,
            isFrozen: null,
            isRefrigerated: null,
            isFoam: null,
            isCoated: null,
            isFudge: null,
            isGelatinous: null,
            isLiquorice: null,
            isHardCandy: null,
        },
        alcoholFreeBookKeepingAccounts: {
            Commission: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            OwnedByDrycks: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            DropShipping: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            StandAlone: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
        },
        alcoholTaxClasses: ['Alcoholfree'],
        children: {
            Köket: {
                name: 'Köket',
                localizedName: 'Köket',
                desciption: '',
                children: {
                    'Bageri & konditori': {
                        name: 'Bageri & konditori',
                        localizedName: 'Bageri & konditori',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/rolling-pin.svg',
                        children: {
                            Bakduk: {
                                name: 'Bakduk',
                                localizedName: 'Bakduk',
                                desciption: '',
                            },
                            Bakformar: {
                                name: 'Bakformar',
                                localizedName: 'Bakformar',
                                desciption: '',
                            },
                            Bakmatta: {
                                name: 'Bakmatta',
                                localizedName: 'Bakmatta',
                                desciption: '',
                            },
                            Bakplåt: {
                                name: 'Bakplåt',
                                localizedName: 'Bakplåt',
                                desciption: '',
                            },
                            Bakplåtar: {
                                name: 'Bakplåtar',
                                localizedName: 'Bakplåtar',
                                desciption: '',
                            },
                            Brödkavel: {
                                name: 'Brödkavel',
                                localizedName: 'Brödkavel',
                                desciption: '',
                            },
                            Chokladverktyg: {
                                name: 'Chokladverktyg',
                                localizedName: 'Chokladverktyg',
                                desciption: '',
                            },
                            Degskrapa: {
                                name: 'Degskrapa',
                                localizedName: 'Degskrapa',
                                desciption: '',
                            },
                            Degsporre: {
                                name: 'Degsporre',
                                localizedName: 'Degsporre',
                                desciption: '',
                            },
                            Jäskorgar: {
                                name: 'Jäskorgar',
                                localizedName: 'Jäskorgar',
                                desciption: '',
                            },
                            Kanttyll: {
                                name: 'Kanttyll',
                                localizedName: 'Kanttyll',
                                desciption: '',
                            },
                            Pajformar: {
                                name: 'Pajformar',
                                localizedName: 'Pajformar',
                                desciption: '',
                            },
                            Penslar: {
                                name: 'Penslar',
                                localizedName: 'Penslar',
                                desciption: '',
                            },
                            Plastbunkar: {
                                name: 'Plastbunkar',
                                localizedName: 'Plastbunkar',
                                desciption: '',
                            },
                            Pudersikt: {
                                name: 'Pudersikt',
                                localizedName: 'Pudersikt',
                                desciption: '',
                            },
                            'Rostfria bunkar': {
                                name: 'Rostfria bunkar',
                                localizedName: 'Rostfria bunkar',
                                desciption: '',
                            },
                            Rundtyllar: {
                                name: 'Rundtyllar',
                                localizedName: 'Rundtyllar',
                                desciption: '',
                            },
                            Sifoner: {
                                name: 'Sifoner',
                                localizedName: 'Sifoner',
                                desciption: '',
                            },
                            Silikonformar: {
                                name: 'Silikonformar',
                                localizedName: 'Silikonformar',
                                desciption: '',
                            },
                            Snittknivar: {
                                name: 'Snittknivar',
                                localizedName: 'Snittknivar',
                                desciption: '',
                            },
                            Sockerkaksform: {
                                name: 'Sockerkaksform',
                                localizedName: 'Sockerkaksform',
                                desciption: '',
                            },
                            Speceriskopa: {
                                name: 'Speceriskopa',
                                localizedName: 'Speceriskopa',
                                desciption: '',
                            },
                            Springform: {
                                name: 'Springform',
                                localizedName: 'Springform',
                                desciption: '',
                            },
                            Stjärntyllar: {
                                name: 'Stjärntyllar',
                                localizedName: 'Stjärntyllar',
                                desciption: '',
                            },
                            Tyllpåsar: {
                                name: 'Tyllpåsar',
                                localizedName: 'Tyllpåsar',
                                desciption: '',
                            },
                            Tyllsats: {
                                name: 'Tyllsats',
                                localizedName: 'Tyllsats',
                                desciption: '',
                            },
                            Tårtdelare: {
                                name: 'Tårtdelare',
                                localizedName: 'Tårtdelare',
                                desciption: '',
                            },
                            Tårtringar: {
                                name: 'Tårtringar',
                                localizedName: 'Tårtringar',
                                desciption: '',
                            },
                            Utstickarsats: {
                                name: 'Utstickarsats',
                                localizedName: 'Utstickarsats',
                                desciption: '',
                            },
                            'Övrigt baheri & konditori': {
                                name: 'Övrigt baheri & konditori',
                                localizedName: 'Övrigt baheri & konditori',
                                desciption: '',
                            },
                        },
                    },
                    Förvaring: {
                        name: 'Förvaring',
                        localizedName: 'Förvaring',
                        desciption: '',
                        children: {
                            Förvaringslådor: {
                                name: 'Förvaringslådor',
                                localizedName: 'Förvaringslådor',
                                desciption: '',
                            },
                            Hinkar: {
                                name: 'Hinkar',
                                localizedName: 'Hinkar',
                                desciption: '',
                            },
                            'Kyl & frysburkar': {
                                name: 'Kyl & frysburkar',
                                localizedName: 'Kyl & frysburkar',
                                desciption: '',
                            },
                            Torrförvaringsburkar: {
                                name: 'Torrförvaringsburkar',
                                localizedName: 'Torrförvaringsburkar',
                                desciption: '',
                            },
                            Tunnor: {
                                name: 'Tunnor',
                                localizedName: 'Tunnor',
                                desciption: '',
                            },
                        },
                    },
                    Kantiner: {
                        name: 'Kantiner',
                        localizedName: 'Kantiner',
                        desciption: '',
                        children: {
                            'ABC kantiner': {
                                name: 'ABC kantiner',
                                localizedName: 'ABC kantiner',
                                desciption: '',
                            },
                            'GN-kantiner': {
                                name: 'GN-kantiner',
                                localizedName: 'GN-kantiner',
                                desciption: '',
                            },
                        },
                    },
                    'Knivar & saxar': {
                        name: 'Knivar & saxar',
                        localizedName: 'Knivar & saxar',
                        desciption: '',
                        children: {
                            Allknivar: {
                                name: 'Allknivar',
                                localizedName: 'Allknivar',
                                desciption: '',
                            },
                            Grönsaksknivar: {
                                name: 'Grönsaksknivar',
                                localizedName: 'Grönsaksknivar',
                                desciption: '',
                            },
                            Knivslipning: {
                                name: 'Knivslipning',
                                localizedName: 'Knivslipning',
                                desciption: '',
                            },
                            Styckningsknivar: {
                                name: 'Styckningsknivar',
                                localizedName: 'Styckningsknivar',
                                desciption: '',
                            },
                            'Övrigt knivar & saxar': {
                                name: 'Övrigt knivar & saxar',
                                localizedName: 'Övrigt knivar & saxar',
                                desciption: '',
                            },
                        },
                    },
                    'Kokkärl & stekpannor': {
                        name: 'Kokkärl & stekpannor',
                        localizedName: 'Kokkärl & stekpannor',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/pot.svg',
                        children: {
                            Grytor: {
                                name: 'Grytor',
                                localizedName: 'Grytor',
                                desciption: '',
                            },
                            Grötkokare: {
                                name: 'Grötkokare',
                                localizedName: 'Grötkokare',
                                desciption: '',
                            },
                            Kastruller: {
                                name: 'Kastruller',
                                localizedName: 'Kastruller',
                                desciption: '',
                            },
                            Kittlar: {
                                name: 'Kittlar',
                                localizedName: 'Kittlar',
                                desciption: '',
                            },
                            Lock: {
                                name: 'Lock',
                                localizedName: 'Lock',
                                desciption: '',
                            },
                            Sauteuser: {
                                name: 'Sauteuser',
                                localizedName: 'Sauteuser',
                                desciption: '',
                            },
                            Stekfat: {
                                name: 'Stekfat',
                                localizedName: 'Stekfat',
                                desciption: '',
                            },
                            Stekpannor: {
                                name: 'Stekpannor',
                                localizedName: 'Stekpannor',
                                desciption: '',
                            },
                            Wokkpannor: {
                                name: 'Wokkpannor',
                                localizedName: 'Wokkpannor',
                                desciption: '',
                            },
                        },
                    },
                    Köksredskap: {
                        name: 'Köksredskap',
                        localizedName: 'Köksredskap',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/spatula.svg',
                        children: {
                            Citruspress: {
                                name: 'Citruspress',
                                localizedName: 'Citruspress',
                                desciption: '',
                            },
                            Flottyrslev: {
                                name: 'Flottyrslev',
                                localizedName: 'Flottyrslev',
                                desciption: '',
                            },
                            'Glass & mosskopor': {
                                name: 'Glass & mosskopor',
                                localizedName: 'Glass & mosskopor',
                                desciption: '',
                            },
                            Grillborstar: {
                                name: 'Grillborstar',
                                localizedName: 'Grillborstar',
                                desciption: '',
                            },
                            Grillskrapa: {
                                name: 'Grillskrapa',
                                localizedName: 'Grillskrapa',
                                desciption: '',
                            },
                            Grillskrapor: {
                                name: 'Grillskrapor',
                                localizedName: 'Grillskrapor',
                                desciption: '',
                            },
                            Grillsten: {
                                name: 'Grillsten',
                                localizedName: 'Grillsten',
                                desciption: '',
                            },
                            Konservöppnare: {
                                name: 'Konservöppnare',
                                localizedName: 'Konservöppnare',
                                desciption: '',
                            },
                            Lock: {
                                name: 'Lock',
                                localizedName: 'Lock',
                                desciption: '',
                            },
                            Mortel: {
                                name: 'Mortel',
                                localizedName: 'Mortel',
                                desciption: '',
                            },
                            Omrörare: {
                                name: 'Omrörare',
                                localizedName: 'Omrörare',
                                desciption: '',
                            },
                            Osthyvlar: {
                                name: 'Osthyvlar',
                                localizedName: 'Osthyvlar',
                                desciption: '',
                            },
                            Paj: {
                                name: 'Paj',
                                localizedName: 'Paj',
                                desciption: '',
                            },
                            Palett: {
                                name: 'Palett',
                                localizedName: 'Palett',
                                desciption: '',
                            },
                            Pastaslev: {
                                name: 'Pastaslev',
                                localizedName: 'Pastaslev',
                                desciption: '',
                            },
                            Plastskedar: {
                                name: 'Plastskedar',
                                localizedName: 'Plastskedar',
                                desciption: '',
                            },
                            Pommes: {
                                name: 'Pommes',
                                localizedName: 'Pommes',
                                desciption: '',
                            },
                            Portionering: {
                                name: 'Portionering',
                                localizedName: 'Portionering',
                                desciption: '',
                            },
                            Potatisstöt: {
                                name: 'Potatisstöt',
                                localizedName: 'Potatisstöt',
                                desciption: '',
                            },
                            Purépress: {
                                name: 'Purépress',
                                localizedName: 'Purépress',
                                desciption: '',
                            },
                            Rivjärn: {
                                name: 'Rivjärn',
                                localizedName: 'Rivjärn',
                                desciption: '',
                            },
                            Serv: {
                                name: 'Serv',
                                localizedName: 'Serv',
                                desciption: '',
                            },
                            Skalare: {
                                name: 'Skalare',
                                localizedName: 'Skalare',
                                desciption: '',
                            },
                            'Skaldjurs & nötknäckare': {
                                name: 'Skaldjurs & nötknäckare',
                                localizedName: 'Skaldjurs & nötknäckare',
                                desciption: '',
                            },
                            Skopor: {
                                name: 'Skopor',
                                localizedName: 'Skopor',
                                desciption: '',
                            },
                            Skumslevar: {
                                name: 'Skumslevar',
                                localizedName: 'Skumslevar',
                                desciption: '',
                            },
                            Slickepott: {
                                name: 'Slickepott',
                                localizedName: 'Slickepott',
                                desciption: '',
                            },
                            Stekbordsskyffel: {
                                name: 'Stekbordsskyffel',
                                localizedName: 'Stekbordsskyffel',
                                desciption: '',
                            },
                            Stekgaffel: {
                                name: 'Stekgaffel',
                                localizedName: 'Stekgaffel',
                                desciption: '',
                            },
                            Stekpincett: {
                                name: 'Stekpincett',
                                localizedName: 'Stekpincett',
                                desciption: '',
                            },
                            Stekspade: {
                                name: 'Stekspade',
                                localizedName: 'Stekspade',
                                desciption: '',
                            },
                            Stekvikt: {
                                name: 'Stekvikt',
                                localizedName: 'Stekvikt',
                                desciption: '',
                            },
                            Ströare: {
                                name: 'Ströare',
                                localizedName: 'Ströare',
                                desciption: '',
                            },
                            Såsportionering: {
                                name: 'Såsportionering',
                                localizedName: 'Såsportionering',
                                desciption: '',
                            },
                            Tillbehör: {
                                name: 'Tillbehör',
                                localizedName: 'Tillbehör',
                                desciption: '',
                            },
                            Tryffeljärn: {
                                name: 'Tryffeljärn',
                                localizedName: 'Tryffeljärn',
                                desciption: '',
                            },
                            Träslevar: {
                                name: 'Träslevar',
                                localizedName: 'Träslevar',
                                desciption: '',
                            },
                            Vitlökspress: {
                                name: 'Vitlökspress',
                                localizedName: 'Vitlökspress',
                                desciption: '',
                            },
                            Zestjärn: {
                                name: 'Zestjärn',
                                localizedName: 'Zestjärn',
                                desciption: '',
                            },
                            Äggskärare: {
                                name: 'Äggskärare',
                                localizedName: 'Äggskärare',
                                desciption: '',
                            },
                            Ösor: {
                                name: 'Ösor',
                                localizedName: 'Ösor',
                                desciption: '',
                            },
                            'Övrigt köksredskap': {
                                name: 'Övrigt köksredskap',
                                localizedName: 'Övrigt köksredskap',
                                desciption: '',
                            },
                        },
                    },
                    Köksutrustning: {
                        name: 'Köksutrustning',
                        localizedName: 'Köksutrustning',
                        desciption: '',
                        children: {
                            'Bonglist & spett': {
                                name: 'Bonglist & spett',
                                localizedName: 'Bonglist & spett',
                                desciption: '',
                            },
                            Brännare: {
                                name: 'Brännare',
                                localizedName: 'Brännare',
                                desciption: '',
                            },
                            Grillspett: {
                                name: 'Grillspett',
                                localizedName: 'Grillspett',
                                desciption: '',
                            },
                            Hamburgerpress: {
                                name: 'Hamburgerpress',
                                localizedName: 'Hamburgerpress',
                                desciption: '',
                            },
                            Mandolin: {
                                name: 'Mandolin',
                                localizedName: 'Mandolin',
                                desciption: '',
                            },
                            Plastflaskor: {
                                name: 'Plastflaskor',
                                localizedName: 'Plastflaskor',
                                desciption: '',
                            },
                            Skalare: {
                                name: 'Skalare',
                                localizedName: 'Skalare',
                                desciption: '',
                            },
                            'Squeez bottles': {
                                name: 'Squeez bottles',
                                localizedName: 'Squeez bottles',
                                desciption: '',
                            },
                            Såsportionering: {
                                name: 'Såsportionering',
                                localizedName: 'Såsportionering',
                                desciption: '',
                            },
                            'Övrigt köksutrustning': {
                                name: 'Övrigt köksutrustning',
                                localizedName: 'Övrigt köksutrustning',
                                desciption: '',
                            },
                        },
                    },
                    Mätverktyg: {
                        name: 'Mätverktyg',
                        localizedName: 'Mätverktyg',
                        desciption: '',
                        children: {
                            Köksmått: {
                                name: 'Köksmått',
                                localizedName: 'Köksmått',
                                desciption: '',
                            },
                            Termometer: {
                                name: 'Termometer',
                                localizedName: 'Termometer',
                                desciption: '',
                            },
                            Tidur: {
                                name: 'Tidur',
                                localizedName: 'Tidur',
                                desciption: '',
                            },
                            Vågar: {
                                name: 'Vågar',
                                localizedName: 'Vågar',
                                desciption: '',
                            },
                        },
                    },
                    'Pizza utrustning': {
                        name: 'Pizza utrustning',
                        localizedName: 'Pizza utrustning',
                        desciption: '',
                        children: {
                            Pizzadelare: {
                                name: 'Pizzadelare',
                                localizedName: 'Pizzadelare',
                                desciption: '',
                            },
                            Pizzaform: {
                                name: 'Pizzaform',
                                localizedName: 'Pizzaform',
                                desciption: '',
                            },
                            Pizzaspade: {
                                name: 'Pizzaspade',
                                localizedName: 'Pizzaspade',
                                desciption: '',
                            },
                        },
                    },
                    Skärbrädor: {
                        name: 'Skärbrädor',
                        localizedName: 'Skärbrädor',
                        desciption: '',
                        children: {
                            Plastskärbrädor: {
                                name: 'Plastskärbrädor',
                                localizedName: 'Plastskärbrädor',
                                desciption: '',
                            },
                            Träskärbrädor: {
                                name: 'Träskärbrädor',
                                localizedName: 'Träskärbrädor',
                                desciption: '',
                            },
                        },
                    },
                    'Trattar, silar & chinois': {
                        name: 'Trattar, silar & chinois',
                        localizedName: 'Trattar, silar & chinois',
                        desciption: '',
                        children: {
                            Armsil: {
                                name: 'Armsil',
                                localizedName: 'Armsil',
                                desciption: '',
                            },
                            Chinois: {
                                name: 'Chinois',
                                localizedName: 'Chinois',
                                desciption: '',
                            },
                            Durkslag: {
                                name: 'Durkslag',
                                localizedName: 'Durkslag',
                                desciption: '',
                            },
                            Passersil: {
                                name: 'Passersil',
                                localizedName: 'Passersil',
                                desciption: '',
                            },
                            Pipsil: {
                                name: 'Pipsil',
                                localizedName: 'Pipsil',
                                desciption: '',
                            },
                            Silduk: {
                                name: 'Silduk',
                                localizedName: 'Silduk',
                                desciption: '',
                            },
                            Tesil: {
                                name: 'Tesil',
                                localizedName: 'Tesil',
                                desciption: '',
                            },
                            Trattar: {
                                name: 'Trattar',
                                localizedName: 'Trattar',
                                desciption: '',
                            },
                        },
                    },
                    Tänger: {
                        name: 'Tänger',
                        localizedName: 'Tänger',
                        desciption: '',
                        children: {
                            Korvtång: {
                                name: 'Korvtång',
                                localizedName: 'Korvtång',
                                desciption: '',
                            },
                            Laxpincett: {
                                name: 'Laxpincett',
                                localizedName: 'Laxpincett',
                                desciption: '',
                            },
                            Laxtång: {
                                name: 'Laxtång',
                                localizedName: 'Laxtång',
                                desciption: '',
                            },
                            Salladstång: {
                                name: 'Salladstång',
                                localizedName: 'Salladstång',
                                desciption: '',
                            },
                            Serveringstång: {
                                name: 'Serveringstång',
                                localizedName: 'Serveringstång',
                                desciption: '',
                            },
                            Sockertång: {
                                name: 'Sockertång',
                                localizedName: 'Sockertång',
                                desciption: '',
                            },
                        },
                    },
                    Vispar: {
                        name: 'Vispar',
                        localizedName: 'Vispar',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/whisk.svg',
                        children: {
                            Ballongvispar: {
                                name: 'Ballongvispar',
                                localizedName: 'Ballongvispar',
                                desciption: '',
                            },
                            Spiralvisp: {
                                name: 'Spiralvisp',
                                localizedName: 'Spiralvisp',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            Matsal: {
                name: 'Matsal',
                localizedName: 'Matsal',
                desciption: '',
                icon: 'https://assets.flaivy.com/1.svg',
                children: {
                    Vispar: {
                        name: 'Vispar',
                        localizedName: 'Vispar',
                        desciption: '',
                    },
                    Barutrustning: {
                        name: 'Barutrustning',
                        localizedName: 'Barutrustning',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/blender.svg',
                        children: {
                            Barinredning: {
                                name: 'Barinredning',
                                localizedName: 'Barinredning',
                                desciption: '',
                            },
                            Barskedar: {
                                name: 'Barskedar',
                                localizedName: 'Barskedar',
                                desciption: '',
                            },
                            Champagnekylare: {
                                name: 'Champagnekylare',
                                localizedName: 'Champagnekylare',
                                desciption: '',
                            },
                            Cocktaildispenser: {
                                name: 'Cocktaildispenser',
                                localizedName: 'Cocktaildispenser',
                                desciption: '',
                            },
                            Droppkorkar: {
                                name: 'Droppkorkar',
                                localizedName: 'Droppkorkar',
                                desciption: '',
                            },
                            Flaskförslutning: {
                                name: 'Flaskförslutning',
                                localizedName: 'Flaskförslutning',
                                desciption: '',
                            },
                            Glashängare: {
                                name: 'Glashängare',
                                localizedName: 'Glashängare',
                                desciption: '',
                            },
                            Isskopor: {
                                name: 'Isskopor',
                                localizedName: 'Isskopor',
                                desciption: '',
                            },
                            Istänger: {
                                name: 'Istänger',
                                localizedName: 'Istänger',
                                desciption: '',
                            },
                            Isverktyg: {
                                name: 'Isverktyg',
                                localizedName: 'Isverktyg',
                                desciption: '',
                            },
                            Jiggers: {
                                name: 'Jiggers',
                                localizedName: 'Jiggers',
                                desciption: '',
                            },
                            Juiceflaskor: {
                                name: 'Juiceflaskor',
                                localizedName: 'Juiceflaskor',
                                desciption: '',
                            },
                            Kapsylöppnare: {
                                name: 'Kapsylöppnare',
                                localizedName: 'Kapsylöppnare',
                                desciption: '',
                            },
                            Rörglas: {
                                name: 'Rörglas',
                                localizedName: 'Rörglas',
                                desciption: '',
                            },
                            Shakers: {
                                name: 'Shakers',
                                localizedName: 'Shakers',
                                desciption: '',
                            },
                            Strainers: {
                                name: 'Strainers',
                                localizedName: 'Strainers',
                                desciption: '',
                            },
                            Stänkflaskor: {
                                name: 'Stänkflaskor',
                                localizedName: 'Stänkflaskor',
                                desciption: '',
                            },
                            Vinkylare: {
                                name: 'Vinkylare',
                                localizedName: 'Vinkylare',
                                desciption: '',
                            },
                            Vinöppnare: {
                                name: 'Vinöppnare',
                                localizedName: 'Vinöppnare',
                                desciption: '',
                            },
                            'Övrigt barutrustning': {
                                name: 'Övrigt barutrustning',
                                localizedName: 'Övrigt barutrustning',
                                desciption: '',
                            },
                        },
                    },
                    Bestick: {
                        name: 'Bestick',
                        localizedName: 'Bestick',
                        desciption: '',
                        children: {
                            Bakelsegaffel: {
                                name: 'Bakelsegaffel',
                                localizedName: 'Bakelsegaffel',
                                desciption: '',
                            },
                            Bordsgaffel: {
                                name: 'Bordsgaffel',
                                localizedName: 'Bordsgaffel',
                                desciption: '',
                            },
                            Bordskniv: {
                                name: 'Bordskniv',
                                localizedName: 'Bordskniv',
                                desciption: '',
                            },
                            Bordssked: {
                                name: 'Bordssked',
                                localizedName: 'Bordssked',
                                desciption: '',
                            },
                            Dessertgaffel: {
                                name: 'Dessertgaffel',
                                localizedName: 'Dessertgaffel',
                                desciption: '',
                            },
                            Dessertkniv: {
                                name: 'Dessertkniv',
                                localizedName: 'Dessertkniv',
                                desciption: '',
                            },
                            Dessertsked: {
                                name: 'Dessertsked',
                                localizedName: 'Dessertsked',
                                desciption: '',
                            },
                            Fiskbestick: {
                                name: 'Fiskbestick',
                                localizedName: 'Fiskbestick',
                                desciption: '',
                            },
                            Glassked: {
                                name: 'Glassked',
                                localizedName: 'Glassked',
                                desciption: '',
                            },
                            Grillbestick: {
                                name: 'Grillbestick',
                                localizedName: 'Grillbestick',
                                desciption: '',
                            },
                            Kaffesked: {
                                name: 'Kaffesked',
                                localizedName: 'Kaffesked',
                                desciption: '',
                            },
                            Matgaffel: {
                                name: 'Matgaffel',
                                localizedName: 'Matgaffel',
                                desciption: '',
                            },
                            Matkniv: {
                                name: 'Matkniv',
                                localizedName: 'Matkniv',
                                desciption: '',
                            },
                            Matsked: {
                                name: 'Matsked',
                                localizedName: 'Matsked',
                                desciption: '',
                            },
                            Serveringsgaffel: {
                                name: 'Serveringsgaffel',
                                localizedName: 'Serveringsgaffel',
                                desciption: '',
                            },
                            Serveringssked: {
                                name: 'Serveringssked',
                                localizedName: 'Serveringssked',
                                desciption: '',
                            },
                            Skaldjursbestick: {
                                name: 'Skaldjursbestick',
                                localizedName: 'Skaldjursbestick',
                                desciption: '',
                            },
                            Smörkniv: {
                                name: 'Smörkniv',
                                localizedName: 'Smörkniv',
                                desciption: '',
                            },
                            Snigeltång: {
                                name: 'Snigeltång',
                                localizedName: 'Snigeltång',
                                desciption: '',
                            },
                            Soppslev: {
                                name: 'Soppslev',
                                localizedName: 'Soppslev',
                                desciption: '',
                            },
                            Tesked: {
                                name: 'Tesked',
                                localizedName: 'Tesked',
                                desciption: '',
                            },
                            Tårtspade: {
                                name: 'Tårtspade',
                                localizedName: 'Tårtspade',
                                desciption: '',
                            },
                            'Övrigt bestick': {
                                name: 'Övrigt bestick',
                                localizedName: 'Övrigt bestick',
                                desciption: '',
                            },
                        },
                    },
                    'Formar & karotter': {
                        name: 'Formar & karotter',
                        localizedName: 'Formar & karotter',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/4.svg',
                        children: {
                            Gratängformar: {
                                name: 'Gratängformar',
                                localizedName: 'Gratängformar',
                                desciption: '',
                            },
                            Karotter: {
                                name: 'Karotter',
                                localizedName: 'Karotter',
                                desciption: '',
                            },
                            Kokotter: {
                                name: 'Kokotter',
                                localizedName: 'Kokotter',
                                desciption: '',
                            },
                            Krus: {
                                name: 'Krus',
                                localizedName: 'Krus',
                                desciption: '',
                            },
                            Portionsformar: {
                                name: 'Portionsformar',
                                localizedName: 'Portionsformar',
                                desciption: '',
                            },
                            Suffléformar: {
                                name: 'Suffléformar',
                                localizedName: 'Suffléformar',
                                desciption: '',
                            },
                        },
                    },
                    Glas: {
                        name: 'Glas',
                        localizedName: 'Glas',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/champagne.svg',
                        children: {
                            Aromglas: {
                                name: 'Aromglas',
                                localizedName: 'Aromglas',
                                desciption: '',
                            },
                            Champagneglas: {
                                name: 'Champagneglas',
                                localizedName: 'Champagneglas',
                                desciption: '',
                            },
                            Cocktailglas: {
                                name: 'Cocktailglas',
                                localizedName: 'Cocktailglas',
                                desciption: '',
                            },
                            Coupeglas: {
                                name: 'Coupeglas',
                                localizedName: 'Coupeglas',
                                desciption: '',
                            },
                            DOF: {
                                name: 'DOF',
                                localizedName: 'DOF',
                                desciption: '',
                            },
                            Dricksglas: {
                                name: 'Dricksglas',
                                localizedName: 'Dricksglas',
                                desciption: '',
                            },
                            Drinkglas: {
                                name: 'Drinkglas',
                                localizedName: 'Drinkglas',
                                desciption: '',
                            },
                            'Gin tonic glas': {
                                name: 'Gin tonic glas',
                                localizedName: 'Gin tonic glas',
                                desciption: '',
                            },
                            'Glass & dessertglas': {
                                name: 'Glass & dessertglas',
                                localizedName: 'Glass & dessertglas',
                                desciption: '',
                            },
                            Glögglas: {
                                name: 'Glögglas',
                                localizedName: 'Glögglas',
                                desciption: '',
                            },
                            Grappaglas: {
                                name: 'Grappaglas',
                                localizedName: 'Grappaglas',
                                desciption: '',
                            },
                            'Irish coffeeglas': {
                                name: 'Irish coffeeglas',
                                localizedName: 'Irish coffeeglas',
                                desciption: '',
                            },
                            Margaritaglas: {
                                name: 'Margaritaglas',
                                localizedName: 'Margaritaglas',
                                desciption: '',
                            },
                            'Old fashion': {
                                name: 'Old fashion',
                                localizedName: 'Old fashion',
                                desciption: '',
                            },
                            Shotsglas: {
                                name: 'Shotsglas',
                                localizedName: 'Shotsglas',
                                desciption: '',
                            },
                            Snapsglas: {
                                name: 'Snapsglas',
                                localizedName: 'Snapsglas',
                                desciption: '',
                            },
                            Starkvinsglas: {
                                name: 'Starkvinsglas',
                                localizedName: 'Starkvinsglas',
                                desciption: '',
                            },
                            Vattenglas: {
                                name: 'Vattenglas',
                                localizedName: 'Vattenglas',
                                desciption: '',
                            },
                            Whiskyglas: {
                                name: 'Whiskyglas',
                                localizedName: 'Whiskyglas',
                                desciption: '',
                            },
                            Vinglas: {
                                name: 'Vinglas',
                                localizedName: 'Vinglas',
                                desciption: '',
                            },
                            Ölglas: {
                                name: 'Ölglas',
                                localizedName: 'Ölglas',
                                desciption: '',
                            },
                            'Övrigt glas': {
                                name: 'Övrigt glas',
                                localizedName: 'Övrigt glas',
                                desciption: '',
                            },
                        },
                    },
                    'Kannor & snipor': {
                        name: 'Kannor & snipor',
                        localizedName: 'Kannor & snipor',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/coffee, machine, drink, beverage, kitchen.svg',
                        children: {
                            'Grädd & mjölkkannor': {
                                name: 'Grädd & mjölkkannor',
                                localizedName: 'Grädd & mjölkkannor',
                                desciption: '',
                            },
                            Kaffekannor: {
                                name: 'Kaffekannor',
                                localizedName: 'Kaffekannor',
                                desciption: '',
                            },
                            Såskanna: {
                                name: 'Såskanna',
                                localizedName: 'Såskanna',
                                desciption: '',
                            },
                            Såssnipa: {
                                name: 'Såssnipa',
                                localizedName: 'Såssnipa',
                                desciption: '',
                            },
                            Tekanna: {
                                name: 'Tekanna',
                                localizedName: 'Tekanna',
                                desciption: '',
                            },
                        },
                    },
                    'Koppar & fat': {
                        name: 'Koppar & fat',
                        localizedName: 'Koppar & fat',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/coffee, machine, drink, beverage, kitchen.svg',
                        children: {
                            Cappuccinofat: {
                                name: 'Cappuccinofat',
                                localizedName: 'Cappuccinofat',
                                desciption: '',
                            },
                            Cappuccinokoppar: {
                                name: 'Cappuccinokoppar',
                                localizedName: 'Cappuccinokoppar',
                                desciption: '',
                            },
                            Espressofat: {
                                name: 'Espressofat',
                                localizedName: 'Espressofat',
                                desciption: '',
                            },
                            Espressokoppar: {
                                name: 'Espressokoppar',
                                localizedName: 'Espressokoppar',
                                desciption: '',
                            },
                            Julepmuggar: {
                                name: 'Julepmuggar',
                                localizedName: 'Julepmuggar',
                                desciption: '',
                            },
                            Kaffefat: {
                                name: 'Kaffefat',
                                localizedName: 'Kaffefat',
                                desciption: '',
                            },
                            Kaffekoppar: {
                                name: 'Kaffekoppar',
                                localizedName: 'Kaffekoppar',
                                desciption: '',
                            },
                            Muggar: {
                                name: 'Muggar',
                                localizedName: 'Muggar',
                                desciption: '',
                            },
                            Tefat: {
                                name: 'Tefat',
                                localizedName: 'Tefat',
                                desciption: '',
                            },
                            Tekopp: {
                                name: 'Tekopp',
                                localizedName: 'Tekopp',
                                desciption: '',
                            },
                            Äggkopp: {
                                name: 'Äggkopp',
                                localizedName: 'Äggkopp',
                                desciption: '',
                            },
                            'Övrigt koppar & fat': {
                                name: 'Övrigt koppar & fat',
                                localizedName: 'Övrigt koppar & fat',
                                desciption: '',
                            },
                        },
                    },
                    Skålar: {
                        name: 'Skålar',
                        localizedName: 'Skålar',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/5.svg',
                        children: {
                            Glasskålar: {
                                name: 'Glasskålar',
                                localizedName: 'Glasskålar',
                                desciption: '',
                            },
                            Portionskål: {
                                name: 'Portionskål',
                                localizedName: 'Portionskål',
                                desciption: '',
                            },
                            Serveringsskålar: {
                                name: 'Serveringsskålar',
                                localizedName: 'Serveringsskålar',
                                desciption: '',
                            },
                            Skålar: {
                                name: 'Skålar',
                                localizedName: 'Skålar',
                                desciption: '',
                            },
                            Soppskålar: {
                                name: 'Soppskålar',
                                localizedName: 'Soppskålar',
                                desciption: '',
                            },
                            Såsskål: {
                                name: 'Såsskål',
                                localizedName: 'Såsskål',
                                desciption: '',
                            },
                            'Övrigt skålar': {
                                name: 'Övrigt skålar',
                                localizedName: 'Övrigt skålar',
                                desciption: '',
                            },
                        },
                    },
                    'Tallrikar & fat': {
                        name: 'Tallrikar & fat',
                        localizedName: 'Tallrikar & fat',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/5.svg',
                        children: {
                            Bufféfat: {
                                name: 'Bufféfat',
                                localizedName: 'Bufféfat',
                                desciption: '',
                            },
                            'Djupa tallrikar': {
                                name: 'Djupa tallrikar',
                                localizedName: 'Djupa tallrikar',
                                desciption: '',
                            },
                            'Flata tallrikar': {
                                name: 'Flata tallrikar',
                                localizedName: 'Flata tallrikar',
                                desciption: '',
                            },
                            'Kak & tårtfat': {
                                name: 'Kak & tårtfat',
                                localizedName: 'Kak & tårtfat',
                                desciption: '',
                            },
                            Serveringsfat: {
                                name: 'Serveringsfat',
                                localizedName: 'Serveringsfat',
                                desciption: '',
                            },
                            Skaldjursfat: {
                                name: 'Skaldjursfat',
                                localizedName: 'Skaldjursfat',
                                desciption: '',
                            },
                            Snigelfat: {
                                name: 'Snigelfat',
                                localizedName: 'Snigelfat',
                                desciption: '',
                            },
                            Tallrikslock: {
                                name: 'Tallrikslock',
                                localizedName: 'Tallrikslock',
                                desciption: '',
                            },
                            Tapasfat: {
                                name: 'Tapasfat',
                                localizedName: 'Tapasfat',
                                desciption: '',
                            },
                            Tillbehör: {
                                name: 'Tillbehör',
                                localizedName: 'Tillbehör',
                                desciption: '',
                            },
                            Ägglådor: {
                                name: 'Ägglådor',
                                localizedName: 'Ägglådor',
                                desciption: '',
                            },
                            'Övrigt tallrikar & fat': {
                                name: 'Övrigt tallrikar & fat',
                                localizedName: 'Övrigt tallrikar & fat',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Textilier, kläder & skor': {
                name: 'Textilier, kläder & skor',
                localizedName: 'Textilier, kläder & skor',
                desciption: '',
                icon: 'https://assets.flaivy.com/chef-hat.svg',
                children: {
                    Förkläden: {
                        name: 'Förkläden',
                        localizedName: 'Förkläden',
                        desciption: '',
                        children: {
                            Bröstlappsförkläden: {
                                name: 'Bröstlappsförkläden',
                                localizedName: 'Bröstlappsförkläden',
                                desciption: '',
                            },
                            Midjeförkläde: {
                                name: 'Midjeförkläde',
                                localizedName: 'Midjeförkläde',
                                desciption: '',
                            },
                        },
                    },
                    'Grytlappar & grillvantar': {
                        name: 'Grytlappar & grillvantar',
                        localizedName: 'Grytlappar & grillvantar',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/oven-mitt.svg',
                        children: {
                            Grytlappar: {
                                name: 'Grytlappar',
                                localizedName: 'Grytlappar',
                                desciption: '',
                            },
                            Ugnsvantar: {
                                name: 'Ugnsvantar',
                                localizedName: 'Ugnsvantar',
                                desciption: '',
                            },
                        },
                    },
                    Kläder: {
                        name: 'Kläder',
                        localizedName: 'Kläder',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/12.svg',
                        children: {
                            Frackhandskar: {
                                name: 'Frackhandskar',
                                localizedName: 'Frackhandskar',
                                desciption: '',
                            },
                            Kockbyxor: {
                                name: 'Kockbyxor',
                                localizedName: 'Kockbyxor',
                                desciption: '',
                            },
                            Kockrock: {
                                name: 'Kockrock',
                                localizedName: 'Kockrock',
                                desciption: '',
                            },
                            'Piké tröjor': {
                                name: 'Piké tröjor',
                                localizedName: 'Piké tröjor',
                                desciption: '',
                            },
                            Serveringsjacka: {
                                name: 'Serveringsjacka',
                                localizedName: 'Serveringsjacka',
                                desciption: '',
                            },
                            Skjortor: {
                                name: 'Skjortor',
                                localizedName: 'Skjortor',
                                desciption: '',
                            },
                            Skärskyddshandskar: {
                                name: 'Skärskyddshandskar',
                                localizedName: 'Skärskyddshandskar',
                                desciption: '',
                            },
                            Stekärm: {
                                name: 'Stekärm',
                                localizedName: 'Stekärm',
                                desciption: '',
                            },
                            Tillbehör: {
                                name: 'Tillbehör',
                                localizedName: 'Tillbehör',
                                desciption: '',
                            },
                            'T-shirt': {
                                name: 'T-shirt',
                                localizedName: 'T-shirt',
                                desciption: '',
                            },
                            'Övrigt kläder': {
                                name: 'Övrigt kläder',
                                localizedName: 'Övrigt kläder',
                                desciption: '',
                            },
                        },
                    },
                    Linne: {
                        name: 'Linne',
                        localizedName: 'Linne',
                        desciption: '',
                        children: {
                            Bordsdukar: {
                                name: 'Bordsdukar',
                                localizedName: 'Bordsdukar',
                                desciption: '',
                            },
                            Bordstabletter: {
                                name: 'Bordstabletter',
                                localizedName: 'Bordstabletter',
                                desciption: '',
                            },
                            Bäddlinné: {
                                name: 'Bäddlinné',
                                localizedName: 'Bäddlinné',
                                desciption: '',
                            },
                            Frottéhanddukar: {
                                name: 'Frottéhanddukar',
                                localizedName: 'Frottéhanddukar',
                                desciption: '',
                            },
                            Kökshanddukar: {
                                name: 'Kökshanddukar',
                                localizedName: 'Kökshanddukar',
                                desciption: '',
                            },
                            Servetter: {
                                name: 'Servetter',
                                localizedName: 'Servetter',
                                desciption: '',
                            },
                        },
                    },
                    Mössor: {
                        name: 'Mössor',
                        localizedName: 'Mössor',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/6.svg',
                        children: {
                            Bagarmössa: {
                                name: 'Bagarmössa',
                                localizedName: 'Bagarmössa',
                                desciption: '',
                            },
                            Keps: {
                                name: 'Keps',
                                localizedName: 'Keps',
                                desciption: '',
                            },
                            Kockmössa: {
                                name: 'Kockmössa',
                                localizedName: 'Kockmössa',
                                desciption: '',
                            },
                            Mössa: {
                                name: 'Mössa',
                                localizedName: 'Mössa',
                                desciption: '',
                            },
                            Schalett: {
                                name: 'Schalett',
                                localizedName: 'Schalett',
                                desciption: '',
                            },
                        },
                    },
                    Skor: {
                        name: 'Skor',
                        localizedName: 'Skor',
                        desciption: '',
                        children: {
                            Arbetsskor: {
                                name: 'Arbetsskor',
                                localizedName: 'Arbetsskor',
                                desciption: '',
                            },
                            Cloggs: {
                                name: 'Cloggs',
                                localizedName: 'Cloggs',
                                desciption: '',
                            },
                            Serveringsskor: {
                                name: 'Serveringsskor',
                                localizedName: 'Serveringsskor',
                                desciption: '',
                            },
                            Skohorn: {
                                name: 'Skohorn',
                                localizedName: 'Skohorn',
                                desciption: '',
                            },
                            Skyddsskor: {
                                name: 'Skyddsskor',
                                localizedName: 'Skyddsskor',
                                desciption: '',
                            },
                            Sulor: {
                                name: 'Sulor',
                                localizedName: 'Sulor',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Vagnar, maskiner & inredning': {
                name: 'Vagnar, maskiner & inredning',
                localizedName: 'Vagnar, maskiner & inredning',
                desciption: '',
                icon: 'https://assets.flaivy.com/coffee, machine, drink, beverage, kitchen.svg',
                children: {
                    Diskrum: {
                        name: 'Diskrum',
                        localizedName: 'Diskrum',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/9 (1).svg',
                        children: {
                            Baljor: {
                                name: 'Baljor',
                                localizedName: 'Baljor',
                                desciption: '',
                            },
                            Bestickskorgar: {
                                name: 'Bestickskorgar',
                                localizedName: 'Bestickskorgar',
                                desciption: '',
                            },
                            Bestickslådor: {
                                name: 'Bestickslådor',
                                localizedName: 'Bestickslådor',
                                desciption: '',
                            },
                            Bestickmuggar: {
                                name: 'Bestickmuggar',
                                localizedName: 'Bestickmuggar',
                                desciption: '',
                            },
                            Bestickställ: {
                                name: 'Bestickställ',
                                localizedName: 'Bestickställ',
                                desciption: '',
                            },
                            Diskkorgar: {
                                name: 'Diskkorgar',
                                localizedName: 'Diskkorgar',
                                desciption: '',
                            },
                            Diskställ: {
                                name: 'Diskställ',
                                localizedName: 'Diskställ',
                                desciption: '',
                            },
                            Korgvagn: {
                                name: 'Korgvagn',
                                localizedName: 'Korgvagn',
                                desciption: '',
                            },
                            Tallrikskassetter: {
                                name: 'Tallrikskassetter',
                                localizedName: 'Tallrikskassetter',
                                desciption: '',
                            },
                        },
                    },
                    Hushållsmaskiner: {
                        name: 'Hushållsmaskiner',
                        localizedName: 'Hushållsmaskiner',
                        desciption: '',
                        children: {
                            Blender: {
                                name: 'Blender',
                                localizedName: 'Blender',
                                desciption: '',
                            },
                            Brödrost: {
                                name: 'Brödrost',
                                localizedName: 'Brödrost',
                                desciption: '',
                            },
                            Elvisp: {
                                name: 'Elvisp',
                                localizedName: 'Elvisp',
                                desciption: '',
                            },
                            Juicepress: {
                                name: 'Juicepress',
                                localizedName: 'Juicepress',
                                desciption: '',
                            },
                            Kaffebryggare: {
                                name: 'Kaffebryggare',
                                localizedName: 'Kaffebryggare',
                                desciption: '',
                            },
                            Kaffekvarn: {
                                name: 'Kaffekvarn',
                                localizedName: 'Kaffekvarn',
                                desciption: '',
                            },
                            Kryddkvarn: {
                                name: 'Kryddkvarn',
                                localizedName: 'Kryddkvarn',
                                desciption: '',
                            },
                            Köksmaskiner: {
                                name: 'Köksmaskiner',
                                localizedName: 'Köksmaskiner',
                                desciption: '',
                            },
                            Stavmixer: {
                                name: 'Stavmixer',
                                localizedName: 'Stavmixer',
                                desciption: '',
                            },
                            Strykjärn: {
                                name: 'Strykjärn',
                                localizedName: 'Strykjärn',
                                desciption: '',
                            },
                            Vacuummaskiner: {
                                name: 'Vacuummaskiner',
                                localizedName: 'Vacuummaskiner',
                                desciption: '',
                            },
                            Vattenkokare: {
                                name: 'Vattenkokare',
                                localizedName: 'Vattenkokare',
                                desciption: '',
                            },
                            Våffeljärn: {
                                name: 'Våffeljärn',
                                localizedName: 'Våffeljärn',
                                desciption: '',
                            },
                        },
                    },
                    Inredning: {
                        name: 'Inredning',
                        localizedName: 'Inredning',
                        desciption: '',
                        children: {
                            Arbetsbänkar: {
                                name: 'Arbetsbänkar',
                                localizedName: 'Arbetsbänkar',
                                desciption: '',
                            },
                            Avspärrningsrep: {
                                name: 'Avspärrningsrep',
                                localizedName: 'Avspärrningsrep',
                                desciption: '',
                            },
                            Belysning: {
                                name: 'Belysning',
                                localizedName: 'Belysning',
                                desciption: '',
                            },
                            Brickställ: {
                                name: 'Brickställ',
                                localizedName: 'Brickställ',
                                desciption: '',
                            },
                            Ergonomihjälpmedel: {
                                name: 'Ergonomihjälpmedel',
                                localizedName: 'Ergonomihjälpmedel',
                                desciption: '',
                            },
                            Hyllgavel: {
                                name: 'Hyllgavel',
                                localizedName: 'Hyllgavel',
                                desciption: '',
                            },
                            Hyllplan: {
                                name: 'Hyllplan',
                                localizedName: 'Hyllplan',
                                desciption: '',
                            },
                            Hyllset: {
                                name: 'Hyllset',
                                localizedName: 'Hyllset',
                                desciption: '',
                            },
                            Möbler: {
                                name: 'Möbler',
                                localizedName: 'Möbler',
                                desciption: '',
                            },
                            Stolpar: {
                                name: 'Stolpar',
                                localizedName: 'Stolpar',
                                desciption: '',
                            },
                            Terassvärmare: {
                                name: 'Terassvärmare',
                                localizedName: 'Terassvärmare',
                                desciption: '',
                            },
                            Vattensifon: {
                                name: 'Vattensifon',
                                localizedName: 'Vattensifon',
                                desciption: '',
                            },
                            Vägghyllor: {
                                name: 'Vägghyllor',
                                localizedName: 'Vägghyllor',
                                desciption: '',
                            },
                            'Övrigt inredning': {
                                name: 'Övrigt inredning',
                                localizedName: 'Övrigt inredning',
                                desciption: '',
                            },
                        },
                    },
                    Mattransport: {
                        name: 'Mattransport',
                        localizedName: 'Mattransport',
                        desciption: '',
                        children: {
                            Isolerbox: {
                                name: 'Isolerbox',
                                localizedName: 'Isolerbox',
                                desciption: '',
                            },
                            Kombinerad: {
                                name: 'Kombinerad',
                                localizedName: 'Kombinerad',
                                desciption: '',
                            },
                            Kyla: {
                                name: 'Kyla',
                                localizedName: 'Kyla',
                                desciption: '',
                            },
                            Tillbehör: {
                                name: 'Tillbehör',
                                localizedName: 'Tillbehör',
                                desciption: '',
                            },
                            Värme: {
                                name: 'Värme',
                                localizedName: 'Värme',
                                desciption: '',
                            },
                        },
                    },
                    Restaurangmaskiner: {
                        name: 'Restaurangmaskiner',
                        localizedName: 'Restaurangmaskiner',
                        desciption: '',
                        children: {
                            'Bageri & blandningsmaskin': {
                                name: 'Bageri & blandningsmaskin',
                                localizedName: 'Bageri & blandningsmaskin',
                                desciption: '',
                            },
                            Blastchiller: {
                                name: 'Blastchiller',
                                localizedName: 'Blastchiller',
                                desciption: '',
                            },
                            Blender: {
                                name: 'Blender',
                                localizedName: 'Blender',
                                desciption: '',
                            },
                            Brödrost: {
                                name: 'Brödrost',
                                localizedName: 'Brödrost',
                                desciption: '',
                            },
                            Brödskärare: {
                                name: 'Brödskärare',
                                localizedName: 'Brödskärare',
                                desciption: '',
                            },
                            'Chafing dish': {
                                name: 'Chafing dish',
                                localizedName: 'Chafing dish',
                                desciption: '',
                            },
                            Cirkulator: {
                                name: 'Cirkulator',
                                localizedName: 'Cirkulator',
                                desciption: '',
                            },
                            Diskarmaturer: {
                                name: 'Diskarmaturer',
                                localizedName: 'Diskarmaturer',
                                desciption: '',
                            },
                            Elvisp: {
                                name: 'Elvisp',
                                localizedName: 'Elvisp',
                                desciption: '',
                            },
                            Espressomaskiner: {
                                name: 'Espressomaskiner',
                                localizedName: 'Espressomaskiner',
                                desciption: '',
                            },
                            Exponeringskylar: {
                                name: 'Exponeringskylar',
                                localizedName: 'Exponeringskylar',
                                desciption: '',
                            },
                            Fritöser: {
                                name: 'Fritöser',
                                localizedName: 'Fritöser',
                                desciption: '',
                            },
                            Frysskåp: {
                                name: 'Frysskåp',
                                localizedName: 'Frysskåp',
                                desciption: '',
                            },
                            Gasgrillar: {
                                name: 'Gasgrillar',
                                localizedName: 'Gasgrillar',
                                desciption: '',
                            },
                            Glaskylare: {
                                name: 'Glaskylare',
                                localizedName: 'Glaskylare',
                                desciption: '',
                            },
                            Glassmaskin: {
                                name: 'Glassmaskin',
                                localizedName: 'Glassmaskin',
                                desciption: '',
                            },
                            Grillar: {
                                name: 'Grillar',
                                localizedName: 'Grillar',
                                desciption: '',
                            },
                            Grönsaksskärare: {
                                name: 'Grönsaksskärare',
                                localizedName: 'Grönsaksskärare',
                                desciption: '',
                            },
                            Hetvattenbehållare: {
                                name: 'Hetvattenbehållare',
                                localizedName: 'Hetvattenbehållare',
                                desciption: '',
                            },
                            Huvdiskmaskin: {
                                name: 'Huvdiskmaskin',
                                localizedName: 'Huvdiskmaskin',
                                desciption: '',
                            },
                            Induktionshällar: {
                                name: 'Induktionshällar',
                                localizedName: 'Induktionshällar',
                                desciption: '',
                            },
                            Iskross: {
                                name: 'Iskross',
                                localizedName: 'Iskross',
                                desciption: '',
                            },
                            Ismaskiner: {
                                name: 'Ismaskiner',
                                localizedName: 'Ismaskiner',
                                desciption: '',
                            },
                            Juicemaskin: {
                                name: 'Juicemaskin',
                                localizedName: 'Juicemaskin',
                                desciption: '',
                            },
                            Juicepress: {
                                name: 'Juicepress',
                                localizedName: 'Juicepress',
                                desciption: '',
                            },
                            'Kaffe & vattenurna': {
                                name: 'Kaffe & vattenurna',
                                localizedName: 'Kaffe & vattenurna',
                                desciption: '',
                            },
                            Kaffebryggare: {
                                name: 'Kaffebryggare',
                                localizedName: 'Kaffebryggare',
                                desciption: '',
                            },
                            Kaffekvarn: {
                                name: 'Kaffekvarn',
                                localizedName: 'Kaffekvarn',
                                desciption: '',
                            },
                            Kaffemaskin: {
                                name: 'Kaffemaskin',
                                localizedName: 'Kaffemaskin',
                                desciption: '',
                            },
                            Kebabgrill: {
                                name: 'Kebabgrill',
                                localizedName: 'Kebabgrill',
                                desciption: '',
                            },
                            Klämgrillar: {
                                name: 'Klämgrillar',
                                localizedName: 'Klämgrillar',
                                desciption: '',
                            },
                            Korvvärmeri: {
                                name: 'Korvvärmeri',
                                localizedName: 'Korvvärmeri',
                                desciption: '',
                            },
                            Kylbänkar: {
                                name: 'Kylbänkar',
                                localizedName: 'Kylbänkar',
                                desciption: '',
                            },
                            Kylskåp: {
                                name: 'Kylskåp',
                                localizedName: 'Kylskåp',
                                desciption: '',
                            },
                            Köksmaskiner: {
                                name: 'Köksmaskiner',
                                localizedName: 'Köksmaskiner',
                                desciption: '',
                            },
                            Kösystem: {
                                name: 'Kösystem',
                                localizedName: 'Kösystem',
                                desciption: '',
                            },
                            Köttkvarn: {
                                name: 'Köttkvarn',
                                localizedName: 'Köttkvarn',
                                desciption: '',
                            },
                            Livsmedelstork: {
                                name: 'Livsmedelstork',
                                localizedName: 'Livsmedelstork',
                                desciption: '',
                            },
                            Mikrovågsugnar: {
                                name: 'Mikrovågsugnar',
                                localizedName: 'Mikrovågsugnar',
                                desciption: '',
                            },
                            Pastamaskin: {
                                name: 'Pastamaskin',
                                localizedName: 'Pastamaskin',
                                desciption: '',
                            },
                            Perkolator: {
                                name: 'Perkolator',
                                localizedName: 'Perkolator',
                                desciption: '',
                            },
                            Pizzakylbänk: {
                                name: 'Pizzakylbänk',
                                localizedName: 'Pizzakylbänk',
                                desciption: '',
                            },
                            Potatisskalare: {
                                name: 'Potatisskalare',
                                localizedName: 'Potatisskalare',
                                desciption: '',
                            },
                            Riskokare: {
                                name: 'Riskokare',
                                localizedName: 'Riskokare',
                                desciption: '',
                            },
                            Rökar: {
                                name: 'Rökar',
                                localizedName: 'Rökar',
                                desciption: '',
                            },
                            Salamander: {
                                name: 'Salamander',
                                localizedName: 'Salamander',
                                desciption: '',
                            },
                            Skärmaskiner: {
                                name: 'Skärmaskiner',
                                localizedName: 'Skärmaskiner',
                                desciption: '',
                            },
                            Snabbhack: {
                                name: 'Snabbhack',
                                localizedName: 'Snabbhack',
                                desciption: '',
                            },
                            Soppkittel: {
                                name: 'Soppkittel',
                                localizedName: 'Soppkittel',
                                desciption: '',
                            },
                            Spisar: {
                                name: 'Spisar',
                                localizedName: 'Spisar',
                                desciption: '',
                            },
                            Stativ: {
                                name: 'Stativ',
                                localizedName: 'Stativ',
                                desciption: '',
                            },
                            Stavmixer: {
                                name: 'Stavmixer',
                                localizedName: 'Stavmixer',
                                desciption: '',
                            },
                            Stekbord: {
                                name: 'Stekbord',
                                localizedName: 'Stekbord',
                                desciption: '',
                            },
                            Stekhäll: {
                                name: 'Stekhäll',
                                localizedName: 'Stekhäll',
                                desciption: '',
                            },
                            'Tallriksvagn & ställ': {
                                name: 'Tallriksvagn & ställ',
                                localizedName: 'Tallriksvagn & ställ',
                                desciption: '',
                            },
                            Termosbyggare: {
                                name: 'Termosbyggare',
                                localizedName: 'Termosbyggare',
                                desciption: '',
                            },
                            Tesamovar: {
                                name: 'Tesamovar',
                                localizedName: 'Tesamovar',
                                desciption: '',
                            },
                            Thermomixer: {
                                name: 'Thermomixer',
                                localizedName: 'Thermomixer',
                                desciption: '',
                            },
                            Ugnar: {
                                name: 'Ugnar',
                                localizedName: 'Ugnar',
                                desciption: '',
                            },
                            Underbänkdiskmaskin: {
                                name: 'Underbänkdiskmaskin',
                                localizedName: 'Underbänkdiskmaskin',
                                desciption: '',
                            },
                            Urnbryggare: {
                                name: 'Urnbryggare',
                                localizedName: 'Urnbryggare',
                                desciption: '',
                            },
                            Vacuummaskiner: {
                                name: 'Vacuummaskiner',
                                localizedName: 'Vacuummaskiner',
                                desciption: '',
                            },
                            Vattenbad: {
                                name: 'Vattenbad',
                                localizedName: 'Vattenbad',
                                desciption: '',
                            },
                            Vinkylskåp: {
                                name: 'Vinkylskåp',
                                localizedName: 'Vinkylskåp',
                                desciption: '',
                            },
                            Våffeljärn: {
                                name: 'Våffeljärn',
                                localizedName: 'Våffeljärn',
                                desciption: '',
                            },
                            Värmehällar: {
                                name: 'Värmehällar',
                                localizedName: 'Värmehällar',
                                desciption: '',
                            },
                            Värmelampor: {
                                name: 'Värmelampor',
                                localizedName: 'Värmelampor',
                                desciption: '',
                            },
                            Värmelister: {
                                name: 'Värmelister',
                                localizedName: 'Värmelister',
                                desciption: '',
                            },
                            Värmerier: {
                                name: 'Värmerier',
                                localizedName: 'Värmerier',
                                desciption: '',
                            },
                            Värmeskåp: {
                                name: 'Värmeskåp',
                                localizedName: 'Värmeskåp',
                                desciption: '',
                            },
                            'Övrigt restaurangmaskiner': {
                                name: 'Övrigt restaurangmaskiner',
                                localizedName: 'Övrigt restaurangmaskiner',
                                desciption: '',
                            },
                        },
                    },
                    'Städ & hygien': {
                        name: 'Städ & hygien',
                        localizedName: 'Städ & hygien',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/9 (1).svg',
                        children: {
                            Avfallshantering: {
                                name: 'Avfallshantering',
                                localizedName: 'Avfallshantering',
                                desciption: '',
                            },
                            Dammsugare: {
                                name: 'Dammsugare',
                                localizedName: 'Dammsugare',
                                desciption: '',
                            },
                            Hink: {
                                name: 'Hink',
                                localizedName: 'Hink',
                                desciption: '',
                            },
                            Sopborste: {
                                name: 'Sopborste',
                                localizedName: 'Sopborste',
                                desciption: '',
                            },
                            Städvagnar: {
                                name: 'Städvagnar',
                                localizedName: 'Städvagnar',
                                desciption: '',
                            },
                            Säckvagnar: {
                                name: 'Säckvagnar',
                                localizedName: 'Säckvagnar',
                                desciption: '',
                            },
                            'Tunnor och lock': {
                                name: 'Tunnor och lock',
                                localizedName: 'Tunnor och lock',
                                desciption: '',
                            },
                            'Övrigt städ & hygien': {
                                name: 'Övrigt städ & hygien',
                                localizedName: 'Övrigt städ & hygien',
                                desciption: '',
                            },
                        },
                    },
                    Vagnar: {
                        name: 'Vagnar',
                        localizedName: 'Vagnar',
                        desciption: '',
                        children: {
                            Backvagn: {
                                name: 'Backvagn',
                                localizedName: 'Backvagn',
                                desciption: '',
                            },
                            Bassängvagn: {
                                name: 'Bassängvagn',
                                localizedName: 'Bassängvagn',
                                desciption: '',
                            },
                            Bordsvagn: {
                                name: 'Bordsvagn',
                                localizedName: 'Bordsvagn',
                                desciption: '',
                            },
                            Brickvagn: {
                                name: 'Brickvagn',
                                localizedName: 'Brickvagn',
                                desciption: '',
                            },
                            Buffévagnar: {
                                name: 'Buffévagnar',
                                localizedName: 'Buffévagnar',
                                desciption: '',
                            },
                            Diskgodsvagn: {
                                name: 'Diskgodsvagn',
                                localizedName: 'Diskgodsvagn',
                                desciption: '',
                            },
                            Dispenservagn: {
                                name: 'Dispenservagn',
                                localizedName: 'Dispenservagn',
                                desciption: '',
                            },
                            Hjul: {
                                name: 'Hjul',
                                localizedName: 'Hjul',
                                desciption: '',
                            },
                            Kantinvagn: {
                                name: 'Kantinvagn',
                                localizedName: 'Kantinvagn',
                                desciption: '',
                            },
                            Korgvagn: {
                                name: 'Korgvagn',
                                localizedName: 'Korgvagn',
                                desciption: '',
                            },
                            Köksvagn: {
                                name: 'Köksvagn',
                                localizedName: 'Köksvagn',
                                desciption: '',
                            },
                            Lyftvagn: {
                                name: 'Lyftvagn',
                                localizedName: 'Lyftvagn',
                                desciption: '',
                            },
                            Magasinkärra: {
                                name: 'Magasinkärra',
                                localizedName: 'Magasinkärra',
                                desciption: '',
                            },
                            Platåvagn: {
                                name: 'Platåvagn',
                                localizedName: 'Platåvagn',
                                desciption: '',
                            },
                            Redskapsvagn: {
                                name: 'Redskapsvagn',
                                localizedName: 'Redskapsvagn',
                                desciption: '',
                            },
                            Rullbord: {
                                name: 'Rullbord',
                                localizedName: 'Rullbord',
                                desciption: '',
                            },
                            Serveringsvagn: {
                                name: 'Serveringsvagn',
                                localizedName: 'Serveringsvagn',
                                desciption: '',
                            },
                            Speceribinge: {
                                name: 'Speceribinge',
                                localizedName: 'Speceribinge',
                                desciption: '',
                            },
                            Tallriksdispenservagn: {
                                name: 'Tallriksdispenservagn',
                                localizedName: 'Tallriksdispenservagn',
                                desciption: '',
                            },
                            'Tillbehör till vagnar': {
                                name: 'Tillbehör till vagnar',
                                localizedName: 'Tillbehör till vagnar',
                                desciption: '',
                            },
                            'Vagn till tunnor': {
                                name: 'Vagn till tunnor',
                                localizedName: 'Vagn till tunnor',
                                desciption: '',
                            },
                        },
                    },
                },
            },
        },
    },
    'Non food': {
        name: 'Non food',
        localizedName: 'Non food',
        desciption: '',
        immutableFields: {
            alcoholPercentage: null,
            shelfLife: 'long',
            container: null,
            recycleType: null,
            volume: null,
            ingredientsDeclaration: null,
            nutritionDeclaration: null,
            isEco: null,
            goesWith: null,
            appearance: null,
            scent: null,
            taste: null,
            grapes: null,
            seal: null,
            vintage: null,
            systembolagetArticleNumber: null,
            systembolagetSalesPrice: null,
            knNumber: null,
            exciseProductCode: null,
            alcoholTaxPaid: null,
            isVegan: null,
            isGelatinFree: null,
            isSugarFree: null,
            isLactoseFree: null,
            isPalmOilFree: null,
            isFrozen: null,
            isRefrigerated: null,
            isFoam: null,
            isCoated: null,
            isFudge: null,
            isGelatinous: null,
            isLiquorice: null,
            isHardCandy: null,
        },
        alcoholFreeBookKeepingAccounts: {
            Commission: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            OwnedByDrycks: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            DropShipping: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            StandAlone: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
        },
        alcoholTaxClasses: ['Alcoholfree'],
        children: {
            Läkemedel: {
                name: 'Läkemedel',
                localizedName: 'Läkemedel',
                desciption: '',
                icon: 'https://assets.flaivy.com/coffee.svg',
            },
            Engångsmaterial: {
                name: 'Engångsmaterial',
                localizedName: 'Engångsmaterial',
                desciption: '',
                icon: 'https://assets.flaivy.com/coffee.svg',
                children: {
                    'Bageri & konditori': {
                        name: 'Bageri & konditori',
                        localizedName: 'Bageri & konditori',
                        desciption: '',
                        children: {
                            Bakelsekartong: {
                                name: 'Bakelsekartong',
                                localizedName: 'Bakelsekartong',
                                desciption: '',
                            },
                            Bakformar: {
                                name: 'Bakformar',
                                localizedName: 'Bakformar',
                                desciption: '',
                            },
                            Brödback: {
                                name: 'Brödback',
                                localizedName: 'Brödback',
                                desciption: '',
                            },
                            Bullformar: {
                                name: 'Bullformar',
                                localizedName: 'Bullformar',
                                desciption: '',
                            },
                            Cellofan: {
                                name: 'Cellofan',
                                localizedName: 'Cellofan',
                                desciption: '',
                            },
                            Fatpapper: {
                                name: 'Fatpapper',
                                localizedName: 'Fatpapper',
                                desciption: '',
                            },
                            Konfektyrformar: {
                                name: 'Konfektyrformar',
                                localizedName: 'Konfektyrformar',
                                desciption: '',
                            },
                            Muffinsformar: {
                                name: 'Muffinsformar',
                                localizedName: 'Muffinsformar',
                                desciption: '',
                            },
                            Pajformar: {
                                name: 'Pajformar',
                                localizedName: 'Pajformar',
                                desciption: '',
                            },
                            Semlekartong: {
                                name: 'Semlekartong',
                                localizedName: 'Semlekartong',
                                desciption: '',
                            },
                            Smörgåsformar: {
                                name: 'Smörgåsformar',
                                localizedName: 'Smörgåsformar',
                                desciption: '',
                            },
                            Spetspapper: {
                                name: 'Spetspapper',
                                localizedName: 'Spetspapper',
                                desciption: '',
                            },
                            'Tyllar & tyllpåsar': {
                                name: 'Tyllar & tyllpåsar',
                                localizedName: 'Tyllar & tyllpåsar',
                                desciption: '',
                            },
                            Tårtbricka: {
                                name: 'Tårtbricka',
                                localizedName: 'Tårtbricka',
                                desciption: '',
                            },
                            Tårtkartonger: {
                                name: 'Tårtkartonger',
                                localizedName: 'Tårtkartonger',
                                desciption: '',
                            },
                            Tårtpapper: {
                                name: 'Tårtpapper',
                                localizedName: 'Tårtpapper',
                                desciption: '',
                            },
                            'Övrigt bageri & konditori': {
                                name: 'Övrigt bageri & konditori',
                                localizedName: 'Övrigt bageri & konditori',
                                desciption: '',
                            },
                        },
                    },
                    Barartiklar: {
                        name: 'Barartiklar',
                        localizedName: 'Barartiklar',
                        desciption: '',
                        children: {
                            Cocktailpinnar: {
                                name: 'Cocktailpinnar',
                                localizedName: 'Cocktailpinnar',
                                desciption: '',
                            },
                            'Dekoration & tillbehör': {
                                name: 'Dekoration & tillbehör',
                                localizedName: 'Dekoration & tillbehör',
                                desciption: '',
                            },
                            Drinkpinnar: {
                                name: 'Drinkpinnar',
                                localizedName: 'Drinkpinnar',
                                desciption: '',
                            },
                            Kolsyra: {
                                name: 'Kolsyra',
                                localizedName: 'Kolsyra',
                                desciption: '',
                            },
                            Sugrör: {
                                name: 'Sugrör',
                                localizedName: 'Sugrör',
                                desciption: '',
                            },
                        },
                    },
                    Bestick: {
                        name: 'Bestick',
                        localizedName: 'Bestick',
                        desciption: '',
                        children: {
                            Plastbestick: {
                                name: 'Plastbestick',
                                localizedName: 'Plastbestick',
                                desciption: '',
                            },
                            Träbestick: {
                                name: 'Träbestick',
                                localizedName: 'Träbestick',
                                desciption: '',
                            },
                        },
                    },
                    'Butik & emballage': {
                        name: 'Butik & emballage',
                        localizedName: 'Butik & emballage',
                        desciption: '',
                        children: {
                            'Band, snöre & garn': {
                                name: 'Band, snöre & garn',
                                localizedName: 'Band, snöre & garn',
                                desciption: '',
                            },
                            Emballagepapper: {
                                name: 'Emballagepapper',
                                localizedName: 'Emballagepapper',
                                desciption: '',
                            },
                            Märketiketter: {
                                name: 'Märketiketter',
                                localizedName: 'Märketiketter',
                                desciption: '',
                            },
                            'Presentpapper & tillbehör': {
                                name: 'Presentpapper & tillbehör',
                                localizedName: 'Presentpapper & tillbehör',
                                desciption: '',
                            },
                            'Övrigt butik & emballage': {
                                name: 'Övrigt butik & emballage',
                                localizedName: 'Övrigt butik & emballage',
                                desciption: '',
                            },
                        },
                    },
                    'Bärkassar & påsar': {
                        name: 'Bärkassar & påsar',
                        localizedName: 'Bärkassar & påsar',
                        desciption: '',
                        children: {
                            Bygelpåsar: {
                                name: 'Bygelpåsar',
                                localizedName: 'Bygelpåsar',
                                desciption: '',
                            },
                            Bärkassar: {
                                name: 'Bärkassar',
                                localizedName: 'Bärkassar',
                                desciption: '',
                            },
                            Cellofanpåsar: {
                                name: 'Cellofanpåsar',
                                localizedName: 'Cellofanpåsar',
                                desciption: '',
                            },
                            Fryspåsar: {
                                name: 'Fryspåsar',
                                localizedName: 'Fryspåsar',
                                desciption: '',
                            },
                            Grillpåsar: {
                                name: 'Grillpåsar',
                                localizedName: 'Grillpåsar',
                                desciption: '',
                            },
                            Planpåsar: {
                                name: 'Planpåsar',
                                localizedName: 'Planpåsar',
                                desciption: '',
                            },
                            Plastpåsar: {
                                name: 'Plastpåsar',
                                localizedName: 'Plastpåsar',
                                desciption: '',
                            },
                            Räkpåsar: {
                                name: 'Räkpåsar',
                                localizedName: 'Räkpåsar',
                                desciption: '',
                            },
                            'Sos & kanisterpåsar': {
                                name: 'Sos & kanisterpåsar',
                                localizedName: 'Sos & kanisterpåsar',
                                desciption: '',
                            },
                            Specialpåsar: {
                                name: 'Specialpåsar',
                                localizedName: 'Specialpåsar',
                                desciption: '',
                            },
                            'Take away låda': {
                                name: 'Take away låda',
                                localizedName: 'Take away låda',
                                desciption: '',
                            },
                            Tillbehör: {
                                name: 'Tillbehör',
                                localizedName: 'Tillbehör',
                                desciption: '',
                            },
                            Vacuumpåsar: {
                                name: 'Vacuumpåsar',
                                localizedName: 'Vacuumpåsar',
                                desciption: '',
                            },
                        },
                    },
                    Fastfood: {
                        name: 'Fastfood',
                        localizedName: 'Fastfood',
                        desciption: '',
                        children: {
                            'Fish n chips': {
                                name: 'Fish n chips',
                                localizedName: 'Fish n chips',
                                desciption: '',
                            },
                            Hamburgerbox: {
                                name: 'Hamburgerbox',
                                localizedName: 'Hamburgerbox',
                                desciption: '',
                            },
                            Hamburgerfickor: {
                                name: 'Hamburgerfickor',
                                localizedName: 'Hamburgerfickor',
                                desciption: '',
                            },
                            Hamburgerpapper: {
                                name: 'Hamburgerpapper',
                                localizedName: 'Hamburgerpapper',
                                desciption: '',
                            },
                            KebabKorvpapper: {
                                name: 'KebabKorvpapper',
                                localizedName: 'KebabKorvpapper',
                                desciption: '',
                            },
                            'Mostråg & tallrikar': {
                                name: 'Mostråg & tallrikar',
                                localizedName: 'Mostråg & tallrikar',
                                desciption: '',
                            },
                            'Pommes frites bägare': {
                                name: 'Pommes frites bägare',
                                localizedName: 'Pommes frites bägare',
                                desciption: '',
                            },
                            Popcornbägare: {
                                name: 'Popcornbägare',
                                localizedName: 'Popcornbägare',
                                desciption: '',
                            },
                            Tapasformar: {
                                name: 'Tapasformar',
                                localizedName: 'Tapasformar',
                                desciption: '',
                            },
                            Wrappapper: {
                                name: 'Wrappapper',
                                localizedName: 'Wrappapper',
                                desciption: '',
                            },
                        },
                    },
                    'Film & folie': {
                        name: 'Film & folie',
                        localizedName: 'Film & folie',
                        desciption: '',
                        children: {
                            Aluminiumfolie: {
                                name: 'Aluminiumfolie',
                                localizedName: 'Aluminiumfolie',
                                desciption: '',
                            },
                            Dispenser: {
                                name: 'Dispenser',
                                localizedName: 'Dispenser',
                                desciption: '',
                            },
                            Storköksfilm: {
                                name: 'Storköksfilm',
                                localizedName: 'Storköksfilm',
                                desciption: '',
                            },
                            'Övrigt film & folie': {
                                name: 'Övrigt film & folie',
                                localizedName: 'Övrigt film & folie',
                                desciption: '',
                            },
                        },
                    },
                    'Glas, muggar & lock': {
                        name: 'Glas, muggar & lock',
                        localizedName: 'Glas, muggar & lock',
                        desciption: '',
                        children: {
                            'Muggar för kalldryck': {
                                name: 'Muggar för kalldryck',
                                localizedName: 'Muggar för kalldryck',
                                desciption: '',
                            },
                            'Muggar för varmdryck': {
                                name: 'Muggar för varmdryck',
                                localizedName: 'Muggar för varmdryck',
                                desciption: '',
                            },
                            Plastglas: {
                                name: 'Plastglas',
                                localizedName: 'Plastglas',
                                desciption: '',
                            },
                            Tillbehör: {
                                name: 'Tillbehör',
                                localizedName: 'Tillbehör',
                                desciption: '',
                            },
                            'Övrigt glas, muggar & lock': {
                                name: 'Övrigt glas, muggar & lock',
                                localizedName: 'Övrigt glas, muggar & lock',
                                desciption: '',
                            },
                        },
                    },
                    'Grillkol & bricketter': {
                        name: 'Grillkol & bricketter',
                        localizedName: 'Grillkol & bricketter',
                        desciption: '',
                        children: {
                            Grillbricketter: {
                                name: 'Grillbricketter',
                                localizedName: 'Grillbricketter',
                                desciption: '',
                            },
                            Grillkol: {
                                name: 'Grillkol',
                                localizedName: 'Grillkol',
                                desciption: '',
                            },
                            Grilltillbehör: {
                                name: 'Grilltillbehör',
                                localizedName: 'Grilltillbehör',
                                desciption: '',
                                children: {
                                    Tändvätska: {
                                        name: 'Tändvätska',
                                        localizedName: 'Tändvätska',
                                        desciption: '',
                                    },
                                },
                            },
                        },
                    },
                    Kontorsmaterial: {
                        name: 'Kontorsmaterial',
                        localizedName: 'Kontorsmaterial',
                        desciption: '',
                        children: {
                            Batterier: {
                                name: 'Batterier',
                                localizedName: 'Batterier',
                                desciption: '',
                            },
                            Block: {
                                name: 'Block',
                                localizedName: 'Block',
                                desciption: '',
                            },
                            Kvittorullar: {
                                name: 'Kvittorullar',
                                localizedName: 'Kvittorullar',
                                desciption: '',
                            },
                            Lampor: {
                                name: 'Lampor',
                                localizedName: 'Lampor',
                                desciption: '',
                            },
                            Pennor: {
                                name: 'Pennor',
                                localizedName: 'Pennor',
                                desciption: '',
                            },
                            Tillbehör: {
                                name: 'Tillbehör',
                                localizedName: 'Tillbehör',
                                desciption: '',
                            },
                            'Övrigt kontorsmaterial': {
                                name: 'Övrigt kontorsmaterial',
                                localizedName: 'Övrigt kontorsmaterial',
                                desciption: '',
                                children: {
                                    Tejp: {
                                        name: 'Tejp',
                                        localizedName: 'Tejp',
                                        desciption: '',
                                    },
                                },
                            },
                        },
                    },
                    Livsmedelspapper: {
                        name: 'Livsmedelspapper',
                        localizedName: 'Livsmedelspapper',
                        desciption: '',
                        children: {
                            Absorber: {
                                name: 'Absorber',
                                localizedName: 'Absorber',
                                desciption: '',
                            },
                            Bakplåtspapper: {
                                name: 'Bakplåtspapper',
                                localizedName: 'Bakplåtspapper',
                                desciption: '',
                            },
                            'Delikatess & charkark': {
                                name: 'Delikatess & charkark',
                                localizedName: 'Delikatess & charkark',
                                desciption: '',
                            },
                            Kraftpapper: {
                                name: 'Kraftpapper',
                                localizedName: 'Kraftpapper',
                                desciption: '',
                            },
                            Smörpapper: {
                                name: 'Smörpapper',
                                localizedName: 'Smörpapper',
                                desciption: '',
                            },
                            Sulfitpapper: {
                                name: 'Sulfitpapper',
                                localizedName: 'Sulfitpapper',
                                desciption: '',
                            },
                            'Vaxat papper': {
                                name: 'Vaxat papper',
                                localizedName: 'Vaxat papper',
                                desciption: '',
                            },
                        },
                    },
                    'Ljus & lyktor': {
                        name: 'Ljus & lyktor',
                        localizedName: 'Ljus & lyktor',
                        desciption: '',
                        children: {
                            Antikljus: {
                                name: 'Antikljus',
                                localizedName: 'Antikljus',
                                desciption: '',
                            },
                            Blockljus: {
                                name: 'Blockljus',
                                localizedName: 'Blockljus',
                                desciption: '',
                            },
                            Kanalljus: {
                                name: 'Kanalljus',
                                localizedName: 'Kanalljus',
                                desciption: '',
                            },
                            Kronljus: {
                                name: 'Kronljus',
                                localizedName: 'Kronljus',
                                desciption: '',
                            },
                            'Lyktor & ljushållare': {
                                name: 'Lyktor & ljushållare',
                                localizedName: 'Lyktor & ljushållare',
                                desciption: '',
                            },
                            Marschaller: {
                                name: 'Marschaller',
                                localizedName: 'Marschaller',
                                desciption: '',
                            },
                            'Tändare & tändstickor': {
                                name: 'Tändare & tändstickor',
                                localizedName: 'Tändare & tändstickor',
                                desciption: '',
                            },
                            Värmeljus: {
                                name: 'Värmeljus',
                                localizedName: 'Värmeljus',
                                desciption: '',
                            },
                        },
                    },
                    Matförpackningar: {
                        name: 'Matförpackningar',
                        localizedName: 'Matförpackningar',
                        desciption: '',
                        children: {
                            Alumuminiumformar: {
                                name: 'Alumuminiumformar',
                                localizedName: 'Alumuminiumformar',
                                desciption: '',
                            },
                            'Deli & dressingbägare': {
                                name: 'Deli & dressingbägare',
                                localizedName: 'Deli & dressingbägare',
                                desciption: '',
                            },
                            'Dessert & miniformar': {
                                name: 'Dessert & miniformar',
                                localizedName: 'Dessert & miniformar',
                                desciption: '',
                            },
                            Duniform: {
                                name: 'Duniform',
                                localizedName: 'Duniform',
                                desciption: '',
                            },
                            Flaskor: {
                                name: 'Flaskor',
                                localizedName: 'Flaskor',
                                desciption: '',
                            },
                            Förvaringsburkar: {
                                name: 'Förvaringsburkar',
                                localizedName: 'Förvaringsburkar',
                                desciption: '',
                            },
                            Glassbägare: {
                                name: 'Glassbägare',
                                localizedName: 'Glassbägare',
                                desciption: '',
                            },
                            Hämtlådor: {
                                name: 'Hämtlådor',
                                localizedName: 'Hämtlådor',
                                desciption: '',
                            },
                            Mikroformar: {
                                name: 'Mikroformar',
                                localizedName: 'Mikroformar',
                                desciption: '',
                            },
                            Nudelbägare: {
                                name: 'Nudelbägare',
                                localizedName: 'Nudelbägare',
                                desciption: '',
                            },
                            Pizzakartonger: {
                                name: 'Pizzakartonger',
                                localizedName: 'Pizzakartonger',
                                desciption: '',
                            },
                            Salladsformar: {
                                name: 'Salladsformar',
                                localizedName: 'Salladsformar',
                                desciption: '',
                            },
                            Smörgåsformar: {
                                name: 'Smörgåsformar',
                                localizedName: 'Smörgåsformar',
                                desciption: '',
                            },
                            Soppbägare: {
                                name: 'Soppbägare',
                                localizedName: 'Soppbägare',
                                desciption: '',
                            },
                            Sushiformar: {
                                name: 'Sushiformar',
                                localizedName: 'Sushiformar',
                                desciption: '',
                            },
                            Äggkopp: {
                                name: 'Äggkopp',
                                localizedName: 'Äggkopp',
                                desciption: '',
                            },
                            'Övrigt matförpackningar': {
                                name: 'Övrigt matförpackningar',
                                localizedName: 'Övrigt matförpackningar',
                                desciption: '',
                            },
                        },
                    },
                    'Servetter & dukar': {
                        name: 'Servetter & dukar',
                        localizedName: 'Servetter & dukar',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/1.svg',
                        children: {
                            Bordstabletter: {
                                name: 'Bordstabletter',
                                localizedName: 'Bordstabletter',
                                desciption: '',
                            },
                            Dukar: {
                                name: 'Dukar',
                                localizedName: 'Dukar',
                                desciption: '',
                            },
                            Servetter: {
                                name: 'Servetter',
                                localizedName: 'Servetter',
                                desciption: '',
                            },
                            Vepa: {
                                name: 'Vepa',
                                localizedName: 'Vepa',
                                desciption: '',
                            },
                            'Övrigt servetter & dukar': {
                                name: 'Övrigt servetter & dukar',
                                localizedName: 'Övrigt servetter & dukar',
                                desciption: '',
                            },
                        },
                    },
                    'Tallrikar & assietter': {
                        name: 'Tallrikar & assietter',
                        localizedName: 'Tallrikar & assietter',
                        desciption: '',
                        children: {
                            Papperstallrikar: {
                                name: 'Papperstallrikar',
                                localizedName: 'Papperstallrikar',
                                desciption: '',
                            },
                            Plasttallrik: {
                                name: 'Plasttallrik',
                                localizedName: 'Plasttallrik',
                                desciption: '',
                            },
                            'Trä & palmbladstallrikar': {
                                name: 'Trä & palmbladstallrikar',
                                localizedName: 'Trä & palmbladstallrikar',
                                desciption: '',
                            },
                            'Övrigt tallrikar & assietter': {
                                name: 'Övrigt tallrikar & assietter',
                                localizedName: 'Övrigt tallrikar & assietter',
                                desciption: '',
                            },
                        },
                    },
                    'Te & kaffefilter': {
                        name: 'Te & kaffefilter',
                        localizedName: 'Te & kaffefilter',
                        desciption: '',
                        children: {
                            Kaffefilter: {
                                name: 'Kaffefilter',
                                localizedName: 'Kaffefilter',
                                desciption: '',
                            },
                            Tefilter: {
                                name: 'Tefilter',
                                localizedName: 'Tefilter',
                                desciption: '',
                            },
                        },
                    },
                    'Uppläggningsfat & serveringsskålar': {
                        name: 'Uppläggningsfat & serveringsskålar',
                        localizedName: 'Uppläggningsfat & serveringsskålar',
                        desciption: '',
                        children: {
                            Serveringsskålar: {
                                name: 'Serveringsskålar',
                                localizedName: 'Serveringsskålar',
                                desciption: '',
                            },
                            Uppläggningsfat: {
                                name: 'Uppläggningsfat',
                                localizedName: 'Uppläggningsfat',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Personlig hygien': {
                name: 'Personlig hygien',
                localizedName: 'Personlig hygien',
                desciption: '',
                children: {
                    Barnartiklar: {
                        name: 'Barnartiklar',
                        localizedName: 'Barnartiklar',
                        desciption: '',
                        children: {
                            Blöjor: {
                                name: 'Blöjor',
                                localizedName: 'Blöjor',
                                desciption: '',
                            },
                            Haklappar: {
                                name: 'Haklappar',
                                localizedName: 'Haklappar',
                                desciption: '',
                            },
                            Tvättlappar: {
                                name: 'Tvättlappar',
                                localizedName: 'Tvättlappar',
                                desciption: '',
                            },
                            'Underlag skötbord': {
                                name: 'Underlag skötbord',
                                localizedName: 'Underlag skötbord',
                                desciption: '',
                            },
                        },
                    },
                    Desinfektion: {
                        name: 'Desinfektion',
                        localizedName: 'Desinfektion',
                        desciption: '',
                        children: {
                            Handdesinfektion: {
                                name: 'Handdesinfektion',
                                localizedName: 'Handdesinfektion',
                                desciption: '',
                            },
                        },
                    },
                    'Första hjälpen': {
                        name: 'Första hjälpen',
                        localizedName: 'Första hjälpen',
                        desciption: '',
                        children: {
                            Blodstoppare: {
                                name: 'Blodstoppare',
                                localizedName: 'Blodstoppare',
                                desciption: '',
                            },
                            Brännskadegel: {
                                name: 'Brännskadegel',
                                localizedName: 'Brännskadegel',
                                desciption: '',
                            },
                            'Förstahjälpen station': {
                                name: 'Förstahjälpen station',
                                localizedName: 'Förstahjälpen station',
                                desciption: '',
                            },
                            Plåster: {
                                name: 'Plåster',
                                localizedName: 'Plåster',
                                desciption: '',
                            },
                            Ögondusch: {
                                name: 'Ögondusch',
                                localizedName: 'Ögondusch',
                                desciption: '',
                            },
                            'Övrigt första hjälpen': {
                                name: 'Övrigt första hjälpen',
                                localizedName: 'Övrigt första hjälpen',
                                desciption: '',
                            },
                        },
                    },
                    Handskar: {
                        name: 'Handskar',
                        localizedName: 'Handskar',
                        desciption: '',
                        children: {
                            Bomullshandskar: {
                                name: 'Bomullshandskar',
                                localizedName: 'Bomullshandskar',
                                desciption: '',
                            },
                            Diskhandskar: {
                                name: 'Diskhandskar',
                                localizedName: 'Diskhandskar',
                                desciption: '',
                            },
                            Dispenser: {
                                name: 'Dispenser',
                                localizedName: 'Dispenser',
                                desciption: '',
                            },
                            Latexhandskar: {
                                name: 'Latexhandskar',
                                localizedName: 'Latexhandskar',
                                desciption: '',
                            },
                            Nitrilhandskar: {
                                name: 'Nitrilhandskar',
                                localizedName: 'Nitrilhandskar',
                                desciption: '',
                            },
                            'PE handskar': {
                                name: 'PE handskar',
                                localizedName: 'PE handskar',
                                desciption: '',
                            },
                            Vinylhandskar: {
                                name: 'Vinylhandskar',
                                localizedName: 'Vinylhandskar',
                                desciption: '',
                            },
                            'Övrigt handskar': {
                                name: 'Övrigt handskar',
                                localizedName: 'Övrigt handskar',
                                desciption: '',
                            },
                        },
                    },
                    Hygienartiklar: {
                        name: 'Hygienartiklar',
                        localizedName: 'Hygienartiklar',
                        desciption: '',
                        children: {
                            Tandborstar: {
                                name: 'Tandborstar',
                                localizedName: 'Tandborstar',
                                desciption: '',
                            },
                            Tandkräm: {
                                name: 'Tandkräm',
                                localizedName: 'Tandkräm',
                                desciption: '',
                            },
                            Solkräm: {
                                name: 'Solkräm',
                                localizedName: 'Solkräm',
                                desciption: '',
                            },
                            Bindor: {
                                name: 'Bindor',
                                localizedName: 'Bindor',
                                desciption: '',
                            },
                            Tamponger: {
                                name: 'Tamponger',
                                localizedName: 'Tamponger',
                                desciption: '',
                            },
                            Trosskydd: {
                                name: 'Trosskydd',
                                localizedName: 'Trosskydd',
                                desciption: '',
                            },
                            Kondomer: {
                                name: 'Kondomer',
                                localizedName: 'Kondomer',
                                desciption: '',
                            },
                            Deodoranter: {
                                name: 'Deodoranter',
                                localizedName: 'Deodoranter',
                                desciption: '',
                            },
                            Hudkräm: {
                                name: 'Hudkräm',
                                localizedName: 'Hudkräm',
                                desciption: '',
                            },
                            Hygienartiklar: {
                                name: 'Hygienartiklar',
                                localizedName: 'Hygienartiklar',
                                desciption: '',
                            },
                            Nagelborste: {
                                name: 'Nagelborste',
                                localizedName: 'Nagelborste',
                                desciption: '',
                            },
                            Tandpetare: {
                                name: 'Tandpetare',
                                localizedName: 'Tandpetare',
                                desciption: '',
                            },
                            Våtservett: {
                                name: 'Våtservett',
                                localizedName: 'Våtservett',
                                desciption: '',
                            },
                            'Övrigt hygienartiklar': {
                                name: 'Övrigt hygienartiklar',
                                localizedName: 'Övrigt hygienartiklar',
                                desciption: '',
                            },
                        },
                    },
                    'Kläder & skydd': {
                        name: 'Kläder & skydd',
                        localizedName: 'Kläder & skydd',
                        desciption: '',
                        icon: 'https://assets.flaivy.com/12.svg',
                        children: {
                            Britspapper: {
                                name: 'Britspapper',
                                localizedName: 'Britspapper',
                                desciption: '',
                            },
                            Engångsförkläde: {
                                name: 'Engångsförkläde',
                                localizedName: 'Engångsförkläde',
                                desciption: '',
                            },
                            Haklapp: {
                                name: 'Haklapp',
                                localizedName: 'Haklapp',
                                desciption: '',
                            },
                            Munskydd: {
                                name: 'Munskydd',
                                localizedName: 'Munskydd',
                                desciption: '',
                            },
                            'Mössor & Hårnät': {
                                name: 'Mössor & Hårnät',
                                localizedName: 'Mössor & Hårnät',
                                desciption: '',
                            },
                            Skoskydd: {
                                name: 'Skoskydd',
                                localizedName: 'Skoskydd',
                                desciption: '',
                            },
                            Skyddglasögon: {
                                name: 'Skyddglasögon',
                                localizedName: 'Skyddglasögon',
                                desciption: '',
                            },
                            Skäggskydd: {
                                name: 'Skäggskydd',
                                localizedName: 'Skäggskydd',
                                desciption: '',
                            },
                            'Övrigt kläder & skydd': {
                                name: 'Övrigt kläder & skydd',
                                localizedName: 'Övrigt kläder & skydd',
                                desciption: '',
                            },
                        },
                    },
                    'Tvål & schampo': {
                        name: 'Tvål & schampo',
                        localizedName: 'Tvål & schampo',
                        desciption: '',
                        children: {
                            Duschtvål: {
                                name: 'Duschtvål',
                                localizedName: 'Duschtvål',
                                desciption: '',
                            },
                            Handtvål: {
                                name: 'Handtvål',
                                localizedName: 'Handtvål',
                                desciption: '',
                            },
                            'Schampo & Balsam': {
                                name: 'Schampo & Balsam',
                                localizedName: 'Schampo & Balsam',
                                desciption: '',
                                children: {
                                    Schampo: {
                                        name: 'Schampo',
                                        localizedName: 'Schampo',
                                        desciption: '',
                                    },
                                    Balsam: {
                                        name: 'Balsam',
                                        localizedName: 'Balsam',
                                        desciption: '',
                                    },
                                },
                            },
                            Tvåldispenser: {
                                name: 'Tvåldispenser',
                                localizedName: 'Tvåldispenser',
                                desciption: '',
                            },
                            'Övrigt tvål & schampo': {
                                name: 'Övrigt tvål & schampo',
                                localizedName: 'Övrigt tvål & schampo',
                                desciption: '',
                            },
                        },
                    },
                },
            },
            'Städ & hygien': {
                name: 'Städ & hygien',
                localizedName: 'Städ & hygien',
                desciption: '',
                icon: 'https://assets.flaivy.com/9 (1).svg',
                children: {
                    Avfallshantering: {
                        name: 'Avfallshantering',
                        localizedName: 'Avfallshantering',
                        desciption: '',
                        children: {
                            Avfallspåse: {
                                name: 'Avfallspåse',
                                localizedName: 'Avfallspåse',
                                desciption: '',
                            },
                            Papperskorg: {
                                name: 'Papperskorg',
                                localizedName: 'Papperskorg',
                                desciption: '',
                            },
                            Sanitetspåse: {
                                name: 'Sanitetspåse',
                                localizedName: 'Sanitetspåse',
                                desciption: '',
                            },
                            Sopsäck: {
                                name: 'Sopsäck',
                                localizedName: 'Sopsäck',
                                desciption: '',
                            },
                            Säckställ: {
                                name: 'Säckställ',
                                localizedName: 'Säckställ',
                                desciption: '',
                            },
                            Tillbehör: {
                                name: 'Tillbehör',
                                localizedName: 'Tillbehör',
                                desciption: '',
                            },
                            'Övrigt avfallshantering': {
                                name: 'Övrigt avfallshantering',
                                localizedName: 'Övrigt avfallshantering',
                                desciption: '',
                            },
                        },
                    },
                    'Disk & städredskap': {
                        name: 'Disk & städredskap',
                        localizedName: 'Disk & städredskap',
                        desciption: '',
                        children: {
                            Allduk: {
                                name: 'Allduk',
                                localizedName: 'Allduk',
                                desciption: '',
                            },
                            Bänkskrapa: {
                                name: 'Bänkskrapa',
                                localizedName: 'Bänkskrapa',
                                desciption: '',
                            },
                            Dammborste: {
                                name: 'Dammborste',
                                localizedName: 'Dammborste',
                                desciption: '',
                            },
                            Diskborste: {
                                name: 'Diskborste',
                                localizedName: 'Diskborste',
                                desciption: '',
                            },
                            Diskduk: {
                                name: 'Diskduk',
                                localizedName: 'Diskduk',
                                desciption: '',
                            },
                            Engångsduk: {
                                name: 'Engångsduk',
                                localizedName: 'Engångsduk',
                                desciption: '',
                            },
                            Fogborste: {
                                name: 'Fogborste',
                                localizedName: 'Fogborste',
                                desciption: '',
                            },
                            Fönstertvätt: {
                                name: 'Fönstertvätt',
                                localizedName: 'Fönstertvätt',
                                desciption: '',
                            },
                            Golvborste: {
                                name: 'Golvborste',
                                localizedName: 'Golvborste',
                                desciption: '',
                            },
                            Golvraka: {
                                name: 'Golvraka',
                                localizedName: 'Golvraka',
                                desciption: '',
                            },
                            'Grillpad, stålbollar & Stålull': {
                                name: 'Grillpad, stålbollar & Stålull',
                                localizedName: 'Grillpad, stålbollar & Stålull',
                                desciption: '',
                            },
                            Handskrapor: {
                                name: 'Handskrapor',
                                localizedName: 'Handskrapor',
                                desciption: '',
                            },
                            Mikrofiberduk: {
                                name: 'Mikrofiberduk',
                                localizedName: 'Mikrofiberduk',
                                desciption: '',
                            },
                            'Moppar & svabbar': {
                                name: 'Moppar & svabbar',
                                localizedName: 'Moppar & svabbar',
                                desciption: '',
                            },
                            Rengöringssvamp: {
                                name: 'Rengöringssvamp',
                                localizedName: 'Rengöringssvamp',
                                desciption: '',
                            },
                            Rörborste: {
                                name: 'Rörborste',
                                localizedName: 'Rörborste',
                                desciption: '',
                            },
                            Skaft: {
                                name: 'Skaft',
                                localizedName: 'Skaft',
                                desciption: '',
                            },
                            Skumspruta: {
                                name: 'Skumspruta',
                                localizedName: 'Skumspruta',
                                desciption: '',
                            },
                            Skurborstar: {
                                name: 'Skurborstar',
                                localizedName: 'Skurborstar',
                                desciption: '',
                            },
                            Skurdukar: {
                                name: 'Skurdukar',
                                localizedName: 'Skurdukar',
                                desciption: '',
                            },
                            Sopborstar: {
                                name: 'Sopborstar',
                                localizedName: 'Sopborstar',
                                desciption: '',
                            },
                            Sopset: {
                                name: 'Sopset',
                                localizedName: 'Sopset',
                                desciption: '',
                            },
                            Städhinkar: {
                                name: 'Städhinkar',
                                localizedName: 'Städhinkar',
                                desciption: '',
                            },
                            Svabbvagn: {
                                name: 'Svabbvagn',
                                localizedName: 'Svabbvagn',
                                desciption: '',
                            },
                            Toalettborstar: {
                                name: 'Toalettborstar',
                                localizedName: 'Toalettborstar',
                                desciption: '',
                            },
                            Vattenslang: {
                                name: 'Vattenslang',
                                localizedName: 'Vattenslang',
                                desciption: '',
                            },
                            Vägghållare: {
                                name: 'Vägghållare',
                                localizedName: 'Vägghållare',
                                desciption: '',
                            },
                            'Övrigt disk & städredskap': {
                                name: 'Övrigt disk & städredskap',
                                localizedName: 'Övrigt disk & städredskap',
                                desciption: '',
                            },
                        },
                    },
                    Diskkem: {
                        name: 'Diskkem',
                        localizedName: 'Diskkem',
                        desciption: '',
                        children: {
                            Avkalkningsmedel: {
                                name: 'Avkalkningsmedel',
                                localizedName: 'Avkalkningsmedel',
                                desciption: '',
                            },
                            Blötläggningsmedel: {
                                name: 'Blötläggningsmedel',
                                localizedName: 'Blötläggningsmedel',
                                desciption: '',
                            },
                            Handdisk: {
                                name: 'Handdisk',
                                localizedName: 'Handdisk',
                                desciption: '',
                            },
                            Maskindiskmedel: {
                                name: 'Maskindiskmedel',
                                localizedName: 'Maskindiskmedel',
                                desciption: '',
                            },
                            Torkmedel: {
                                name: 'Torkmedel',
                                localizedName: 'Torkmedel',
                                desciption: '',
                            },
                        },
                    },
                    Städkem: {
                        name: 'Städkem',
                        localizedName: 'Städkem',
                        desciption: '',
                        children: {
                            Allrengöring: {
                                name: 'Allrengöring',
                                localizedName: 'Allrengöring',
                                desciption: '',
                            },
                            Desinfektion: {
                                name: 'Desinfektion',
                                localizedName: 'Desinfektion',
                                desciption: '',
                            },
                            Fläckborttagning: {
                                name: 'Fläckborttagning',
                                localizedName: 'Fläckborttagning',
                                desciption: '',
                            },
                            Frysrengöring: {
                                name: 'Frysrengöring',
                                localizedName: 'Frysrengöring',
                                desciption: '',
                            },
                            Glasputs: {
                                name: 'Glasputs',
                                localizedName: 'Glasputs',
                                desciption: '',
                            },
                            Golvrengöring: {
                                name: 'Golvrengöring',
                                localizedName: 'Golvrengöring',
                                desciption: '',
                            },
                            Grovrengöring: {
                                name: 'Grovrengöring',
                                localizedName: 'Grovrengöring',
                                desciption: '',
                            },
                            Kaffemaskinrengöring: {
                                name: 'Kaffemaskinrengöring',
                                localizedName: 'Kaffemaskinrengöring',
                                desciption: '',
                            },
                            Köksrengöring: {
                                name: 'Köksrengöring',
                                localizedName: 'Köksrengöring',
                                desciption: '',
                            },
                            Luftförbättrare: {
                                name: 'Luftförbättrare',
                                localizedName: 'Luftförbättrare',
                                desciption: '',
                            },
                            Metallrengöring: {
                                name: 'Metallrengöring',
                                localizedName: 'Metallrengöring',
                                desciption: '',
                            },
                            Sanitet: {
                                name: 'Sanitet',
                                localizedName: 'Sanitet',
                                desciption: '',
                            },
                            Såpa: {
                                name: 'Såpa',
                                localizedName: 'Såpa',
                                desciption: '',
                            },
                            'Ugn & grill': {
                                name: 'Ugn & grill',
                                localizedName: 'Ugn & grill',
                                desciption: '',
                            },
                            'Övrigt städkem': {
                                name: 'Övrigt städkem',
                                localizedName: 'Övrigt städkem',
                                desciption: '',
                            },
                        },
                    },
                    'Toalett & torkpapper': {
                        name: 'Toalett & torkpapper',
                        localizedName: 'Toalett & torkpapper',
                        desciption: '',
                        children: {
                            Handdukar: {
                                name: 'Handdukar',
                                localizedName: 'Handdukar',
                                desciption: '',
                            },
                            Hushållspapper: {
                                name: 'Hushållspapper',
                                localizedName: 'Hushållspapper',
                                desciption: '',
                            },
                            Toalettpapper: {
                                name: 'Toalettpapper',
                                localizedName: 'Toalettpapper',
                                desciption: '',
                            },
                            Torkpapper: {
                                name: 'Torkpapper',
                                localizedName: 'Torkpapper',
                                desciption: '',
                            },
                        },
                    },
                    Tvättkem: {
                        name: 'Tvättkem',
                        localizedName: 'Tvättkem',
                        desciption: '',
                        children: {
                            'Blek & fläckbortagning': {
                                name: 'Blek & fläckbortagning',
                                localizedName: 'Blek & fläckbortagning',
                                desciption: '',
                            },
                            Sköljmedel: {
                                name: 'Sköljmedel',
                                localizedName: 'Sköljmedel',
                                desciption: '',
                            },
                            Tvättmedel: {
                                name: 'Tvättmedel',
                                localizedName: 'Tvättmedel',
                                desciption: '',
                            },
                        },
                    },
                },
            },
        },
    },
    'Nikotin & tobak': {
        name: 'Nikotin & tobak',
        localizedName: 'Nikotin & tobak',
        desciption: '',
        immutableFields: {
            alcoholPercentage: null,
            shelfLife: 'long',
            container: null,
            recycleType: null,
            volume: null,
            nutritionDeclaration: null,
            isEco: null,
            goesWith: null,
            appearance: null,
            scent: null,
            taste: null,
            grapes: null,
            seal: null,
            vintage: null,
            systembolagetArticleNumber: null,
            systembolagetSalesPrice: null,
            knNumber: null,
            exciseProductCode: null,
            alcoholTaxPaid: null,
            isVegan: null,
            isGelatinFree: null,
            isSugarFree: null,
            isLactoseFree: null,
            isPalmOilFree: null,
            isFrozen: null,
            isRefrigerated: null,
            isFoam: null,
            isCoated: null,
            isFudge: null,
            isGelatinous: null,
            isLiquorice: null,
            isHardCandy: null,
        },
        alcoholFreeBookKeepingAccounts: {
            Commission: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            OwnedByDrycks: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            DropShipping: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            StandAlone: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
        },
        alcoholTaxClasses: ['Alcoholfree'],
        children: {
            Röktobak: {
                name: 'Röktobak',
                localizedName: 'Röktobak',
                desciption: '',
                children: {
                    Cigaretter: {
                        name: 'Cigaretter',
                        localizedName: 'Cigaretter',
                        desciption: '',
                    },
                    Cigariller: {
                        name: 'Cigariller',
                        localizedName: 'Cigariller',
                        desciption: '',
                    },
                    Cigarrer: {
                        name: 'Cigarrer',
                        localizedName: 'Cigarrer',
                        desciption: '',
                    },
                    Piptobak: {
                        name: 'Piptobak',
                        localizedName: 'Piptobak',
                        desciption: '',
                    },
                    Rulltobak: {
                        name: 'Rulltobak',
                        localizedName: 'Rulltobak',
                        desciption: '',
                    },
                },
            },
            Snus: {
                name: 'Snus',
                localizedName: 'Snus',
                desciption: '',
                children: {
                    'All white': {
                        name: 'All white',
                        localizedName: 'All white',
                        desciption: '',
                    },
                    Lössnus: {
                        name: 'Lössnus',
                        localizedName: 'Lössnus',
                        desciption: '',
                    },
                    'Nikotinfritt snus': {
                        name: 'Nikotinfritt snus',
                        localizedName: 'Nikotinfritt snus',
                        desciption: '',
                    },
                    Portionssnus: {
                        name: 'Portionssnus',
                        localizedName: 'Portionssnus',
                        desciption: '',
                    },
                },
            },
        },
    },
    Zoo: {
        name: 'Zoo',
        localizedName: 'Zoo',
        desciption: '',
        immutableFields: {
            alcoholPercentage: null,
            shelfLife: 'long',
            container: null,
            recycleType: null,
            volume: null,
            nutritionDeclaration: null,
            isEco: null,
            goesWith: null,
            appearance: null,
            scent: null,
            taste: null,
            grapes: null,
            seal: null,
            vintage: null,
            systembolagetArticleNumber: null,
            systembolagetSalesPrice: null,
            knNumber: null,
            exciseProductCode: null,
            alcoholTaxPaid: null,
            isVegan: null,
            isGelatinFree: null,
            isSugarFree: null,
            isLactoseFree: null,
            isPalmOilFree: null,
            isFrozen: null,
            isRefrigerated: null,
            isFoam: null,
            isCoated: null,
            isFudge: null,
            isGelatinous: null,
            isLiquorice: null,
            isHardCandy: null,
        },
        alcoholFreeBookKeepingAccounts: {
            DropShipping: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            StandAlone: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
        },
        alcoholTaxClasses: ['Alcoholfree'],
        children: {
            Hund: {
                name: 'Hund',
                localizedName: 'Hund',
                desciption: '',
                children: {
                    Torrfoder: {
                        name: 'Torrfoder',
                        localizedName: 'Torrfoder',
                        desciption: '',
                        children: {
                            Original: {
                                name: 'Original',
                                localizedName: 'Original',
                                desciption: '',
                            },
                            'Grain Free': {
                                name: 'Grain Free',
                                localizedName: 'Grain Free',
                                desciption: '',
                            },
                            'Daily Care': {
                                name: 'Daily Care',
                                localizedName: 'Daily Care',
                                desciption: '',
                            },
                            DNA: {
                                name: 'DNA',
                                localizedName: 'DNA',
                                desciption: '',
                            },
                            'Heritage Gran Free': {
                                name: 'Heritage Gran Free',
                                localizedName: 'Heritage Gran Free',
                                desciption: '',
                            },
                            'Regionals Grain Free': {
                                name: 'Regionals Grain Free',
                                localizedName: 'Regionals Grain Free',
                                desciption: '',
                            },
                            Singles: {
                                name: 'Singles',
                                localizedName: 'Singles',
                                desciption: '',
                            },
                            Classic: {
                                name: 'Classic',
                                localizedName: 'Classic',
                                desciption: '',
                            },
                        },
                    },
                    Våtfoder: {
                        name: 'Våtfoder',
                        localizedName: 'Våtfoder',
                        desciption: '',
                        children: {
                            Original: {
                                name: 'Original',
                                localizedName: 'Original',
                                desciption: '',
                            },
                        },
                    },
                    Godis: {
                        name: 'Godis',
                        localizedName: 'Godis',
                        desciption: '',
                    },
                    Tuggben: {
                        name: 'Tuggben',
                        localizedName: 'Tuggben',
                        desciption: '',
                    },
                    Tillbehör: {
                        name: 'Tillbehör',
                        localizedName: 'Tillbehör',
                        desciption: '',
                    },
                    Veterinär: {
                        name: 'Veterinär',
                        localizedName: 'Veterinär',
                        desciption: '',
                    },
                },
            },
            Katt: {
                name: 'Katt',
                localizedName: 'Katt',
                desciption: '',
                children: {
                    Torrfoder: {
                        name: 'Torrfoder',
                        localizedName: 'Torrfoder',
                        desciption: '',
                        children: {
                            Original: {
                                name: 'Original',
                                localizedName: 'Original',
                                desciption: '',
                            },
                            'Grain Free': {
                                name: 'Grain Free',
                                localizedName: 'Grain Free',
                                desciption: '',
                            },
                            'Regionals Grain Free': {
                                name: 'Regionals Grain Free',
                                localizedName: 'Regionals Grain Free',
                                desciption: '',
                            },
                            Bajpåsar: {
                                name: 'Bajpåsar',
                                localizedName: 'Bajpåsar',
                                desciption: '',
                            },
                            Trimprodukter: {
                                name: 'Trimprodukter',
                                localizedName: 'Trimprodukter',
                                desciption: '',
                            },
                        },
                    },
                    Våtfoder: {
                        name: 'Våtfoder',
                        localizedName: 'Våtfoder',
                        desciption: '',
                        children: {
                            Original: {
                                name: 'Original',
                                localizedName: 'Original',
                                desciption: '',
                            },
                        },
                    },
                    Godis: {
                        name: 'Godis',
                        localizedName: 'Godis',
                        desciption: '',
                    },
                    Sand: {
                        name: 'Sand',
                        localizedName: 'Sand',
                        desciption: '',
                    },
                    Tillbehör: {
                        name: 'Tillbehör',
                        localizedName: 'Tillbehör',
                        desciption: '',
                    },
                },
            },
        },
    },
    Pant: {
        name: 'Pant',
        localizedName: 'Pant',
        desciption: '',
        immutableFields: {
            alcoholPercentage: null,
            shelfLife: null,
            container: null,
            recycleType: null,
            volume: null,
            weight: null,
            ingredientsDeclaration: null,
            nutritionDeclaration: null,
            isEco: null,
            goesWith: null,
            appearance: null,
            scent: null,
            taste: null,
            grapes: null,
            seal: null,
            vintage: null,
            systembolagetArticleNumber: null,
            systembolagetSalesPrice: null,
            knNumber: null,
            exciseProductCode: null,
            alcoholTaxPaid: null,
            isVegan: null,
            isGelatinFree: null,
            isSugarFree: null,
            isLactoseFree: null,
            isPalmOilFree: null,
            isFrozen: null,
            isRefrigerated: null,
            isFoam: null,
            isCoated: null,
            isFudge: null,
            isGelatinous: null,
            isLiquorice: null,
            isHardCandy: null,
        },
        alcoholFreeBookKeepingAccounts: {
            DropShipping: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            StandAlone: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
        },
        alcoholTaxClasses: ['Alcoholfree'],
    },
    Tjänst: {
        name: 'Tjänst',
        localizedName: 'Tjänst',
        desciption: '',
        immutableFields: {
            alcoholPercentage: null,
            shelfLife: null,
            container: null,
            recycleType: null,
            volume: null,
            weight: null,
            ingredientsDeclaration: null,
            nutritionDeclaration: null,
            isEco: null,
            goesWith: null,
            appearance: null,
            scent: null,
            taste: null,
            grapes: null,
            seal: null,
            vintage: null,
            systembolagetArticleNumber: null,
            systembolagetSalesPrice: null,
            knNumber: null,
            exciseProductCode: null,
            alcoholTaxPaid: null,
            isVegan: null,
            isGelatinFree: null,
            isSugarFree: null,
            isLactoseFree: null,
            isPalmOilFree: null,
            isFrozen: null,
            isRefrigerated: null,
            isFoam: null,
            isCoated: null,
            isFudge: null,
            isGelatinous: null,
            isLiquorice: null,
            isHardCandy: null,
        },
        alcoholFreeBookKeepingAccounts: {
            DropShipping: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
            StandAlone: {
                purchaseAccount: 4000,
                salesAccount: 3000,
            },
        },
        alcoholTaxClasses: ['Alcoholfree'],
    },
};
